var Jn, q, ns, ce, sr, is, os, Ci, Nn, nn, rs, Ki, Di, Fi, Hn = {}, Un = [], el = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, rn = Array.isArray;
function ee(o, i) {
  for (var s in i) o[s] = i[s];
  return o;
}
function Yi(o) {
  o && o.parentNode && o.parentNode.removeChild(o);
}
function Wn(o, i, s) {
  var l, u, c, d = {};
  for (c in i) c == "key" ? l = i[c] : c == "ref" ? u = i[c] : d[c] = i[c];
  if (arguments.length > 2 && (d.children = arguments.length > 3 ? Jn.call(arguments, 2) : s), typeof o == "function" && o.defaultProps != null) for (c in o.defaultProps) d[c] === void 0 && (d[c] = o.defaultProps[c]);
  return Dn(o, d, l, u, null);
}
function Dn(o, i, s, l, u) {
  var c = { type: o, props: i, key: s, ref: l, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: u ?? ++ns, __i: -1, __u: 0 };
  return u == null && q.vnode != null && q.vnode(c), c;
}
function Vt(o) {
  return o.children;
}
function ne(o, i) {
  this.props = o, this.context = i;
}
function ze(o, i) {
  if (i == null) return o.__ ? ze(o.__, o.__i + 1) : null;
  for (var s; i < o.__k.length; i++) if ((s = o.__k[i]) != null && s.__e != null) return s.__e;
  return typeof o.type == "function" ? ze(o) : null;
}
function nl(o) {
  if (o.__P && o.__d) {
    var i = o.__v, s = i.__e, l = [], u = [], c = ee({}, i);
    c.__v = i.__v + 1, q.vnode && q.vnode(c), Ji(o.__P, c, i, o.__n, o.__P.namespaceURI, 32 & i.__u ? [s] : null, l, s ?? ze(i), !!(32 & i.__u), u), c.__v = i.__v, c.__.__k[c.__i] = c, us(l, c, u), i.__e = i.__ = null, c.__e != s && ss(c);
  }
}
function ss(o) {
  if ((o = o.__) != null && o.__c != null) return o.__e = o.__c.base = null, o.__k.some(function(i) {
    if (i != null && i.__e != null) return o.__e = o.__c.base = i.__e;
  }), ss(o);
}
function ar(o) {
  (!o.__d && (o.__d = !0) && ce.push(o) && !qn.__r++ || sr != q.debounceRendering) && ((sr = q.debounceRendering) || is)(qn);
}
function qn() {
  try {
    for (var o, i = 1; ce.length; ) ce.length > i && ce.sort(os), o = ce.shift(), i = ce.length, nl(o);
  } finally {
    ce.length = qn.__r = 0;
  }
}
function as(o, i, s, l, u, c, d, _, f, g, P) {
  var m, x, T, E, k, b, M, C = l && l.__k || Un, O = i.length;
  for (f = il(s, i, C, f, O), m = 0; m < O; m++) (T = s.__k[m]) != null && (x = T.__i != -1 && C[T.__i] || Hn, T.__i = m, b = Ji(o, T, x, u, c, d, _, f, g, P), E = T.__e, T.ref && x.ref != T.ref && (x.ref && Xi(x.ref, null, T), P.push(T.ref, T.__c || E, T)), k == null && E != null && (k = E), (M = !!(4 & T.__u)) || x.__k === T.__k ? (f = ls(T, f, o, M), M && x.__e && (x.__e = null)) : typeof T.type == "function" && b !== void 0 ? f = b : E && (f = E.nextSibling), T.__u &= -7);
  return s.__e = k, f;
}
function il(o, i, s, l, u) {
  var c, d, _, f, g, P = s.length, m = P, x = 0;
  for (o.__k = new Array(u), c = 0; c < u; c++) (d = i[c]) != null && typeof d != "boolean" && typeof d != "function" ? (typeof d == "string" || typeof d == "number" || typeof d == "bigint" || d.constructor == String ? d = o.__k[c] = Dn(null, d, null, null, null) : rn(d) ? d = o.__k[c] = Dn(Vt, { children: d }, null, null, null) : d.constructor === void 0 && d.__b > 0 ? d = o.__k[c] = Dn(d.type, d.props, d.key, d.ref ? d.ref : null, d.__v) : o.__k[c] = d, f = c + x, d.__ = o, d.__b = o.__b + 1, _ = null, (g = d.__i = ol(d, s, f, m)) != -1 && (m--, (_ = s[g]) && (_.__u |= 2)), _ == null || _.__v == null ? (g == -1 && (u > P ? x-- : u < P && x++), typeof d.type != "function" && (d.__u |= 4)) : g != f && (g == f - 1 ? x-- : g == f + 1 ? x++ : (g > f ? x-- : x++, d.__u |= 4))) : o.__k[c] = null;
  if (m) for (c = 0; c < P; c++) (_ = s[c]) != null && (2 & _.__u) == 0 && (_.__e == l && (l = ze(_)), hs(_, _));
  return l;
}
function ls(o, i, s, l) {
  var u, c;
  if (typeof o.type == "function") {
    for (u = o.__k, c = 0; u && c < u.length; c++) u[c] && (u[c].__ = o, i = ls(u[c], i, s, l));
    return i;
  }
  o.__e != i && (l && (i && o.type && !i.parentNode && (i = ze(o)), s.insertBefore(o.__e, i || null)), i = o.__e);
  do
    i = i && i.nextSibling;
  while (i != null && i.nodeType == 8);
  return i;
}
function jn(o, i) {
  return i = i || [], o == null || typeof o == "boolean" || (rn(o) ? o.some(function(s) {
    jn(s, i);
  }) : i.push(o)), i;
}
function ol(o, i, s, l) {
  var u, c, d, _ = o.key, f = o.type, g = i[s], P = g != null && (2 & g.__u) == 0;
  if (g === null && _ == null || P && _ == g.key && f == g.type) return s;
  if (l > (P ? 1 : 0)) {
    for (u = s - 1, c = s + 1; u >= 0 || c < i.length; ) if ((g = i[d = u >= 0 ? u-- : c++]) != null && (2 & g.__u) == 0 && _ == g.key && f == g.type) return d;
  }
  return -1;
}
function lr(o, i, s) {
  i[0] == "-" ? o.setProperty(i, s ?? "") : o[i] = s == null ? "" : typeof s != "number" || el.test(i) ? s : s + "px";
}
function Sn(o, i, s, l, u) {
  var c, d;
  t: if (i == "style") if (typeof s == "string") o.style.cssText = s;
  else {
    if (typeof l == "string" && (o.style.cssText = l = ""), l) for (i in l) s && i in s || lr(o.style, i, "");
    if (s) for (i in s) l && s[i] == l[i] || lr(o.style, i, s[i]);
  }
  else if (i[0] == "o" && i[1] == "n") c = i != (i = i.replace(rs, "$1")), d = i.toLowerCase(), i = d in o || i == "onFocusOut" || i == "onFocusIn" ? d.slice(2) : i.slice(2), o.l || (o.l = {}), o.l[i + c] = s, s ? l ? s[nn] = l[nn] : (s[nn] = Ki, o.addEventListener(i, c ? Fi : Di, c)) : o.removeEventListener(i, c ? Fi : Di, c);
  else {
    if (u == "http://www.w3.org/2000/svg") i = i.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (i != "width" && i != "height" && i != "href" && i != "list" && i != "form" && i != "tabIndex" && i != "download" && i != "rowSpan" && i != "colSpan" && i != "role" && i != "popover" && i in o) try {
      o[i] = s ?? "";
      break t;
    } catch {
    }
    typeof s == "function" || (s == null || s === !1 && i[4] != "-" ? o.removeAttribute(i) : o.setAttribute(i, i == "popover" && s == 1 ? "" : s));
  }
}
function ur(o) {
  return function(i) {
    if (this.l) {
      var s = this.l[i.type + o];
      if (i[Nn] == null) i[Nn] = Ki++;
      else if (i[Nn] < s[nn]) return;
      return s(q.event ? q.event(i) : i);
    }
  };
}
function Ji(o, i, s, l, u, c, d, _, f, g) {
  var P, m, x, T, E, k, b, M, C, O, V, j, rt, et, pt, dt = i.type;
  if (i.constructor !== void 0) return null;
  128 & s.__u && (f = !!(32 & s.__u), c = [_ = i.__e = s.__e]), (P = q.__b) && P(i);
  t: if (typeof dt == "function") try {
    if (M = i.props, C = dt.prototype && dt.prototype.render, O = (P = dt.contextType) && l[P.__c], V = P ? O ? O.props.value : P.__ : l, s.__c ? b = (m = i.__c = s.__c).__ = m.__E : (C ? i.__c = m = new dt(M, V) : (i.__c = m = new ne(M, V), m.constructor = dt, m.render = sl), O && O.sub(m), m.state || (m.state = {}), m.__n = l, x = m.__d = !0, m.__h = [], m._sb = []), C && m.__s == null && (m.__s = m.state), C && dt.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = ee({}, m.__s)), ee(m.__s, dt.getDerivedStateFromProps(M, m.__s))), T = m.props, E = m.state, m.__v = i, x) C && dt.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), C && m.componentDidMount != null && m.__h.push(m.componentDidMount);
    else {
      if (C && dt.getDerivedStateFromProps == null && M !== T && m.componentWillReceiveProps != null && m.componentWillReceiveProps(M, V), i.__v == s.__v || !m.__e && m.shouldComponentUpdate != null && m.shouldComponentUpdate(M, m.__s, V) === !1) {
        i.__v != s.__v && (m.props = M, m.state = m.__s, m.__d = !1), i.__e = s.__e, i.__k = s.__k, i.__k.some(function(mt) {
          mt && (mt.__ = i);
        }), Un.push.apply(m.__h, m._sb), m._sb = [], m.__h.length && d.push(m);
        break t;
      }
      m.componentWillUpdate != null && m.componentWillUpdate(M, m.__s, V), C && m.componentDidUpdate != null && m.__h.push(function() {
        m.componentDidUpdate(T, E, k);
      });
    }
    if (m.context = V, m.props = M, m.__P = o, m.__e = !1, j = q.__r, rt = 0, C) m.state = m.__s, m.__d = !1, j && j(i), P = m.render(m.props, m.state, m.context), Un.push.apply(m.__h, m._sb), m._sb = [];
    else do
      m.__d = !1, j && j(i), P = m.render(m.props, m.state, m.context), m.state = m.__s;
    while (m.__d && ++rt < 25);
    m.state = m.__s, m.getChildContext != null && (l = ee(ee({}, l), m.getChildContext())), C && !x && m.getSnapshotBeforeUpdate != null && (k = m.getSnapshotBeforeUpdate(T, E)), et = P != null && P.type === Vt && P.key == null ? cs(P.props.children) : P, _ = as(o, rn(et) ? et : [et], i, s, l, u, c, d, _, f, g), m.base = i.__e, i.__u &= -161, m.__h.length && d.push(m), b && (m.__E = m.__ = null);
  } catch (mt) {
    if (i.__v = null, f || c != null) if (mt.then) {
      for (i.__u |= f ? 160 : 128; _ && _.nodeType == 8 && _.nextSibling; ) _ = _.nextSibling;
      c[c.indexOf(_)] = null, i.__e = _;
    } else {
      for (pt = c.length; pt--; ) Yi(c[pt]);
      Hi(i);
    }
    else i.__e = s.__e, i.__k = s.__k, mt.then || Hi(i);
    q.__e(mt, i, s);
  }
  else c == null && i.__v == s.__v ? (i.__k = s.__k, i.__e = s.__e) : _ = i.__e = rl(s.__e, i, s, l, u, c, d, f, g);
  return (P = q.diffed) && P(i), 128 & i.__u ? void 0 : _;
}
function Hi(o) {
  o && (o.__c && (o.__c.__e = !0), o.__k && o.__k.some(Hi));
}
function us(o, i, s) {
  for (var l = 0; l < s.length; l++) Xi(s[l], s[++l], s[++l]);
  q.__c && q.__c(i, o), o.some(function(u) {
    try {
      o = u.__h, u.__h = [], o.some(function(c) {
        c.call(u);
      });
    } catch (c) {
      q.__e(c, u.__v);
    }
  });
}
function cs(o) {
  return typeof o != "object" || o == null || o.__b > 0 ? o : rn(o) ? o.map(cs) : o.constructor !== void 0 ? null : ee({}, o);
}
function rl(o, i, s, l, u, c, d, _, f) {
  var g, P, m, x, T, E, k, b = s.props || Hn, M = i.props, C = i.type;
  if (C == "svg" ? u = "http://www.w3.org/2000/svg" : C == "math" ? u = "http://www.w3.org/1998/Math/MathML" : u || (u = "http://www.w3.org/1999/xhtml"), c != null) {
    for (g = 0; g < c.length; g++) if ((T = c[g]) && "setAttribute" in T == !!C && (C ? T.localName == C : T.nodeType == 3)) {
      o = T, c[g] = null;
      break;
    }
  }
  if (o == null) {
    if (C == null) return document.createTextNode(M);
    o = document.createElementNS(u, C, M.is && M), _ && (q.__m && q.__m(i, c), _ = !1), c = null;
  }
  if (C == null) b === M || _ && o.data == M || (o.data = M);
  else {
    if (c = C == "textarea" && M.defaultValue != null ? null : c && Jn.call(o.childNodes), !_ && c != null) for (b = {}, g = 0; g < o.attributes.length; g++) b[(T = o.attributes[g]).name] = T.value;
    for (g in b) T = b[g], g == "dangerouslySetInnerHTML" ? m = T : g == "children" || g in M || g == "value" && "defaultValue" in M || g == "checked" && "defaultChecked" in M || Sn(o, g, null, T, u);
    for (g in M) T = M[g], g == "children" ? x = T : g == "dangerouslySetInnerHTML" ? P = T : g == "value" ? E = T : g == "checked" ? k = T : _ && typeof T != "function" || b[g] === T || Sn(o, g, T, b[g], u);
    if (P) _ || m && (P.__html == m.__html || P.__html == o.innerHTML) || (o.innerHTML = P.__html), i.__k = [];
    else if (m && (o.innerHTML = ""), as(i.type == "template" ? o.content : o, rn(x) ? x : [x], i, s, l, C == "foreignObject" ? "http://www.w3.org/1999/xhtml" : u, c, d, c ? c[0] : s.__k && ze(s, 0), _, f), c != null) for (g = c.length; g--; ) Yi(c[g]);
    _ && C != "textarea" || (g = "value", C == "progress" && E == null ? o.removeAttribute("value") : E != null && (E !== o[g] || C == "progress" && !E || C == "option" && E != b[g]) && Sn(o, g, E, b[g], u), g = "checked", k != null && k != o[g] && Sn(o, g, k, b[g], u));
  }
  return o;
}
function Xi(o, i, s) {
  try {
    if (typeof o == "function") {
      var l = typeof o.__u == "function";
      l && o.__u(), l && i == null || (o.__u = o(i));
    } else o.current = i;
  } catch (u) {
    q.__e(u, s);
  }
}
function hs(o, i, s) {
  var l, u;
  if (q.unmount && q.unmount(o), (l = o.ref) && (l.current && l.current != o.__e || Xi(l, null, i)), (l = o.__c) != null) {
    if (l.componentWillUnmount) try {
      l.componentWillUnmount();
    } catch (c) {
      q.__e(c, i);
    }
    l.base = l.__P = null;
  }
  if (l = o.__k) for (u = 0; u < l.length; u++) l[u] && hs(l[u], i, s || typeof o.type != "function");
  s || Yi(o.__e), o.__c = o.__ = o.__e = void 0;
}
function sl(o, i, s) {
  return this.constructor(o, s);
}
function ds(o, i, s) {
  var l, u, c, d;
  i == document && (i = document.documentElement), q.__ && q.__(o, i), u = (l = !1) ? null : i.__k, c = [], d = [], Ji(i, o = i.__k = Wn(Vt, null, [o]), u || Hn, Hn, i.namespaceURI, u ? null : i.firstChild ? Jn.call(i.childNodes) : null, c, u ? u.__e : i.firstChild, l, d), us(c, o, d);
}
Jn = Un.slice, q = { __e: function(o, i, s, l) {
  for (var u, c, d; i = i.__; ) if ((u = i.__c) && !u.__) try {
    if ((c = u.constructor) && c.getDerivedStateFromError != null && (u.setState(c.getDerivedStateFromError(o)), d = u.__d), u.componentDidCatch != null && (u.componentDidCatch(o, l || {}), d = u.__d), d) return u.__E = u;
  } catch (_) {
    o = _;
  }
  throw o;
} }, ns = 0, ne.prototype.setState = function(o, i) {
  var s;
  s = this.__s != null && this.__s != this.state ? this.__s : this.__s = ee({}, this.state), typeof o == "function" && (o = o(ee({}, s), this.props)), o && ee(s, o), o != null && this.__v && (i && this._sb.push(i), ar(this));
}, ne.prototype.forceUpdate = function(o) {
  this.__v && (this.__e = !0, o && this.__h.push(o), ar(this));
}, ne.prototype.render = Vt, ce = [], is = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, os = function(o, i) {
  return o.__v.__b - i.__v.__b;
}, qn.__r = 0, Ci = Math.random().toString(8), Nn = "__d" + Ci, nn = "__a" + Ci, rs = /(PointerCapture)$|Capture$/i, Ki = 0, Di = ur(!1), Fi = ur(!0);
var al = 0;
function y(o, i, s, l, u, c) {
  i || (i = {});
  var d, _, f = i;
  if ("ref" in f) for (_ in f = {}, i) _ == "ref" ? d = i[_] : f[_] = i[_];
  var g = { type: o, props: f, key: s, ref: d, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --al, __i: -1, __u: 0, __source: u, __self: c };
  if (typeof o == "function" && (d = o.defaultProps)) for (_ in d) f[_] === void 0 && (f[_] = d[_]);
  return q.vnode && q.vnode(g), g;
}
const fs = [
  "performance_tuning",
  "electrical_wiring",
  "engine_building_reconditioning",
  "installation_mechanical_upgrades",
  "parts_retail_sales",
  "panel_paint",
  "vehicle_conversions",
  "training_consultation",
  "fabrication_welding",
  "trackside_race_support",
  "warrant_fitness_certification",
  "pdm_power_control",
  "data_setup_analysis",
  "sensors_accessories",
  "direct_injection"
], Qi = {
  performance_tuning: "Performance Tuning",
  electrical_wiring: "Electrical & Wiring",
  engine_building_reconditioning: "Engine Building and Reconditioning",
  installation_mechanical_upgrades: "Installation & Mechanical Upgrades",
  parts_retail_sales: "Parts Retail & Sales",
  panel_paint: "Panel & Paint",
  vehicle_conversions: "Vehicle Conversions",
  training_consultation: "Training & Consultation",
  fabrication_welding: "Fabrication & Welding",
  trackside_race_support: "Trackside or Race Support",
  warrant_fitness_certification: "Warrant of Fitness / Certification",
  pdm_power_control: "PDM / Power Control",
  data_setup_analysis: "Data Setup and Analysis",
  sensors_accessories: "Sensors and Accessories",
  direct_injection: "Direct Injection (DI)"
}, _s = [
  "road_street",
  "drift",
  "track_day",
  "circuit_endurance",
  "drag",
  "dirt_track",
  "rally",
  "off_road",
  "hill_climb",
  "boat_watercraft",
  "snow_vehicle",
  "motorcycle",
  "airplane",
  "other"
], to = {
  road_street: "Road / Street",
  drift: "Drift",
  track_day: "Track Days",
  circuit_endurance: "Circuit / Endurance",
  drag: "Drag",
  dirt_track: "Dirt Track",
  rally: "Rally",
  off_road: "Off-Road",
  hill_climb: "Hill Climb",
  boat_watercraft: "Boat / Watercraft",
  snow_vehicle: "Snow Vehicle",
  motorcycle: "Motorcycle",
  airplane: "Airplane",
  other: "Other"
}, ps = new Set(fs), ms = new Set(_s);
function Gn(o) {
  if (typeof o == "number") return Number.isFinite(o) ? o : null;
  if (typeof o == "string" && o.trim() !== "") {
    const i = Number(o.trim());
    return Number.isFinite(i) ? i : null;
  }
  return null;
}
const ct = (o) => typeof o == "string" && o.trim() !== "" ? o : null, cr = (o) => o === !0 || o === "T" || o === "true";
function Vn(o, i) {
  return Array.isArray(o) ? o.filter((s) => typeof s == "string" && i.has(s)) : [];
}
function ll(o) {
  if (!o || typeof o != "object" || typeof o.id != "string" || typeof o.business_name != "string") return null;
  const i = o.address ?? {}, s = o.social ?? {};
  return {
    id: o.id,
    businessName: o.business_name,
    resellerLevel: ct(o.reseller_level),
    premiumDealer: cr(o.premium_dealer),
    contactPerson: ct(o.contact_person),
    phone: ct(o.phone),
    email: ct(o.email),
    websiteUrl: ct(o.website_url),
    description: ct(o.description),
    languagesSpoken: ct(o.languages_spoken),
    ownsDyno: cr(o.owns_dyno),
    address: {
      street1: ct(i.street_1) ?? "",
      street2: ct(i.street_2) ?? "",
      street3: ct(i.street_3) ?? "",
      suburbCity: ct(i.suburb_city) ?? "",
      stateRegion: ct(i.state_region) ?? "",
      postcode: ct(i.postcode) ?? "",
      country: ct(i.country) ?? ""
    },
    latitude: Gn(o.latitude),
    longitude: Gn(o.longitude),
    services: Vn(o.services, ps),
    vehicleTypes: Vn(o.vehicle_types, ms),
    social: {
      googleId: ct(s.google_id),
      facebook: ct(s.facebook),
      instagram: ct(s.instagram),
      youtube: ct(s.youtube)
    }
  };
}
function ul(o) {
  if (!o) return null;
  try {
    return ll(JSON.parse(o));
  } catch {
    return null;
  }
}
function cl(o) {
  return !o || typeof o != "object" || typeof o.id != "string" || typeof o.name != "string" ? null : {
    id: o.id,
    name: o.name,
    latitude: Gn(o.lat),
    longitude: Gn(o.lng),
    suburbCity: ct(o.suburb_city) ?? "",
    stateRegion: ct(o.state_region) ?? "",
    country: ct(o.country) ?? "",
    postcode: ct(o.postcode) ?? "",
    services: Vn(o.services, ps),
    vehicleTypes: Vn(o.vehicle_types, ms)
  };
}
function hl(o) {
  if (!o) return { entries: [], rawCount: 0 };
  let i;
  try {
    i = JSON.parse(o);
  } catch {
    return { entries: [], rawCount: 0 };
  }
  const s = Array.isArray(i) ? i : i && typeof i == "object" && Array.isArray(i.installers) ? i.installers : [];
  return {
    entries: s.map((l) => cl(l)).filter((l) => l !== null),
    rawCount: s.length
  };
}
const gs = "installer";
function dl(o) {
  return `installer-${o.trim().toLowerCase()}`;
}
const fl = (
  /* GraphQL */
  `
  query Installer($handle: MetaobjectHandleInput!) {
    metaobject(handle: $handle) {
      fields {
        key
        value
      }
    }
  }
`
);
function _l(o, i = gs) {
  return { handle: { type: i, handle: dl(o) } };
}
const pl = "data";
function ml(o) {
  const i = o.metaobject?.fields ?? [], s = i.find((l) => l.key === pl && l.value != null);
  return s?.value != null ? s.value : i.find((l) => l.value != null && /^\s*[[{]/.test(l.value))?.value ?? null;
}
const vs = "installer_index", hr = 1, gl = 10;
function vl(o = vs) {
  return (
    /* GraphQL */
    `
  query InstallerIndex {
    metaobjects(type: "${o}", first: ${gl}) {
      nodes {
        shard: field(key: "shard") { value }
        shardCount: field(key: "shard_count") { value }
        totalCount: field(key: "total_count") { value }
        generatedAt: field(key: "generated_at") { value }
        version: field(key: "version") { value }
        data: field(key: "data") { value }
      }
    }
  }
`
  );
}
const In = (o) => {
  if (typeof o != "string" || o.trim() === "") return null;
  const i = Number(o.trim());
  return Number.isInteger(i) ? i : null;
};
function yl(o) {
  const i = In(o.shard?.value), s = In(o.shardCount?.value), l = In(o.totalCount?.value), u = In(o.version?.value), c = o.generatedAt?.value, d = o.data?.value;
  return i === null || s === null || l === null || u === null || typeof c != "string" || c === "" || typeof d != "string" ? null : { shard: i, shardCount: s, totalCount: l, generatedAt: c, version: u, data: d };
}
function wl(o) {
  const i = o?.metaobjects?.nodes ?? [];
  if (i.length === 0)
    return { ok: !1, reason: "no-shards", detail: "the index query returned no shards" };
  const s = i.map(yl), l = s.filter((k) => k === null).length, u = s.filter((k) => k !== null);
  if (u.length === 0)
    return { ok: !1, reason: "malformed-shard", detail: "every shard is missing required fields" };
  const c = u.filter((k) => k.version === hr), d = u.length - c.length;
  if (c.length === 0)
    return {
      ok: !1,
      reason: "unsupported-version",
      detail: `no shard matches index version ${hr} (got ${[...new Set(u.map((k) => k.version))].join("/")})`
    };
  const _ = [], f = [];
  l > 0 && (_.push("malformed-shards-skipped"), f.push(`${l} malformed shard(s) skipped`)), d > 0 && (_.push("unsupported-shards-skipped"), f.push(`${d} shard(s) on an unsupported version skipped`));
  const [g] = [...c].sort((k, b) => k.shard - b.shard);
  c.some(
    (k) => k.generatedAt !== g.generatedAt || k.shardCount !== g.shardCount || k.totalCount !== g.totalCount
  ) && (_.push("inconsistent-generation"), f.push("shards disagree on generated_at/shard_count/total_count (sync may be mid-write)"));
  const P = new Set(c.map((k) => k.shard));
  P.size === c.length && c.length === g.shardCount && c.every((k) => k.shard >= 1 && k.shard <= g.shardCount) || (_.push("incomplete-shards"), f.push(`expected shards 1…${g.shardCount}, got [${[...P].sort((k, b) => k - b).join(",")}]`));
  const x = /* @__PURE__ */ new Set(), T = [];
  let E = 0;
  for (const k of [...c].sort((b, M) => b.shard - M.shard)) {
    const b = hl(k.data);
    E += b.rawCount;
    for (const M of b.entries)
      x.has(M.id) || (x.add(M.id), T.push(M));
  }
  return E !== g.totalCount && (_.push("count-mismatch"), f.push(`carried ${E} entries, total_count says ${g.totalCount}`)), {
    ok: !0,
    entries: T,
    generatedAt: g.generatedAt,
    totalCount: g.totalCount,
    shardCount: g.shardCount,
    droppedEntries: E - T.length,
    warnings: _,
    detail: f.join("; ")
  };
}
function eo(o) {
  return o.normalize("NFKD").replace(/[̀-ͯ]/g, "").toLowerCase().replace(/\(.*?\)/g, "").replace(/&/g, "and").replace(/\b(the|of|republic|sar|province|china)\b/g, "").replace(/[^a-z]/g, "");
}
function dr(o) {
  try {
    const s = new Intl.DisplayNames(["en"], { type: "region" }).of(o.toUpperCase());
    return s && s.toUpperCase() !== o.toUpperCase() ? s : void 0;
  } catch {
    return;
  }
}
function fr(o, i) {
  const s = /* @__PURE__ */ new Set(), l = (u) => {
    const c = u ? eo(u) : "";
    c && s.add(c);
  };
  if (l(o), i) {
    l(dr(i));
    const u = dr(i);
    if (u) {
      const c = u.split(/\s+/);
      c.length > 1 && l(c[c.length - 1]);
    }
  }
  return [...s];
}
function bl(o, i) {
  if (i.length === 0 || o.length === 0) return o;
  const s = new Set(i), l = [], u = [];
  for (const c of o)
    (s.has(eo(c.country)) ? l : u).push(c);
  return l.length === 0 ? o : [...l, ...u];
}
const xl = 6371, On = (o) => o * Math.PI / 180;
function Pl(o, i) {
  const s = On(i.latitude - o.latitude), l = On(i.longitude - o.longitude), u = On(o.latitude), c = On(i.latitude), d = Math.sin(s / 2) ** 2 + Math.sin(l / 2) ** 2 * Math.cos(u) * Math.cos(c);
  return 2 * xl * Math.asin(Math.min(1, Math.sqrt(d)));
}
function Ll(o, i) {
  return i ? o.map((s) => ({
    ...s,
    distance: s.latitude != null && s.longitude != null ? Pl(i, { latitude: s.latitude, longitude: s.longitude }) : null
  })).sort((s, l) => (s.distance ?? 1 / 0) - (l.distance ?? 1 / 0)) : o.map((s) => ({ ...s, distance: null }));
}
function _r(o, i, s, l) {
  const u = /* @__PURE__ */ new Map();
  for (const c of o)
    for (const d of i(c))
      u.set(d, (u.get(d) ?? 0) + 1);
  return s.filter((c) => (u.get(c) ?? 0) > 0).map((c) => ({ key: c, label: l[c], count: u.get(c) }));
}
function Tl(o) {
  return {
    services: _r(o, (i) => i.services, fs, Qi),
    vehicleTypes: _r(o, (i) => i.vehicleTypes, _s, to)
  };
}
const kl = (o, i) => o.west <= o.east ? i >= o.west && i <= o.east : i >= o.west || i <= o.east, ys = (o, i) => i.latitude != null && i.longitude != null && i.latitude >= o.south && i.latitude <= o.north && kl(o, i.longitude), Ml = (o) => `${o.name} ${o.suburbCity} ${o.stateRegion} ${o.postcode} ${o.country}`.toLowerCase();
function Al(o, {
  referencePoint: i = null,
  query: s = "",
  services: l = [],
  vehicleTypes: u = [],
  radiusKm: c = null,
  bounds: d = null,
  country: _ = null
} = {}) {
  const f = o.filter(
    (E) => (l.length === 0 || l.some((k) => E.services.includes(k))) && (u.length === 0 || u.some((k) => E.vehicleTypes.includes(k)))
  ), g = Ll(f, i), P = (E) => c != null && E.distance != null && E.distance <= c, m = _ ? g.filter((E) => E.country.toLowerCase() === _.toLowerCase()) : d ? (
    // Bounds OR radius, not bounds alone. A city's box is the right shape,
    // but a street address's box is metres wide — filtering to it would
    // return no dealers at all for the most common search of the lot.
    g.filter((E) => ys(d, E) || P(E))
  ) : i && c != null ? g.filter(P) : g, x = s.trim().toLowerCase();
  if (!x) return { results: m, textMatched: !0 };
  const T = g.filter((E) => Ml(E).includes(x));
  return T.length > 0 ? { results: T, textMatched: !0 } : { results: m, textMatched: !1 };
}
function Cl(o) {
  return o == null ? "" : o < 1 ? `${Math.round(o * 1e3)} m` : `${o.toFixed(1)} km`;
}
function no(o) {
  return [
    o.street1,
    o.street2,
    o.street3,
    o.suburbCity,
    o.stateRegion,
    o.postcode,
    o.country
  ].map((i) => i.trim()).filter(Boolean).join(", ");
}
function ws(o) {
  if (!o) return null;
  const i = o.replace(/[^\d+]/g, "");
  return i ? `tel:${i}` : null;
}
function bs(o) {
  return /^https?:\/\//i.test(o.trim());
}
function xs(o) {
  const i = "https://www.google.com/maps/dir/?api=1&destination=";
  return o.latitude != null && o.longitude != null ? `${i}${o.latitude},${o.longitude}` : `${i}${encodeURIComponent(no(o.address))}`;
}
var Ze, ht, Ei, pr, on = 0, Ps = [], wt = q, mr = wt.__b, gr = wt.__r, vr = wt.diffed, yr = wt.__c, wr = wt.unmount, br = wt.__;
function Xn(o, i) {
  wt.__h && wt.__h(ht, o, on || i), on = 0;
  var s = ht.__H || (ht.__H = { __: [], __h: [] });
  return o >= s.__.length && s.__.push({}), s.__[o];
}
function _t(o) {
  return on = 1, El(Ts, o);
}
function El(o, i, s) {
  var l = Xn(Ze++, 2);
  if (l.t = o, !l.__c && (l.__ = [s ? s(i) : Ts(void 0, i), function(_) {
    var f = l.__N ? l.__N[0] : l.__[0], g = l.t(f, _);
    f !== g && (l.__N = [g, l.__[1]], l.__c.setState({}));
  }], l.__c = ht, !ht.__f)) {
    var u = function(_, f, g) {
      if (!l.__c.__H) return !0;
      var P = l.__c.__H.__.filter(function(x) {
        return x.__c;
      });
      if (P.every(function(x) {
        return !x.__N;
      })) return !c || c.call(this, _, f, g);
      var m = l.__c.props !== _;
      return P.some(function(x) {
        if (x.__N) {
          var T = x.__[0];
          x.__ = x.__N, x.__N = void 0, T !== x.__[0] && (m = !0);
        }
      }), c && c.call(this, _, f, g) || m;
    };
    ht.__f = !0;
    var c = ht.shouldComponentUpdate, d = ht.componentWillUpdate;
    ht.componentWillUpdate = function(_, f, g) {
      if (this.__e) {
        var P = c;
        c = void 0, u(_, f, g), c = P;
      }
      d && d.call(this, _, f, g);
    }, ht.shouldComponentUpdate = u;
  }
  return l.__N || l.__;
}
function xt(o, i) {
  var s = Xn(Ze++, 3);
  !wt.__s && Ls(s.__H, i) && (s.__ = o, s.u = i, ht.__H.__h.push(s));
}
function J(o) {
  return on = 5, te(function() {
    return { current: o };
  }, []);
}
function te(o, i) {
  var s = Xn(Ze++, 7);
  return Ls(s.__H, i) && (s.__ = o(), s.__H = i, s.__h = o), s.__;
}
function Ct(o, i) {
  return on = 8, te(function() {
    return o;
  }, i);
}
function Sl() {
  var o = Xn(Ze++, 11);
  if (!o.__) {
    for (var i = ht.__v; i !== null && !i.__m && i.__ !== null; ) i = i.__;
    var s = i.__m || (i.__m = [0, 0]);
    o.__ = "P" + s[0] + "-" + s[1]++;
  }
  return o.__;
}
function Il() {
  for (var o; o = Ps.shift(); ) {
    var i = o.__H;
    if (o.__P && i) try {
      i.__h.some(Fn), i.__h.some(Ui), i.__h = [];
    } catch (s) {
      i.__h = [], wt.__e(s, o.__v);
    }
  }
}
wt.__b = function(o) {
  ht = null, mr && mr(o);
}, wt.__ = function(o, i) {
  o && i.__k && i.__k.__m && (o.__m = i.__k.__m), br && br(o, i);
}, wt.__r = function(o) {
  gr && gr(o), Ze = 0;
  var i = (ht = o.__c).__H;
  i && (Ei === ht ? (i.__h = [], ht.__h = [], i.__.some(function(s) {
    s.__N && (s.__ = s.__N), s.u = s.__N = void 0;
  })) : (i.__h.some(Fn), i.__h.some(Ui), i.__h = [], Ze = 0)), Ei = ht;
}, wt.diffed = function(o) {
  vr && vr(o);
  var i = o.__c;
  i && i.__H && (i.__H.__h.length && (Ps.push(i) !== 1 && pr === wt.requestAnimationFrame || ((pr = wt.requestAnimationFrame) || Ol)(Il)), i.__H.__.some(function(s) {
    s.u && (s.__H = s.u), s.u = void 0;
  })), Ei = ht = null;
}, wt.__c = function(o, i) {
  i.some(function(s) {
    try {
      s.__h.some(Fn), s.__h = s.__h.filter(function(l) {
        return !l.__ || Ui(l);
      });
    } catch (l) {
      i.some(function(u) {
        u.__h && (u.__h = []);
      }), i = [], wt.__e(l, s.__v);
    }
  }), yr && yr(o, i);
}, wt.unmount = function(o) {
  wr && wr(o);
  var i, s = o.__c;
  s && s.__H && (s.__H.__.some(function(l) {
    try {
      Fn(l);
    } catch (u) {
      i = u;
    }
  }), s.__H = void 0, i && wt.__e(i, s.__v));
};
var xr = typeof requestAnimationFrame == "function";
function Ol(o) {
  var i, s = function() {
    clearTimeout(l), xr && cancelAnimationFrame(i), setTimeout(o);
  }, l = setTimeout(s, 35);
  xr && (i = requestAnimationFrame(s));
}
function Fn(o) {
  var i = ht, s = o.__c;
  typeof s == "function" && (o.__c = void 0, s()), ht = i;
}
function Ui(o) {
  var i = ht;
  o.__c = o.__(), ht = i;
}
function Ls(o, i) {
  return !o || o.length !== i.length || i.some(function(s, l) {
    return s !== o[l];
  });
}
function Ts(o, i) {
  return typeof i == "function" ? i(o) : i;
}
function zl(o) {
  const [i, s] = _t(null), [l, u] = _t("idle"), c = J(0), d = Ct(async () => {
    const _ = ++c.current;
    u("loading");
    try {
      const f = await o();
      if (_ !== c.current) return;
      f ? (s(f), u("ready")) : u("unavailable");
    } catch {
      _ === c.current && u("unavailable");
    }
  }, [o]);
  return { point: i, status: l, request: d };
}
const Zl = 1500, Rl = (o) => new Promise((i) => setTimeout(i, o));
function Bl(o) {
  const [i, s] = _t({
    index: [],
    status: "loading",
    reason: null,
    generatedAt: null
  }), l = J(0), u = Ct(async () => {
    const c = ++l.current;
    s({ index: [], status: "loading", reason: null, generatedAt: null });
    for (let d = 0; d < 2; d++) {
      if (d > 0 && await Rl(Zl), c !== l.current) return;
      let _;
      try {
        _ = wl(await o());
      } catch {
        _ = { ok: !1, reason: "transport", detail: "loader failed" };
      }
      if (c !== l.current) return;
      if (_.ok) {
        _.warnings.length > 0 && console.error(
          `[installer-index] rendered a PARTIAL index — ${_.detail} [${_.warnings.join(", ")}]`
        ), s({
          index: _.entries,
          status: "ready",
          reason: null,
          generatedAt: _.generatedAt
        });
        return;
      }
      d === 1 && s({ index: [], status: "error", reason: _.reason, generatedAt: null });
    }
  }, [o]);
  return xt(() => {
    u();
  }, [u]), { ...i, reload: () => {
    u();
  } };
}
function Nl(o, {
  referencePoint: i = null,
  query: s = "",
  services: l = [],
  vehicleTypes: u = [],
  radiusKm: c = null,
  bounds: d = null,
  country: _ = null
} = {}) {
  const [f, g] = _t(null), P = {
    referencePoint: i,
    query: s,
    services: l,
    vehicleTypes: u,
    radiusKm: c,
    bounds: d,
    country: _
  }, m = te(
    () => Al(o, P),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `filters` is rebuilt each render; depend on its values
    [o, i, s, l, u, c, d, _]
  ), x = m.results, T = te(
    () => x.find((k) => k.id === f) ?? null,
    [x, f]
  ), E = Ct(
    (k) => g((b) => b === k ? null : k),
    []
  );
  return {
    results: x,
    textMatched: m.textMatched,
    selectedId: f,
    selected: T,
    select: g,
    toggle: E
  };
}
function Dl(o, i) {
  const [s, l] = _t({
    installer: null,
    status: "idle",
    forId: null
  }), u = J(/* @__PURE__ */ new Map()), c = J(0);
  return xt(() => {
    const d = ++c.current;
    if (!i) {
      l({ installer: null, status: "idle", forId: null });
      return;
    }
    const _ = u.current.get(i);
    if (_) {
      l({ installer: _, status: "ready", forId: i });
      return;
    }
    l({ installer: null, status: "loading", forId: i }), o(i).then((f) => {
      d === c.current && (f ? (u.current.set(i, f), l({ installer: f, status: "ready", forId: i })) : l({ installer: null, status: "missing", forId: i }));
    }).catch(() => {
      d === c.current && l({ installer: null, status: "error", forId: i });
    });
  }, [i, o]), s;
}
const Fl = 2, Hl = 250;
function Ul(o, i) {
  const [s, l] = _t({ suggestions: [], status: "idle" }), u = J(0);
  return xt(() => {
    const c = i.trim(), d = ++u.current;
    if (!o || c.length < Fl) {
      l({ suggestions: [], status: "idle" });
      return;
    }
    l((f) => ({ ...f, status: "loading" }));
    const _ = setTimeout(() => {
      o(c).then((f) => {
        d === u.current && l({ suggestions: f, status: "ready" });
      }).catch(() => {
        d === u.current && l({ suggestions: [], status: "ready" });
      });
    }, Hl);
    return () => clearTimeout(_);
  }, [o, i]), s;
}
function Wl() {
  return /* @__PURE__ */ y(
    "svg",
    {
      class: "locator__search-icon",
      width: "19",
      height: "18.3008",
      viewBox: "0 0 19 18.3008",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ y(
        "path",
        {
          d: "M7.75971 14.942C9.49476 14.9434 11.1798 14.3812 12.5424 13.3461L17.685 18.3008L19 17.0339L13.8574 12.0791C15.3108 10.2924 15.8421 7.96567 15.3011 5.75576C14.7601 3.54631 13.2059 1.6936 11.0769 0.720757C8.94809 -0.252087 6.47549 -0.239539 4.35746 0.754956C2.2393 1.74922 0.705438 3.61763 0.188879 5.83256C-0.327934 8.04749 0.228634 10.3687 1.70148 12.1408C3.17428 13.9127 5.40336 14.9437 7.75971 14.942ZM7.75971 1.79335C9.32271 1.79335 10.8216 2.3916 11.9266 3.45631C13.032 4.52103 13.6527 5.96535 13.6527 7.47125C13.6527 8.97715 13.032 10.4212 11.9266 11.486C10.8216 12.5509 9.32271 13.1489 7.75971 13.1489C6.1967 13.1489 4.69761 12.5509 3.59252 11.486C2.48744 10.4212 1.8665 8.97715 1.8665 7.47125C1.8665 5.96535 2.48744 4.52103 3.59252 3.45631C4.69761 2.3916 6.1967 1.79335 7.75971 1.79335Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function ql() {
  return /* @__PURE__ */ y(
    "svg",
    {
      class: "locator__locate-icon",
      width: "19",
      height: "19",
      viewBox: "0 0 19 19",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ y("circle", { cx: "9.5", cy: "9.5", r: "7.5", stroke: "currentColor", "stroke-width": "2" }),
        /* @__PURE__ */ y("circle", { cx: "9.5", cy: "9.5", r: "3.5", fill: "currentColor" })
      ]
    }
  );
}
function jl() {
  return /* @__PURE__ */ y(
    "svg",
    {
      class: "locator__card-chevron",
      width: "13",
      height: "8",
      viewBox: "0 0 13 8",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ y("path", { d: "M6.5 0L12.1292 6H0.8708L6.5 0Z", fill: "currentColor" })
    }
  );
}
function Gl() {
  return /* @__PURE__ */ y(
    "svg",
    {
      class: "locator__facet-caret",
      width: "10",
      height: "6",
      viewBox: "0 0 10 6",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      children: /* @__PURE__ */ y("path", { d: "M5 0L9.3301 4.5H0.6699L5 0Z", fill: "currentColor" })
    }
  );
}
function Vl() {
  return /* @__PURE__ */ y(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      "aria-hidden": "true",
      focusable: "false",
      children: [
        /* @__PURE__ */ y(
          "path",
          {
            d: "M6.3 1.8 1.8 3.6v12.6l4.5-1.8 5.4 1.8 4.5-1.8V1.8l-4.5 1.8L6.3 1.8Z",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linejoin": "round"
          }
        ),
        /* @__PURE__ */ y("path", { d: "M6.3 1.8v12.6M11.7 3.6v12.6", stroke: "currentColor", "stroke-width": "1.5" })
      ]
    }
  );
}
function $l() {
  return /* @__PURE__ */ y("svg", { width: "18", height: "14", viewBox: "0 0 18 14", fill: "none", "aria-hidden": "true", focusable: "false", children: [
    /* @__PURE__ */ y("circle", { cx: "1.6", cy: "2", r: "1.6", fill: "currentColor" }),
    /* @__PURE__ */ y("circle", { cx: "1.6", cy: "7", r: "1.6", fill: "currentColor" }),
    /* @__PURE__ */ y("circle", { cx: "1.6", cy: "12", r: "1.6", fill: "currentColor" }),
    /* @__PURE__ */ y(
      "path",
      {
        d: "M6 2h11M6 7h11M6 12h11",
        stroke: "currentColor",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }
    )
  ] });
}
function Kl({
  value: o,
  onChange: i,
  placeholder: s,
  suggestions: l = [],
  onSelectSuggestion: u,
  onClear: c,
  selectOnFocus: d = !1
}) {
  const [_, f] = _t(!1), [g, P] = _t(-1), m = Sl(), x = _ && l.length > 0;
  xt(() => P(-1), [l]);
  const T = (k) => {
    const b = l[k];
    b && (u?.(b), f(!1), P(-1));
  }, E = (k) => {
    if (k.key === "Escape") {
      f(!1), P(-1);
      return;
    }
    if (k.key === "Tab") {
      f(!1);
      return;
    }
    if (!x) {
      k.key === "ArrowDown" && l.length > 0 && (f(!0), P(0), k.preventDefault());
      return;
    }
    k.key === "ArrowDown" ? (k.preventDefault(), P((b) => (b + 1) % l.length)) : k.key === "ArrowUp" ? (k.preventDefault(), P((b) => b <= 0 ? l.length - 1 : b - 1)) : k.key === "Enter" && g >= 0 && (k.preventDefault(), T(g));
  };
  return /* @__PURE__ */ y("div", { class: "locator__search", children: [
    /* @__PURE__ */ y(
      "input",
      {
        class: "locator__field",
        type: "search",
        value: o,
        placeholder: s,
        "aria-label": s ?? "Search",
        role: "combobox",
        "aria-expanded": x,
        "aria-controls": m,
        "aria-autocomplete": "list",
        "aria-activedescendant": x && g >= 0 ? `${m}-opt-${g}` : void 0,
        onInput: (k) => {
          i(k.target.value), f(!0);
        },
        onFocus: (k) => {
          f(!0), d && k.target.select();
        },
        onKeyDown: E,
        onBlur: () => setTimeout(() => f(!1), 120)
      }
    ),
    o && c && /* @__PURE__ */ y("button", { type: "button", class: "locator__search-clear", "aria-label": "Clear search", onClick: c, children: "×" }),
    /* @__PURE__ */ y(Wl, {}),
    x && /* @__PURE__ */ y("ul", { class: "locator__search-menu", id: m, role: "listbox", children: l.map((k, b) => /* @__PURE__ */ y("li", { role: "none", children: /* @__PURE__ */ y(
      "button",
      {
        type: "button",
        id: `${m}-opt-${b}`,
        role: "option",
        "aria-selected": b === g,
        class: `locator__search-opt ${b === g ? "is-active" : ""}`,
        onMouseDown: (M) => {
          M.preventDefault(), T(b);
        },
        onMouseEnter: () => P(b),
        children: k.label
      }
    ) }, k.id)) })
  ] });
}
const Pr = {
  idle: "Use my location",
  loading: "Locating…",
  ready: "Located",
  unavailable: "Location off"
};
function Yl({ status: o, onRequest: i }) {
  return /* @__PURE__ */ y(
    "button",
    {
      type: "button",
      class: `locator__locate locator__locate--${o}`,
      disabled: o === "loading",
      onClick: i,
      "aria-label": Pr[o],
      title: Pr[o],
      children: /* @__PURE__ */ y(ql, {})
    }
  );
}
const Si = 4;
function Lr({
  title: o,
  options: i,
  selected: s,
  onToggle: l
}) {
  const [u, c] = _t(!1);
  if (i.length === 0) return null;
  const d = i.length > Si, _ = d && !u ? i.slice(0, Si) : i;
  return /* @__PURE__ */ y(
    "details",
    {
      class: "locator__facet",
      onToggle: (f) => {
        f.currentTarget.open || c(!1);
      },
      children: [
        /* @__PURE__ */ y("summary", { children: [
          /* @__PURE__ */ y("span", { children: [
            o,
            s.length > 0 ? ` (${s.length})` : ""
          ] }),
          /* @__PURE__ */ y(Gl, {})
        ] }),
        /* @__PURE__ */ y("div", { class: `locator__facet-opts ${u ? "locator__facet-opts--expanded" : ""}`, children: [
          _.map((f) => /* @__PURE__ */ y("label", { class: "locator__facet-opt", children: [
            /* @__PURE__ */ y(
              "input",
              {
                type: "checkbox",
                checked: s.includes(f.key),
                onChange: () => l(f.key)
              }
            ),
            /* @__PURE__ */ y("span", { class: "locator__facet-label", children: f.label }),
            /* @__PURE__ */ y("span", { class: "locator__facet-count", children: f.count })
          ] }, f.key)),
          d && /* @__PURE__ */ y(
            "button",
            {
              type: "button",
              class: "locator__facet-more",
              onClick: () => c((f) => !f),
              children: u ? "Show less" : `Show more (${i.length - Si})`
            }
          )
        ] })
      ]
    }
  );
}
function Jl({
  serviceOptions: o,
  vehicleTypeOptions: i,
  selectedServices: s,
  selectedVehicleTypes: l,
  onToggleService: u,
  onToggleVehicleType: c
}) {
  const d = J(null);
  return xt(() => {
    const _ = () => {
      d.current?.querySelectorAll("details[open]").forEach((x) => x.removeAttribute("open"));
    }, f = (x) => {
      const T = d.current;
      T && (x.composedPath().includes(T) || _());
    }, g = (x) => {
      if (x.key !== "Escape") return;
      const E = d.current?.querySelector("details[open]");
      E && (_(), E.querySelector("summary")?.focus());
    }, P = (x) => {
      const T = x.target;
      T.open && d.current?.querySelectorAll("details[open]").forEach((E) => {
        E !== T && E.removeAttribute("open");
      });
    }, m = d.current;
    return m?.addEventListener("toggle", P, !0), document.addEventListener("pointerdown", f, !0), document.addEventListener("keydown", g, !0), () => {
      m?.removeEventListener("toggle", P, !0), document.removeEventListener("pointerdown", f, !0), document.removeEventListener("keydown", g, !0);
    };
  }, []), /* @__PURE__ */ y("div", { class: "locator__facets", ref: d, children: [
    /* @__PURE__ */ y(
      Lr,
      {
        title: "Services",
        options: o,
        selected: s,
        onToggle: u
      }
    ),
    /* @__PURE__ */ y(
      Lr,
      {
        title: "Specialties",
        options: i,
        selected: l,
        onToggle: c
      }
    )
  ] });
}
function Xl({
  services: o,
  vehicleTypes: i,
  onRemoveService: s,
  onRemoveVehicleType: l,
  onClearAll: u
}) {
  return o.length + i.length === 0 ? null : /* @__PURE__ */ y("div", { class: "locator__selected", role: "group", "aria-label": "Active filters", children: [
    /* @__PURE__ */ y("ul", { class: "locator__selected-list", children: [
      o.map((d) => /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          class: "locator__selected-chip",
          onClick: () => s(d),
          children: [
            /* @__PURE__ */ y("span", { children: Qi[d] }),
            /* @__PURE__ */ y("span", { class: "locator__selected-x", "aria-hidden": "true", children: "✕" }),
            /* @__PURE__ */ y("span", { class: "locator__sr", children: "Remove filter" })
          ]
        }
      ) }, `s-${d}`)),
      i.map((d) => /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(
        "button",
        {
          type: "button",
          class: "locator__selected-chip",
          onClick: () => l(d),
          children: [
            /* @__PURE__ */ y("span", { children: to[d] }),
            /* @__PURE__ */ y("span", { class: "locator__selected-x", "aria-hidden": "true", children: "✕" }),
            /* @__PURE__ */ y("span", { class: "locator__sr", children: "Remove filter" })
          ]
        }
      ) }, `v-${d}`))
    ] }),
    /* @__PURE__ */ y("button", { type: "button", class: "locator__selected-clear", onClick: u, children: "Clear all" })
  ] });
}
function ks() {
  return typeof window > "u" || typeof window.matchMedia != "function" ? !0 : window.matchMedia("(hover: none) and (pointer: coarse)").matches;
}
function Ql(o) {
  try {
    return new URL(o).hostname.replace(/^www\./, "");
  } catch {
    return o;
  }
}
function tu({ entry: o, detail: i, detailStatus: s, detailForId: l }) {
  if (!o) return null;
  const u = l === o.id, c = u && s === "ready" && i != null && i.id === o.id, d = !c && !(u && (s === "missing" || s === "error")), _ = c ? ws(i.phone) : null, f = c && i.websiteUrl && bs(i.websiteUrl) ? i.websiteUrl : null, g = [o.suburbCity, o.stateRegion, o.country].filter(Boolean).join(", ");
  return /* @__PURE__ */ y("div", { class: "locator__mapcard", "aria-busy": d ? "true" : void 0, children: [
    /* @__PURE__ */ y("span", { class: "locator__mapcard-handle", "aria-hidden": "true" }),
    /* @__PURE__ */ y("div", { class: "locator__mapcard-head", children: [
      /* @__PURE__ */ y("h3", { class: "locator__mapcard-name", children: o.name }),
      c && i.ownsDyno && /* @__PURE__ */ y("span", { class: "locator__badge", children: "DYNO IN-HOUSE" })
    ] }),
    d && /* @__PURE__ */ y("p", { class: "locator__mapcard-contactline-skel", children: /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line" }) }),
    c && (i.phone || f) && /* @__PURE__ */ y("p", { class: "locator__card-contactline", children: [
      i.phone,
      i.phone && f ? "  ·  " : "",
      f && /* @__PURE__ */ y("a", { href: f, target: "_blank", rel: "noreferrer", children: Ql(f) })
    ] }),
    /* @__PURE__ */ y("p", { class: "locator__mapcard-address", children: d ? /* @__PURE__ */ y(Vt, { children: [
      /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line" }),
      /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line locator__skel--short" })
    ] }) : c ? no(i.address) : g }),
    d && /* @__PURE__ */ y("div", { class: "locator__mapcard-actions", "aria-hidden": "true", children: [
      /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" }),
      /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" }),
      /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" })
    ] }),
    c && /* @__PURE__ */ y("div", { class: "locator__mapcard-actions", children: [
      _ && ks() && /* @__PURE__ */ y("a", { class: "locator__btn locator__btn--ghost", href: _, children: "Call" }),
      i.email && /* @__PURE__ */ y("a", { class: "locator__btn locator__btn--ghost", href: `mailto:${i.email}`, children: "Email" }),
      /* @__PURE__ */ y(
        "a",
        {
          class: "locator__btn locator__btn--primary",
          href: xs(i),
          target: "_blank",
          rel: "noreferrer",
          children: "Directions"
        }
      )
    ] })
  ] });
}
function eu(o, i) {
  for (var s in i) o[s] = i[s];
  return o;
}
function Wi(o, i) {
  for (var s in o) if (s !== "__source" && !(s in i)) return !0;
  for (var l in i) if (l !== "__source" && o[l] !== i[l]) return !0;
  return !1;
}
function Tr(o, i) {
  this.props = o, this.context = i;
}
function nu(o, i) {
  function s(u) {
    var c = this.props.ref;
    return c != u.ref && c && (typeof c == "function" ? c(null) : c.current = null), i ? !i(this.props, u) || c != u.ref : Wi(this.props, u);
  }
  function l(u) {
    return this.shouldComponentUpdate = s, Wn(o, u);
  }
  return l.displayName = "Memo(" + (o.displayName || o.name) + ")", l.__f = l.prototype.isReactComponent = !0, l.type = o, l;
}
(Tr.prototype = new ne()).isPureReactComponent = !0, Tr.prototype.shouldComponentUpdate = function(o, i) {
  return Wi(this.props, o) || Wi(this.state, i);
};
var kr = q.__b;
q.__b = function(o) {
  o.type && o.type.__f && o.ref && (o.props.ref = o.ref, o.ref = null), kr && kr(o);
};
var iu = q.__e;
q.__e = function(o, i, s, l) {
  if (o.then) {
    for (var u, c = i; c = c.__; ) if ((u = c.__c) && u.__c) return i.__e == null && (i.__e = s.__e, i.__k = s.__k), u.__c(o, i);
  }
  iu(o, i, s, l);
};
var Mr = q.unmount;
function Ms(o, i, s) {
  return o && (o.__c && o.__c.__H && (o.__c.__H.__.forEach(function(l) {
    typeof l.__c == "function" && l.__c();
  }), o.__c.__H = null), (o = eu({}, o)).__c != null && (o.__c.__P === s && (o.__c.__P = i), o.__c.__e = !0, o.__c = null), o.__k = o.__k && o.__k.map(function(l) {
    return Ms(l, i, s);
  })), o;
}
function As(o, i, s) {
  return o && s && (o.__v = null, o.__k = o.__k && o.__k.map(function(l) {
    return As(l, i, s);
  }), o.__c && o.__c.__P === i && (o.__e && s.appendChild(o.__e), o.__c.__e = !0, o.__c.__P = s)), o;
}
function Ii() {
  this.__u = 0, this.o = null, this.__b = null;
}
function Cs(o) {
  var i = o.__ && o.__.__c;
  return i && i.__a && i.__a(o);
}
function zn() {
  this.i = null, this.l = null;
}
q.unmount = function(o) {
  var i = o.__c;
  i && (i.__z = !0), i && i.__R && i.__R(), i && 32 & o.__u && (o.type = null), Mr && Mr(o);
}, (Ii.prototype = new ne()).__c = function(o, i) {
  var s = i.__c, l = this;
  l.o == null && (l.o = []), l.o.push(s);
  var u = Cs(l.__v), c = !1, d = function() {
    c || l.__z || (c = !0, s.__R = null, u ? u(f) : f());
  };
  s.__R = d;
  var _ = s.__P;
  s.__P = null;
  var f = function() {
    if (!--l.__u) {
      if (l.state.__a) {
        var g = l.state.__a;
        l.__v.__k[0] = As(g, g.__c.__P, g.__c.__O);
      }
      var P;
      for (l.setState({ __a: l.__b = null }); P = l.o.pop(); ) P.__P = _, P.forceUpdate();
    }
  };
  l.__u++ || 32 & i.__u || l.setState({ __a: l.__b = l.__v.__k[0] }), o.then(d, d);
}, Ii.prototype.componentWillUnmount = function() {
  this.o = [];
}, Ii.prototype.render = function(o, i) {
  if (this.__b) {
    if (this.__v.__k) {
      var s = document.createElement("div"), l = this.__v.__k[0].__c;
      this.__v.__k[0] = Ms(this.__b, s, l.__O = l.__P);
    }
    this.__b = null;
  }
  var u = i.__a && Wn(Vt, null, o.fallback);
  return u && (u.__u &= -33), [Wn(Vt, null, i.__a ? null : o.children), u];
};
var Ar = function(o, i, s) {
  if (++s[1] === s[0] && o.l.delete(i), o.props.revealOrder && (o.props.revealOrder[0] !== "t" || !o.l.size)) for (s = o.i; s; ) {
    for (; s.length > 3; ) s.pop()();
    if (s[1] < s[0]) break;
    o.i = s = s[2];
  }
};
(zn.prototype = new ne()).__a = function(o) {
  var i = this, s = Cs(i.__v), l = i.l.get(o);
  return l[0]++, function(u) {
    var c = function() {
      i.props.revealOrder ? (l.push(u), Ar(i, o, l)) : u();
    };
    s ? s(c) : c();
  };
}, zn.prototype.render = function(o) {
  this.i = null, this.l = /* @__PURE__ */ new Map();
  var i = jn(o.children);
  o.revealOrder && o.revealOrder[0] === "b" && i.reverse();
  for (var s = i.length; s--; ) this.l.set(i[s], this.i = [1, 0, this.i]);
  return o.children;
}, zn.prototype.componentDidUpdate = zn.prototype.componentDidMount = function() {
  var o = this;
  this.l.forEach(function(i, s) {
    Ar(o, s, i);
  });
};
var ou = typeof Symbol < "u" && Symbol.for && /* @__PURE__ */ Symbol.for("react.element") || 60103, ru = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, su = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, au = /[A-Z0-9]/g, lu = typeof document < "u", uu = function(o) {
  return (typeof Symbol < "u" && typeof /* @__PURE__ */ Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(o);
};
ne.prototype.isReactComponent = !0, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(o) {
  Object.defineProperty(ne.prototype, o, { configurable: !0, get: function() {
    return this["UNSAFE_" + o];
  }, set: function(i) {
    Object.defineProperty(this, o, { configurable: !0, writable: !0, value: i });
  } });
});
var Cr = q.event;
q.event = function(o) {
  return Cr && (o = Cr(o)), o.persist = function() {
  }, o.isPropagationStopped = function() {
    return this.cancelBubble;
  }, o.isDefaultPrevented = function() {
    return this.defaultPrevented;
  }, o.nativeEvent = o;
};
var cu = { configurable: !0, get: function() {
  return this.class;
} }, Er = q.vnode;
q.vnode = function(o) {
  typeof o.type == "string" && (function(i) {
    var s = i.props, l = i.type, u = {}, c = l.indexOf("-") == -1;
    for (var d in s) {
      var _ = s[d];
      if (!(d === "value" && "defaultValue" in s && _ == null || lu && d === "children" && l === "noscript" || d === "class" || d === "className")) {
        var f = d.toLowerCase();
        d === "defaultValue" && "value" in s && s.value == null ? d = "value" : d === "download" && _ === !0 ? _ = "" : f === "translate" && _ === "no" ? _ = !1 : f[0] === "o" && f[1] === "n" ? f === "ondoubleclick" ? d = "ondblclick" : f !== "onchange" || l !== "input" && l !== "textarea" || uu(s.type) ? f === "onfocus" ? d = "onfocusin" : f === "onblur" ? d = "onfocusout" : su.test(d) && (d = f) : f = d = "oninput" : c && ru.test(d) ? d = d.replace(au, "-$&").toLowerCase() : _ === null && (_ = void 0), f === "oninput" && u[d = f] && (d = "oninputCapture"), u[d] = _;
      }
    }
    l == "select" && (u.multiple && Array.isArray(u.value) && (u.value = jn(s.children).forEach(function(g) {
      g.props.selected = u.value.indexOf(g.props.value) != -1;
    })), u.defaultValue != null && (u.value = jn(s.children).forEach(function(g) {
      g.props.selected = u.multiple ? u.defaultValue.indexOf(g.props.value) != -1 : u.defaultValue == g.props.value;
    }))), s.class && !s.className ? (u.class = s.class, Object.defineProperty(u, "className", cu)) : s.className && (u.class = u.className = s.className), i.props = u;
  })(o), o.$$typeof = ou, Er && Er(o);
};
var Sr = q.__r;
q.__r = function(o) {
  Sr && Sr(o), o.__c;
};
var Ir = q.diffed;
q.diffed = function(o) {
  Ir && Ir(o);
  var i = o.props, s = o.__e;
  s != null && o.type === "textarea" && "value" in i && i.value !== s.value && (s.value = i.value == null ? "" : i.value);
};
function hu(o, i) {
  const [s, l] = _t(!1);
  return xt(() => {
    if (!o) {
      l(!1);
      return;
    }
    const u = setTimeout(() => l(!0), i);
    return () => clearTimeout(u);
  }, [o, i]), s;
}
function du(o) {
  try {
    return new URL(o).hostname.replace(/^www\./, "");
  } catch {
    return o;
  }
}
const fu = nu(function({
  installer: i,
  expanded: s,
  onToggle: l,
  detail: u,
  detailStatus: c,
  detailForId: d
}) {
  const _ = d === i.id, f = _ && c === "ready" && u != null && u.id === i.id, g = _ && c === "missing", P = _ && c === "error", x = s && !(f || g || P), T = hu(x, 250), E = [i.suburbCity, i.stateRegion].filter(Boolean).join(", "), k = u && ws(u.phone), b = u?.websiteUrl && bs(u.websiteUrl) ? u.websiteUrl : null;
  return /* @__PURE__ */ y(
    "article",
    {
      class: `locator__card ${s ? "locator__card--open" : ""}`,
      "aria-busy": x && s ? "true" : void 0,
      children: [
        /* @__PURE__ */ y("h3", { class: "locator__card-heading", children: /* @__PURE__ */ y(
          "button",
          {
            type: "button",
            class: "locator__card-toggle",
            "aria-expanded": s,
            onClick: () => l(i.id),
            children: [
              /* @__PURE__ */ y("span", { class: "locator__card-name", children: i.name }),
              /* @__PURE__ */ y(jl, {})
            ]
          }
        ) }),
        (!s || x && !T) && /* @__PURE__ */ y("div", { class: "locator__card-summary", children: [
          /* @__PURE__ */ y("p", { class: "locator__card-locality", children: E || i.country }),
          i.distance != null && /* @__PURE__ */ y("p", { class: "locator__card-distance", children: Cl(i.distance) })
        ] }),
        x && T && /* @__PURE__ */ y("div", { class: "locator__card-body", "aria-hidden": "true", children: [
          /* @__PURE__ */ y("p", { class: "locator__card-badges", children: /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--badge" }) }),
          /* @__PURE__ */ y("p", { class: "locator__card-skel-line", children: /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line locator__skel--short" }) }),
          /* @__PURE__ */ y("p", { class: "locator__card-address", children: [
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line" }),
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--line locator__skel--short" })
          ] }),
          /* @__PURE__ */ y("div", { class: "locator__card-skel-actions", children: [
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" }),
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" }),
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" }),
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--btn" })
          ] }),
          /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--sub" }),
          /* @__PURE__ */ y("div", { class: "locator__card-skel-tags", children: [
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--tag" }),
            /* @__PURE__ */ y("span", { class: "locator__skel locator__skel--tag" })
          ] })
        ] }),
        s && P && /* @__PURE__ */ y("p", { class: "locator__card-loading", children: "Couldn’t load this dealer. Please try again." }),
        s && g && /* @__PURE__ */ y("div", { class: "locator__card-body", children: [
          /* @__PURE__ */ y("p", { class: "locator__card-address", children: [i.suburbCity, i.stateRegion, i.country].filter(Boolean).join(", ") }),
          /* @__PURE__ */ y(Or, { services: i.services, vehicleTypes: i.vehicleTypes }),
          /* @__PURE__ */ y("p", { class: "locator__card-note", children: "Full contact details for this dealer aren’t available yet." })
        ] }),
        s && f && /* @__PURE__ */ y("div", { class: "locator__card-body", children: [
          /* @__PURE__ */ y("p", { class: "locator__card-badges", children: u.ownsDyno && /* @__PURE__ */ y("span", { class: "locator__badge", children: "DYNO IN-HOUSE" }) }),
          (u.phone || b) && /* @__PURE__ */ y("p", { class: "locator__card-contactline", children: [
            u.phone,
            u.phone && b ? "  ·  " : "",
            b && /* @__PURE__ */ y("a", { href: b, target: "_blank", rel: "noreferrer", children: du(b) })
          ] }),
          u.contactPerson && /* @__PURE__ */ y("p", { class: "locator__card-contact", children: [
            "Contact:  ",
            u.contactPerson
          ] }),
          /* @__PURE__ */ y("p", { class: "locator__card-address", children: no(u.address) }),
          u.description && /* @__PURE__ */ y("p", { class: "locator__card-desc", children: u.description }),
          /* @__PURE__ */ y("div", { class: "locator__card-actions", children: [
            k && ks() && /* @__PURE__ */ y("a", { class: "locator__btn locator__btn--ghost", href: k, children: "Call" }),
            u.email && /* @__PURE__ */ y("a", { class: "locator__btn locator__btn--ghost", href: `mailto:${u.email}`, children: "Email" }),
            b && /* @__PURE__ */ y("a", { class: "locator__btn locator__btn--ghost", href: b, target: "_blank", rel: "noreferrer", children: "Website" }),
            /* @__PURE__ */ y(
              "a",
              {
                class: "locator__btn locator__btn--primary",
                href: xs(u),
                target: "_blank",
                rel: "noreferrer",
                children: "Directions"
              }
            )
          ] }),
          /* @__PURE__ */ y(Or, { services: u.services, vehicleTypes: u.vehicleTypes }),
          u.languagesSpoken && /* @__PURE__ */ y("p", { class: "locator__card-note", children: [
            "Languages: ",
            u.languagesSpoken
          ] })
        ] })
      ]
    }
  );
});
function Or({
  services: o,
  vehicleTypes: i
}) {
  return /* @__PURE__ */ y(Vt, { children: [
    o.length > 0 && /* @__PURE__ */ y(Vt, { children: [
      /* @__PURE__ */ y("h4", { class: "locator__card-sub", children: "Services" }),
      /* @__PURE__ */ y("ul", { class: "locator__taglist", children: o.map((s) => /* @__PURE__ */ y("li", { children: Qi[s] }, s)) })
    ] }),
    i.length > 0 && /* @__PURE__ */ y(Vt, { children: [
      /* @__PURE__ */ y("h4", { class: "locator__card-sub", children: "Specialties" }),
      /* @__PURE__ */ y("ul", { class: "locator__taglist", children: i.map((s) => /* @__PURE__ */ y("li", { children: to[s] }, s)) })
    ] })
  ] });
}
function _u({
  installers: o,
  selectedId: i,
  onSelectInstaller: s,
  detail: l,
  detailStatus: u,
  detailForId: c
}) {
  return /* @__PURE__ */ y("ul", { class: "locator__list", children: o.map((d) => /* @__PURE__ */ y("li", { children: /* @__PURE__ */ y(
    fu,
    {
      installer: d,
      expanded: d.id === i,
      onToggle: s,
      detail: d.id === i ? l : null,
      detailStatus: d.id === i ? u : "idle",
      detailForId: d.id === i ? c : null
    }
  ) }, d.id)) });
}
const { getOwnPropertyNames: pu, getOwnPropertySymbols: mu } = Object, { hasOwnProperty: gu } = Object.prototype;
function Je(o, i) {
  return function(l, u, c) {
    return o(l, u, c) && i(l, u, c);
  };
}
function Xe(o) {
  return function(s, l, u) {
    if (!s || !l || typeof s != "object" || typeof l != "object")
      return o(s, l, u);
    const { cache: c } = u, d = c.get(s), _ = c.get(l);
    if (d && _)
      return d === l && _ === s;
    c.set(s, l), c.set(l, s);
    const f = o(s, l, u);
    return c.delete(s), c.delete(l), f;
  };
}
function vu(o) {
  return o?.[Symbol.toStringTag];
}
function zr(o) {
  return pu(o).concat(mu(o));
}
const yu = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  Object.hasOwn || ((o, i) => gu.call(o, i))
);
function xe(o, i) {
  return o === i || !o && !i && o !== o && i !== i;
}
const wu = "__v", bu = "__o", xu = "_owner", Pu = typeof Float16Array < "u", { getOwnPropertyDescriptor: Zr, keys: Rr } = Object;
function Lu(o, i) {
  return o.byteLength === i.byteLength && $n(new Uint8Array(o), new Uint8Array(i));
}
function Tu(o, i, s) {
  let l = o.length;
  if (i.length !== l)
    return !1;
  for (; l-- > 0; )
    if (!s.equals(o[l], i[l], l, l, o, i, s))
      return !1;
  return !0;
}
function ku(o, i) {
  return o.byteLength === i.byteLength && $n(new Uint8Array(o.buffer, o.byteOffset, o.byteLength), new Uint8Array(i.buffer, i.byteOffset, i.byteLength));
}
function Mu(o, i) {
  return xe(o.getTime(), i.getTime());
}
function Br(o, i, s) {
  return o.name === i.name && o.message === i.message && o.stack === i.stack && s.equals(o.cause, i.cause, "cause", "cause", o, i, s);
}
function Au(o, i) {
  return o === i;
}
function Nr(o, i, s) {
  const l = o.size;
  if (l !== i.size)
    return !1;
  if (!l)
    return !0;
  const u = new Array(l), c = o.entries();
  let d, _, f = 0;
  for (; (d = c.next()) && !d.done; ) {
    const g = i.entries();
    let P = !1, m = 0;
    for (; (_ = g.next()) && !_.done; ) {
      if (u[m]) {
        m++;
        continue;
      }
      const x = d.value, T = _.value;
      if (s.equals(x[0], T[0], f, m, o, i, s) && s.equals(x[1], T[1], x[0], T[0], o, i, s)) {
        P = u[m] = !0;
        break;
      }
      m++;
    }
    if (!P)
      return !1;
    f++;
  }
  return !0;
}
const Cu = xe;
function Dr(o, i, s) {
  const l = Rr(o);
  let u = l.length;
  if (Rr(i).length !== u)
    return !1;
  for (; u-- > 0; )
    if (!Es(o, i, s, l[u]))
      return !1;
  return !0;
}
function Oe(o, i, s) {
  const l = zr(o);
  let u = l.length;
  if (zr(i).length !== u)
    return !1;
  let c, d, _;
  for (; u-- > 0; )
    if (c = l[u], !Es(o, i, s, c) || (d = Zr(o, c), _ = Zr(i, c), (d || _) && (!d || !_ || d.configurable !== _.configurable || d.enumerable !== _.enumerable || d.writable !== _.writable)))
      return !1;
  return !0;
}
function Eu(o, i) {
  return xe(o.valueOf(), i.valueOf());
}
function Su(o, i) {
  return o.source === i.source && o.flags === i.flags;
}
function Fr(o, i, s) {
  const l = o.size;
  if (l !== i.size)
    return !1;
  if (!l)
    return !0;
  const u = new Array(l), c = o.values();
  let d, _;
  for (; (d = c.next()) && !d.done; ) {
    const f = i.values();
    let g = !1, P = 0;
    for (; (_ = f.next()) && !_.done; ) {
      if (!u[P] && s.equals(d.value, _.value, d.value, _.value, o, i, s)) {
        g = u[P] = !0;
        break;
      }
      P++;
    }
    if (!g)
      return !1;
  }
  return !0;
}
function $n(o, i) {
  let s = o.length;
  if (i.length !== s || o.byteOffset !== i.byteOffset)
    return !1;
  if (o instanceof Float64Array || o instanceof Float32Array || Pu && o instanceof Float16Array) {
    for (; s-- > 0; )
      if (o[s] !== i[s] && (o[s] === o[s] || i[s] === i[s]))
        return !1;
    return !0;
  }
  for (; s-- > 0; )
    if (o[s] !== i[s])
      return !1;
  return !0;
}
function Iu(o, i) {
  return o.href === i.href ? !0 : o.protocol === i.protocol && o.username === i.username && o.password === i.password && o.host === i.host && o.pathname === i.pathname && o.hash === i.hash && Ou(o.searchParams, i.searchParams);
}
function Ou(o, i) {
  const s = o.toString(), l = i.toString();
  return s === l || Hr(s) === Hr(l);
}
function Hr(o) {
  return o.split("&").sort().join("&");
}
function Es(o, i, s, l) {
  return (l === xu || l === bu || l === wu) && (o.$$typeof || i.$$typeof) ? !0 : yu(i, l) && s.equals(o[l], i[l], l, l, o, i, s);
}
const zu = "[object ArrayBuffer]", Zu = "[object Arguments]", Ru = "[object Boolean]", Bu = "[object DataView]", Nu = "[object Date]", Du = "[object Error]", Fu = "[object Map]", Hu = "[object Number]", Uu = "[object Object]", Wu = "[object RegExp]", qu = "[object Set]", ju = "[object String]", Gu = {
  "[object Int8Array]": !0,
  "[object Uint8Array]": !0,
  "[object Uint8ClampedArray]": !0,
  "[object Int16Array]": !0,
  "[object Uint16Array]": !0,
  "[object Int32Array]": !0,
  "[object Uint32Array]": !0,
  "[object Float16Array]": !0,
  "[object Float32Array]": !0,
  "[object Float64Array]": !0,
  "[object BigInt64Array]": !0,
  "[object BigUint64Array]": !0
}, Vu = "[object URL]", $u = Object.prototype.toString;
function Ku({ areArrayBuffersEqual: o, areArraysEqual: i, areDataViewsEqual: s, areDatesEqual: l, areErrorsEqual: u, areFunctionsEqual: c, areMapsEqual: d, areNumbersEqual: _, areObjectsEqual: f, arePrimitiveWrappersEqual: g, areRegExpsEqual: P, areSetsEqual: m, areTypedArraysEqual: x, areUrlsEqual: T, unknownTagComparators: E }) {
  return function(b, M, C) {
    if (b === M)
      return !0;
    if (b == null || M == null)
      return !1;
    const O = typeof b;
    if (O !== typeof M)
      return !1;
    if (O !== "object")
      return O === "number" ? _(b, M, C) : O === "function" ? c(b, M, C) : !1;
    const V = b.constructor;
    if (V !== M.constructor)
      return !1;
    if (V === Object)
      return f(b, M, C);
    if (Array.isArray(b))
      return i(b, M, C);
    if (V === Date)
      return l(b, M, C);
    if (V === RegExp)
      return P(b, M, C);
    if (V === Map)
      return d(b, M, C);
    if (V === Set)
      return m(b, M, C);
    if (V == null)
      return f(b, M, C);
    const j = $u.call(b);
    if (j === Nu)
      return l(b, M, C);
    if (j === Wu)
      return P(b, M, C);
    if (j === Fu)
      return d(b, M, C);
    if (j === qu)
      return m(b, M, C);
    if (j === Uu)
      return typeof b.then != "function" && typeof M.then != "function" && f(b, M, C);
    if (j === Vu)
      return T(b, M, C);
    if (j === Du)
      return u(b, M, C);
    if (j === Zu)
      return f(b, M, C);
    if (Gu[j])
      return x(b, M, C);
    if (j === zu)
      return o(b, M, C);
    if (j === Bu)
      return s(b, M, C);
    if (j === Ru || j === Hu || j === ju)
      return g(b, M, C);
    if (E) {
      let rt = E[j];
      if (!rt) {
        const et = vu(b);
        et && (rt = E[et]);
      }
      if (rt)
        return rt(b, M, C);
    }
    return !1;
  };
}
function Yu({ circular: o, createCustomConfig: i, strict: s }) {
  let l = {
    areArrayBuffersEqual: Lu,
    areArraysEqual: s ? Oe : Tu,
    areDataViewsEqual: ku,
    areDatesEqual: Mu,
    // `Error` subclasses routinely carry their own enumerable properties (`status`, `code`, ...),
    // which the error comparator alone does not see, so it is composed with the object comparator.
    // `name` / `message` / `stack` are own but not enumerable, which is why errors need a
    // comparator of their own rather than being treated as plain objects in the first place.
    areErrorsEqual: s ? Je(Br, Oe) : Je(Br, Dr),
    areFunctionsEqual: Au,
    areMapsEqual: s ? Je(Nr, Oe) : Nr,
    areNumbersEqual: Cu,
    areObjectsEqual: s ? Oe : Dr,
    arePrimitiveWrappersEqual: Eu,
    areRegExpsEqual: Su,
    areSetsEqual: s ? Je(Fr, Oe) : Fr,
    areTypedArraysEqual: s ? Je($n, Oe) : $n,
    areUrlsEqual: Iu,
    unknownTagComparators: void 0
  };
  if (i && (l = Object.assign({}, l, i(l))), o) {
    const u = Xe(l.areArraysEqual), c = Xe(l.areErrorsEqual), d = Xe(l.areMapsEqual), _ = Xe(l.areObjectsEqual), f = Xe(l.areSetsEqual);
    l = Object.assign({}, l, {
      areArraysEqual: u,
      areErrorsEqual: c,
      areMapsEqual: d,
      areObjectsEqual: _,
      areSetsEqual: f
    });
  }
  return l;
}
function Ju(o) {
  return function(i, s, l, u, c, d, _) {
    return o(i, s, _);
  };
}
function Xu({ circular: o, comparator: i, createState: s, equals: l, strict: u }) {
  if (s)
    return function(_, f) {
      const { cache: g = o ? /* @__PURE__ */ new WeakMap() : void 0, meta: P } = s();
      return i(_, f, {
        cache: g,
        equals: l,
        meta: P,
        strict: u
      });
    };
  if (o)
    return function(_, f) {
      return i(_, f, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: l,
        meta: void 0,
        strict: u
      });
    };
  const c = {
    cache: void 0,
    equals: l,
    meta: void 0,
    strict: u
  };
  return function(_, f) {
    return i(_, f, c);
  };
}
const Ur = de();
de({ strict: !0 });
de({ circular: !0 });
de({
  circular: !0,
  strict: !0
});
de({
  createInternalComparator: () => xe
});
de({
  strict: !0,
  createInternalComparator: () => xe
});
de({
  circular: !0,
  createInternalComparator: () => xe
});
de({
  circular: !0,
  createInternalComparator: () => xe,
  strict: !0
});
function de(o = {}) {
  const { circular: i = !1, createInternalComparator: s, createState: l, strict: u = !1 } = o, c = Yu(o), d = Ku(c), _ = s ? s(d) : Ju(d);
  return Xu({ circular: i, comparator: d, createState: l, equals: _, strict: u });
}
const Wr = [
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
], Oi = 1, Qe = 8, at = new Uint32Array(96);
class io {
  /**
   * Creates an index from raw `ArrayBuffer` data.
   * @param {ArrayBufferLike} data
   */
  static from(i) {
    if (!i || i.byteLength === void 0 || i.buffer)
      throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
    const [s, l] = new Uint8Array(i, 0, 2);
    if (s !== 219)
      throw new Error("Data does not appear to be in a KDBush format.");
    const u = l >> 4;
    if (u !== Oi)
      throw new Error(`Got v${u} data when expected v${Oi}.`);
    const c = Wr[l & 15];
    if (!c)
      throw new Error("Unrecognized array type.");
    const [d] = new Uint16Array(i, 2, 1), [_] = new Uint32Array(i, 4, 1);
    return new io(_, d, c, void 0, i);
  }
  /**
   * Creates an index that will hold a given number of items.
   * @param {number} numItems
   * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
   * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
   * @param {ArrayBufferConstructor | SharedArrayBufferConstructor} [ArrayBufferType=ArrayBuffer] The array buffer type used for storage (`ArrayBuffer` by default).
   * @param {ArrayBufferLike} [data] (For internal use only)
   */
  constructor(i, s = 64, l = Float64Array, u = ArrayBuffer, c) {
    if (isNaN(i) || i < 0) throw new Error(`Unexpected numItems value: ${i}.`);
    this.numItems = +i, this.nodeSize = Math.min(Math.max(+s, 2), 65535), this.ArrayType = l, this.IndexArrayType = i < 65536 ? Uint16Array : Uint32Array;
    const d = Wr.indexOf(this.ArrayType), _ = i * 2 * this.ArrayType.BYTES_PER_ELEMENT, f = i * this.IndexArrayType.BYTES_PER_ELEMENT, g = (8 - f % 8) % 8;
    if (d < 0)
      throw new Error(`Unexpected typed array class: ${l}.`);
    if (c)
      this.data = c, this.ids = new this.IndexArrayType(c, Qe, i), this.coords = new l(c, Qe + f + g, i * 2), this._pos = i * 2, this._finished = !0;
    else {
      const P = this.data = new u(Qe + _ + f + g);
      this.ids = new this.IndexArrayType(P, Qe, i), this.coords = new l(P, Qe + f + g, i * 2), this._pos = 0, this._finished = !1, new Uint8Array(P, 0, 2).set([219, (Oi << 4) + d]), new Uint16Array(P, 2, 1)[0] = s, new Uint32Array(P, 4, 1)[0] = i;
    }
  }
  /**
   * Add a point to the index.
   * @param {number} x
   * @param {number} y
   * @returns {number} An incremental index associated with the added item (starting from `0`).
   */
  add(i, s) {
    const l = this._pos >> 1;
    return this.ids[l] = l, this.coords[this._pos++] = i, this.coords[this._pos++] = s, l;
  }
  /**
   * Perform indexing of the added points.
   */
  finish() {
    const i = this._pos >> 1;
    if (i !== this.numItems)
      throw new Error(`Added ${i} items when expected ${this.numItems}.`);
    return qi(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
  }
  /**
   * Search the index for items within a given bounding box.
   * @param {number} minX
   * @param {number} minY
   * @param {number} maxX
   * @param {number} maxY
   * @returns {number[]} An array of indices correponding to the found items.
   */
  range(i, s, l, u) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: c, coords: d, nodeSize: _ } = this;
    at[0] = 0, at[1] = c.length - 1, at[2] = 0;
    let f = 3;
    const g = [];
    for (; f > 0; ) {
      const P = at[--f], m = at[--f], x = at[--f];
      if (m - x <= _) {
        for (let b = x; b <= m; b++) {
          const M = d[2 * b], C = d[2 * b + 1];
          M >= i && M <= l && C >= s && C <= u && g.push(c[b]);
        }
        continue;
      }
      const T = x + m >> 1, E = d[2 * T], k = d[2 * T + 1];
      E >= i && E <= l && k >= s && k <= u && g.push(c[T]), (P === 0 ? i <= E : s <= k) && (at[f++] = x, at[f++] = T - 1, at[f++] = 1 - P), (P === 0 ? l >= E : u >= k) && (at[f++] = T + 1, at[f++] = m, at[f++] = 1 - P);
    }
    return g;
  }
  /**
   * Search the index for items within a given radius.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @returns {number[]} An array of indices correponding to the found items.
   */
  within(i, s, l) {
    const u = (
      /** @type {number[]} */
      []
    );
    return this.withinInto(i, s, l, u), u;
  }
  /**
   * Search the index for items within a given radius, writing matching ids into `out`
   * via indexed assignment (`out[i] = id`). Accepts any indexed-writable container —
   * a typed array sized to the expected upper bound (allocation-free, fast) or a plain
   * `Array` (which will grow as needed). Returns the number of matches written.
   * @param {number} qx
   * @param {number} qy
   * @param {number} r Query radius.
   * @param {number[] | TypedArray} out Container to write matching ids into.
   * @returns {number} The number of matches written to `out`.
   */
  withinInto(i, s, l, u) {
    if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
    const { ids: c, coords: d, nodeSize: _ } = this;
    at[0] = 0, at[1] = c.length - 1, at[2] = 0;
    let f = 3, g = 0;
    const P = l * l;
    for (; f > 0; ) {
      const m = at[--f], x = at[--f], T = at[--f];
      if (x - T <= _) {
        for (let M = T; M <= x; M++)
          qr(d[2 * M], d[2 * M + 1], i, s) <= P && (u[g++] = c[M]);
        continue;
      }
      const E = T + x >> 1, k = d[2 * E], b = d[2 * E + 1];
      qr(k, b, i, s) <= P && (u[g++] = c[E]), (m === 0 ? i - l <= k : s - l <= b) && (at[f++] = T, at[f++] = E - 1, at[f++] = 1 - m), (m === 0 ? i + l >= k : s + l >= b) && (at[f++] = E + 1, at[f++] = x, at[f++] = 1 - m);
    }
    return g;
  }
}
function qi(o, i, s, l, u, c) {
  if (u - l <= s) return;
  const d = l + u >> 1;
  Ss(o, i, d, l, u, c), qi(o, i, s, l, d - 1, 1 - c), qi(o, i, s, d + 1, u, 1 - c);
}
function Ss(o, i, s, l, u, c) {
  for (; u > l; ) {
    if (u - l > 600) {
      const g = u - l + 1, P = s - l + 1, m = Math.log(g), x = 0.5 * Math.exp(2 * m / 3), T = 0.5 * Math.sqrt(m * x * (g - x) / g) * (P - g / 2 < 0 ? -1 : 1), E = Math.max(l, Math.floor(s - P * x / g + T)), k = Math.min(u, Math.floor(s + (g - P) * x / g + T));
      Ss(o, i, s, E, k, c);
    }
    const d = i[2 * s + c];
    let _ = l, f = u;
    for (tn(o, i, l, s), i[2 * u + c] > d && tn(o, i, l, u); _ < f; ) {
      for (tn(o, i, _, f), _++, f--; i[2 * _ + c] < d; ) _++;
      for (; i[2 * f + c] > d; ) f--;
    }
    i[2 * l + c] === d ? tn(o, i, l, f) : (f++, tn(o, i, f, u)), f <= s && (l = f + 1), s <= f && (u = f - 1);
  }
}
function tn(o, i, s, l) {
  zi(o, s, l), zi(i, 2 * s, 2 * l), zi(i, 2 * s + 1, 2 * l + 1);
}
function zi(o, i, s) {
  const l = o[i];
  o[i] = o[s], o[s] = l;
}
function qr(o, i, s, l) {
  const u = o - s, c = i - l;
  return u * u + c * c;
}
const Qu = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: !1,
  // whether to log timing info
  // whether to generate numeric ids for input features (in vector tiles)
  generateId: !1,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }
  // properties to use for individual points when running the reducer
  map: (o) => o
  // props => ({sum: props.my_value})
}, jr = Math.fround || /* @__PURE__ */ ((o) => ((i) => (o[0] = +i, o[0])))(new Float32Array(1)), ve = 2, he = 3, Zi = 4, ue = 5, Is = 6;
class tc {
  constructor(i) {
    this.options = Object.assign(Object.create(Qu), i), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
  }
  load(i) {
    const { log: s, minZoom: l, maxZoom: u } = this.options;
    s && console.time("total time");
    const c = `prepare ${i.length} points`;
    s && console.time(c), this.points = i;
    const d = [];
    for (let f = 0; f < i.length; f++) {
      const g = i[f];
      if (!g.geometry) continue;
      const [P, m] = g.geometry.coordinates, x = jr(Zn(P)), T = jr(Rn(m));
      d.push(
        x,
        T,
        // projected point coordinates
        1 / 0,
        // the last zoom the point was processed at
        f,
        // index of the source feature in the original input array
        -1,
        // parent cluster id
        1
        // number of points in a cluster
      ), this.options.reduce && d.push(0);
    }
    let _ = this.trees[u + 1] = this._createTree(d);
    s && console.timeEnd(c);
    for (let f = u; f >= l; f--) {
      const g = +Date.now();
      _ = this.trees[f] = this._createTree(this._cluster(_, f)), s && console.log("z%d: %d clusters in %dms", f, _.numItems, +Date.now() - g);
    }
    return s && console.timeEnd("total time"), this;
  }
  getClusters(i, s) {
    let l = ((i[0] + 180) % 360 + 360) % 360 - 180;
    const u = Math.max(-90, Math.min(90, i[1]));
    let c = i[2] === 180 ? 180 : ((i[2] + 180) % 360 + 360) % 360 - 180;
    const d = Math.max(-90, Math.min(90, i[3]));
    if (i[2] - i[0] >= 360)
      l = -180, c = 180;
    else if (l > c) {
      const m = this.getClusters([l, u, 180, d], s), x = this.getClusters([-180, u, c, d], s);
      return m.concat(x);
    }
    const _ = this.trees[this._limitZoom(s)], f = _.range(Zn(l), Rn(d), Zn(c), Rn(u)), g = _.data, P = [];
    for (const m of f) {
      const x = this.stride * m;
      P.push(g[x + ue] > 1 ? Gr(g, x, this.clusterProps) : this.points[g[x + he]]);
    }
    return P;
  }
  getChildren(i) {
    const s = this._getOriginId(i), l = this._getOriginZoom(i), u = "No cluster with the specified id.", c = this.trees[l];
    if (!c) throw new Error(u);
    const d = c.data;
    if (s * this.stride >= d.length) throw new Error(u);
    const _ = this.options.radius / (this.options.extent * Math.pow(2, l - 1)), f = d[s * this.stride], g = d[s * this.stride + 1], P = c.within(f, g, _), m = [];
    for (const x of P) {
      const T = x * this.stride;
      d[T + Zi] === i && m.push(d[T + ue] > 1 ? Gr(d, T, this.clusterProps) : this.points[d[T + he]]);
    }
    if (m.length === 0) throw new Error(u);
    return m;
  }
  getLeaves(i, s, l) {
    s = s || 10, l = l || 0;
    const u = [];
    return this._appendLeaves(u, i, s, l, 0), u;
  }
  getTile(i, s, l) {
    const u = this.trees[this._limitZoom(i)], c = Math.pow(2, i), { extent: d, radius: _ } = this.options, f = _ / d, g = (l - f) / c, P = (l + 1 + f) / c, m = {
      features: []
    };
    return this._addTileFeatures(
      u.range((s - f) / c, g, (s + 1 + f) / c, P),
      u.data,
      s,
      l,
      c,
      m
    ), s === 0 && this._addTileFeatures(
      u.range(1 - f / c, g, 1, P),
      u.data,
      c,
      l,
      c,
      m
    ), s === c - 1 && this._addTileFeatures(
      u.range(0, g, f / c, P),
      u.data,
      -1,
      l,
      c,
      m
    ), m.features.length ? m : null;
  }
  getClusterExpansionZoom(i) {
    let s = this._getOriginZoom(i) - 1;
    for (; s <= this.options.maxZoom; ) {
      const l = this.getChildren(i);
      if (s++, l.length !== 1) break;
      i = l[0].properties.cluster_id;
    }
    return s;
  }
  _appendLeaves(i, s, l, u, c) {
    const d = this.getChildren(s);
    for (const _ of d) {
      const f = _.properties;
      if (f && f.cluster ? c + f.point_count <= u ? c += f.point_count : c = this._appendLeaves(i, f.cluster_id, l, u, c) : c < u ? c++ : i.push(_), i.length === l) break;
    }
    return c;
  }
  _createTree(i) {
    const s = new io(i.length / this.stride | 0, this.options.nodeSize, Float32Array);
    for (let l = 0; l < i.length; l += this.stride) s.add(i[l], i[l + 1]);
    return s.finish(), s.data = i, s;
  }
  _addTileFeatures(i, s, l, u, c, d) {
    for (const _ of i) {
      const f = _ * this.stride, g = s[f + ue] > 1;
      let P, m, x;
      if (g)
        P = Os(s, f, this.clusterProps), m = s[f], x = s[f + 1];
      else {
        const k = this.points[s[f + he]];
        P = k.properties;
        const [b, M] = k.geometry.coordinates;
        m = Zn(b), x = Rn(M);
      }
      const T = {
        type: 1,
        geometry: [[
          Math.round(this.options.extent * (m * c - l)),
          Math.round(this.options.extent * (x * c - u))
        ]],
        tags: P
      };
      let E;
      g || this.options.generateId ? E = s[f + he] : E = this.points[s[f + he]].id, E !== void 0 && (T.id = E), d.features.push(T);
    }
  }
  _limitZoom(i) {
    return Math.max(this.options.minZoom, Math.min(Math.floor(+i), this.options.maxZoom + 1));
  }
  _cluster(i, s) {
    const { radius: l, extent: u, reduce: c, minPoints: d } = this.options, _ = l / (u * Math.pow(2, s)), f = i.data, g = [], P = this.stride;
    for (let m = 0; m < f.length; m += P) {
      if (f[m + ve] <= s) continue;
      f[m + ve] = s;
      const x = f[m], T = f[m + 1], E = i.within(f[m], f[m + 1], _), k = f[m + ue];
      let b = k;
      for (const M of E) {
        const C = M * P;
        f[C + ve] > s && (b += f[C + ue]);
      }
      if (b > k && b >= d) {
        let M = x * k, C = T * k, O, V = -1;
        const j = ((m / P | 0) << 5) + (s + 1) + this.points.length;
        for (const rt of E) {
          const et = rt * P;
          if (f[et + ve] <= s) continue;
          f[et + ve] = s;
          const pt = f[et + ue];
          M += f[et] * pt, C += f[et + 1] * pt, f[et + Zi] = j, c && (O || (O = this._map(f, m, !0), V = this.clusterProps.length, this.clusterProps.push(O)), c(O, this._map(f, et)));
        }
        f[m + Zi] = j, g.push(M / b, C / b, 1 / 0, j, -1, b), c && g.push(V);
      } else {
        for (let M = 0; M < P; M++) g.push(f[m + M]);
        if (b > 1)
          for (const M of E) {
            const C = M * P;
            if (!(f[C + ve] <= s)) {
              f[C + ve] = s;
              for (let O = 0; O < P; O++) g.push(f[C + O]);
            }
          }
      }
    }
    return g;
  }
  // get index of the point from which the cluster originated
  _getOriginId(i) {
    return i - this.points.length >> 5;
  }
  // get zoom of the point from which the cluster originated
  _getOriginZoom(i) {
    return (i - this.points.length) % 32;
  }
  _map(i, s, l) {
    if (i[s + ue] > 1) {
      const d = this.clusterProps[i[s + Is]];
      return l ? Object.assign({}, d) : d;
    }
    const u = this.points[i[s + he]].properties, c = this.options.map(u);
    return l && c === u ? Object.assign({}, c) : c;
  }
}
function Gr(o, i, s) {
  return {
    type: "Feature",
    id: o[i + he],
    properties: Os(o, i, s),
    geometry: {
      type: "Point",
      coordinates: [ec(o[i]), nc(o[i + 1])]
    }
  };
}
function Os(o, i, s) {
  const l = o[i + ue], u = l >= 1e4 ? `${Math.round(l / 1e3)}k` : l >= 1e3 ? `${Math.round(l / 100) / 10}k` : l, c = o[i + Is], d = c === -1 ? {} : Object.assign({}, s[c]);
  return Object.assign(d, {
    cluster: !0,
    cluster_id: o[i + he],
    point_count: l,
    point_count_abbreviated: u
  });
}
function Zn(o) {
  return o / 360 + 0.5;
}
function Rn(o) {
  const i = Math.sin(o * Math.PI / 180), s = 0.5 - 0.25 * Math.log((1 + i) / (1 - i)) / Math.PI;
  return s < 0 ? 0 : s > 1 ? 1 : s;
}
function ec(o) {
  return (o - 0.5) * 360;
}
function nc(o) {
  const i = (180 - o * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(i)) / Math.PI - 90;
}
function ic(o, i) {
  var s = {};
  for (var l in o) Object.prototype.hasOwnProperty.call(o, l) && i.indexOf(l) < 0 && (s[l] = o[l]);
  if (o != null && typeof Object.getOwnPropertySymbols == "function")
    for (var u = 0, l = Object.getOwnPropertySymbols(o); u < l.length; u++)
      i.indexOf(l[u]) < 0 && Object.prototype.propertyIsEnumerable.call(o, l[u]) && (s[l[u]] = o[l[u]]);
  return s;
}
class Ot {
  static isAdvancedMarkerAvailable(i) {
    return google.maps.marker && i.getMapCapabilities().isAdvancedMarkersAvailable === !0;
  }
  static isAdvancedMarker(i) {
    return google.maps.marker && i instanceof google.maps.marker.AdvancedMarkerElement;
  }
  static setMap(i, s) {
    this.isAdvancedMarker(i) ? i.map = s : i.setMap(s);
  }
  static getPosition(i) {
    if (this.isAdvancedMarker(i)) {
      if (i.position) {
        if (i.position instanceof google.maps.LatLng)
          return i.position;
        if (Number.isFinite(i.position.lat) && Number.isFinite(i.position.lng))
          return new google.maps.LatLng(i.position.lat, i.position.lng);
      }
      return new google.maps.LatLng(null);
    }
    return i.getPosition();
  }
  static getVisible(i) {
    return this.isAdvancedMarker(i) ? !0 : i.getVisible();
  }
}
class ji {
  constructor({ markers: i, position: s }) {
    this.markers = [], i && (this.markers = i), s && (s instanceof google.maps.LatLng ? this._position = s : this._position = new google.maps.LatLng(s));
  }
  get bounds() {
    if (this.markers.length === 0 && !this._position)
      return;
    const i = new google.maps.LatLngBounds(this._position, this._position);
    for (const s of this.markers)
      i.extend(Ot.getPosition(s));
    return i;
  }
  get position() {
    return this._position || this.bounds.getCenter();
  }
  /**
   * Get the count of **visible** markers.
   */
  get count() {
    return this.markers.filter((i) => Ot.getVisible(i)).length;
  }
  /**
   * Add a marker to the cluster.
   */
  push(i) {
    this.markers.push(i);
  }
  /**
   * Cleanup references and remove marker from map.
   */
  delete() {
    this.marker && (Ot.setMap(this.marker, null), this.marker = void 0), this.markers.length = 0;
  }
}
function Gi(o, i = "assertion failed") {
  if (o == null)
    throw Error(i);
}
class oc {
  constructor({ maxZoom: i = 16 }) {
    this.maxZoom = i;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers})
   *    }
   * }
   * ```
   */
  noop({ markers: i }) {
    return rc(i);
  }
}
const rc = (o) => o.map((s) => new ji({
  position: Ot.getPosition(s),
  markers: [s]
}));
class sc extends oc {
  constructor(i) {
    var { maxZoom: s, radius: l = 60 } = i, u = ic(i, ["maxZoom", "radius"]);
    super({ maxZoom: s }), this.markers = [], this.clusters = [], this.state = { zoom: -1 }, this.superCluster = new tc(Object.assign({ maxZoom: this.maxZoom, radius: l }, u));
  }
  calculate(i) {
    let s = !1, l = i.map.getZoom();
    Gi(l), l = Math.round(l);
    const u = { zoom: l };
    if (!Ur(i.markers, this.markers)) {
      s = !0, this.markers = [...i.markers];
      const c = this.markers.map((d) => {
        const _ = Ot.getPosition(d);
        return {
          type: "Feature",
          geometry: { type: "Point", coordinates: [_.lng(), _.lat()] },
          properties: { marker: d }
        };
      });
      this.superCluster.load(c);
    }
    return s || (this.state.zoom <= this.maxZoom || u.zoom <= this.maxZoom) && (s = !Ur(this.state, u)), this.state = u, i.markers.length === 0 ? (this.clusters = [], { clusters: this.clusters, changed: s }) : (s && (this.clusters = this.cluster(i)), { clusters: this.clusters, changed: s });
  }
  cluster({ map: i }) {
    const s = i.getZoom();
    return Gi(s), this.superCluster.getClusters([-180, -90, 180, 90], Math.round(s)).map((l) => this.transformCluster(l));
  }
  transformCluster({ geometry: { coordinates: [i, s] }, properties: l }) {
    if (l.cluster)
      return new ji({
        markers: this.superCluster.getLeaves(l.cluster_id, 1 / 0).map((c) => c.properties.marker),
        position: { lat: s, lng: i }
      });
    const u = l.marker;
    return new ji({
      markers: [u],
      position: Ot.getPosition(u)
    });
  }
}
class ac {
  constructor(i, s) {
    this.markers = { sum: i.length };
    const l = s.map((c) => c.count), u = l.reduce((c, d) => c + d, 0);
    this.clusters = {
      count: s.length,
      markers: {
        mean: u / s.length,
        sum: u,
        min: Math.min(...l),
        max: Math.max(...l)
      }
    };
  }
}
class lc {
  /**
   * The default render function for the library used by {@link MarkerClusterer}.
   *
   * Currently set to use the following:
   *
   * ```typescript
   * // change color if this cluster has more markers than the mean cluster
   * const color =
   *   count > Math.max(10, stats.clusters.markers.mean)
   *     ? "#ff0000"
   *     : "#0000ff";
   *
   * // create svg url with fill color
   * const svg = window.btoa(`
   * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
   *   <circle cx="120" cy="120" opacity=".6" r="70" />
   *   <circle cx="120" cy="120" opacity=".3" r="90" />
   *   <circle cx="120" cy="120" opacity=".2" r="110" />
   *   <circle cx="120" cy="120" opacity=".1" r="130" />
   * </svg>`);
   *
   * // create marker using svg icon
   * return new google.maps.Marker({
   *   position,
   *   icon: {
   *     url: `data:image/svg+xml;base64,${svg}`,
   *     scaledSize: new google.maps.Size(45, 45),
   *   },
   *   label: {
   *     text: String(count),
   *     color: "rgba(255,255,255,0.9)",
   *     fontSize: "12px",
   *   },
   *   // adjust zIndex to be above other markers
   *   zIndex: 1000 + count,
   * });
   * ```
   */
  render({ count: i, position: s }, l, u) {
    const d = `<svg fill="${i > Math.max(10, l.clusters.markers.mean) ? "#ff0000" : "#0000ff"}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${i}</text>
</svg>`, _ = `Cluster of ${i} markers`, f = Number(google.maps.Marker.MAX_ZINDEX) + i;
    if (Ot.isAdvancedMarkerAvailable(u)) {
      const m = new DOMParser().parseFromString(d, "image/svg+xml").documentElement;
      m.setAttribute("transform", "translate(0 25)");
      const x = {
        map: u,
        position: s,
        zIndex: f,
        title: _,
        content: m
      };
      return new google.maps.marker.AdvancedMarkerElement(x);
    }
    const g = {
      position: s,
      zIndex: f,
      title: _,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(d)}`,
        anchor: new google.maps.Point(25, 25)
      }
    };
    return new google.maps.Marker(g);
  }
}
function uc(o, i) {
  for (let s in i.prototype)
    o.prototype[s] = i.prototype[s];
}
class oo {
  constructor() {
    uc(oo, google.maps.OverlayView);
  }
}
var be;
(function(o) {
  o.CLUSTERING_BEGIN = "clusteringbegin", o.CLUSTERING_END = "clusteringend", o.CLUSTER_CLICK = "click", o.GMP_CLICK = "gmp-click";
})(be || (be = {}));
const cc = (o, i, s) => {
  i.bounds && s.fitBounds(i.bounds);
};
class hc extends oo {
  constructor({ map: i, markers: s = [], algorithmOptions: l = {}, algorithm: u = new sc(l), renderer: c = new lc(), onClusterClick: d = cc }) {
    super(), this.map = null, this.idleListener = null, this.markers = [...s], this.clusters = [], this.algorithm = u, this.renderer = c, this.onClusterClick = d, i && this.setMap(i);
  }
  addMarker(i, s) {
    this.markers.includes(i) || (this.markers.push(i), s || this.render());
  }
  addMarkers(i, s) {
    i.forEach((l) => {
      this.addMarker(l, !0);
    }), s || this.render();
  }
  removeMarker(i, s) {
    const l = this.markers.indexOf(i);
    return l === -1 ? !1 : (Ot.setMap(i, null), this.markers.splice(l, 1), s || this.render(), !0);
  }
  removeMarkers(i, s) {
    let l = !1;
    return i.forEach((u) => {
      l = this.removeMarker(u, !0) || l;
    }), l && !s && this.render(), l;
  }
  clearMarkers(i) {
    this.markers.length = 0, i || this.render();
  }
  /**
   * Recalculates and draws all the marker clusters.
   */
  render() {
    const i = this.getMap();
    if (i instanceof google.maps.Map && i.getProjection()) {
      google.maps.event.trigger(this, be.CLUSTERING_BEGIN, this);
      const { clusters: s, changed: l } = this.algorithm.calculate({
        markers: this.markers,
        map: i,
        mapCanvasProjection: this.getProjection()
      });
      if (l || l == null) {
        const u = /* @__PURE__ */ new Set();
        for (const d of s)
          d.markers.length == 1 && u.add(d.markers[0]);
        const c = [];
        for (const d of this.clusters)
          d.marker != null && (d.markers.length == 1 ? u.has(d.marker) || Ot.setMap(d.marker, null) : c.push(d.marker));
        this.clusters = s, this.renderClusters(), requestAnimationFrame(() => c.forEach((d) => Ot.setMap(d, null)));
      }
      google.maps.event.trigger(this, be.CLUSTERING_END, this);
    }
  }
  onAdd() {
    const i = this.getMap();
    Gi(i), this.idleListener = i.addListener("idle", this.render.bind(this)), this.render();
  }
  onRemove() {
    this.idleListener && google.maps.event.removeListener(this.idleListener), this.reset();
  }
  reset() {
    this.markers.forEach((i) => Ot.setMap(i, null)), this.clusters.forEach((i) => i.delete()), this.clusters = [];
  }
  renderClusters() {
    const i = new ac(this.markers, this.clusters), s = this.getMap();
    this.clusters.forEach((l) => {
      if (l.markers.length === 1)
        l.marker = l.markers[0];
      else if (l.marker = this.renderer.render(l, i, s), l.markers.forEach((u) => Ot.setMap(u, null)), this.onClusterClick) {
        const u = Ot.isAdvancedMarker(l.marker) ? be.GMP_CLICK : be.CLUSTER_CLICK;
        l.marker.addListener(
          u,
          /* istanbul ignore next */
          (c) => {
            google.maps.event.trigger(this, be.CLUSTER_CLICK, l), this.onClusterClick(c, l, s);
          }
        );
      }
      Ot.setMap(l.marker, s);
    });
  }
}
let Bn = null;
async function dc(o, i = 1e4) {
  const s = Date.now() + i;
  for (; Date.now() < s; ) {
    if (o()) return !0;
    await new Promise((l) => setTimeout(l, 50));
  }
  return o();
}
function ro(o) {
  const i = o?.trim();
  return i ? Bn || (Bn = (async () => {
    if (typeof window > "u" || typeof document > "u") return null;
    if (!window.google?.maps?.importLibrary) {
      if (!document.querySelector(
        'script[src*="maps.googleapis.com/maps/api/js"]'
      )) {
        const u = document.createElement("script");
        u.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(i)}&loading=async&v=weekly`, u.async = !0, document.head.appendChild(u);
      }
      if (!await dc(() => typeof window.google?.maps?.importLibrary == "function"))
        return console.warn("[installer-locator] Google Maps SDK did not become available"), null;
    }
    try {
      const s = window.google.maps, [l, u, c] = await Promise.all([
        s.importLibrary("core"),
        s.importLibrary("maps"),
        s.importLibrary("marker")
      ]), d = async (g) => {
        try {
          return await s.importLibrary(g);
        } catch (P) {
          return console.info(`[installer-locator] Google "${g}" library unavailable:`, P), null;
        }
      }, [_, f] = await Promise.all([
        d("places"),
        d("geocoding")
      ]);
      return {
        Map: u.Map,
        InfoWindow: u.InfoWindow,
        Marker: c.Marker,
        AdvancedMarkerElement: c.AdvancedMarkerElement,
        Geocoder: f?.Geocoder,
        AutocompleteSuggestion: _?.AutocompleteSuggestion,
        AutocompleteSessionToken: _?.AutocompleteSessionToken,
        LatLngBounds: l.LatLngBounds,
        Point: l.Point,
        Size: l.Size,
        event: l.event
      };
    } catch (s) {
      return console.warn("[installer-locator] Google Maps libraries failed to load", s), null;
    }
  })(), Bn) : Promise.resolve(null);
}
const zs = "M12.4999 0C19.4033 0 25 5.56269 25 12.4239C25 18.3886 19.2458 26.604 14.7355 32.5991C14.1916 33.3214 13.4106 33.7121 12.5 33.7121C11.5894 33.7121 10.8082 33.3225 10.2645 32.5991C5.75424 26.6038 0 18.3898 0 12.4239C0 5.56255 5.59665 0 12.4999 0Z", Zs = "data:image/png;base64,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", Rs = (o) => "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="34" viewBox="0 0 25 33.7121"><path fill-rule="evenodd" clip-rule="evenodd" d="${zs}" fill="#3F1951"` + (o ? ' stroke="#2EAAAB" stroke-width="2"/>' : "/>") + `<image x="2" y="7" width="21" height="10" preserveAspectRatio="xMidYMid meet" href="${Zs}"/></svg>`
);
function fc(o) {
  const i = document.createElement("div");
  return i.className = "locator__pin" + (o ? " locator__pin--selected" : ""), i.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="34" viewBox="0 0 25 33.7121" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="${zs}" fill="#3F1951"` + (o ? ' stroke="#2EAAAB" stroke-width="2"/>' : "/>") + `</svg><img class="locator__pin-logo" src="${Zs}" alt="" />`, i;
}
function _c(o, i) {
  o.classList.toggle("locator__pin--selected", i);
  const s = o.querySelector("path");
  s && (i ? (s.setAttribute("stroke", "#2EAAAB"), s.setAttribute("stroke-width", "2")) : (s.removeAttribute("stroke"), s.removeAttribute("stroke-width")));
}
const pc = [
  // Colours sampled from the approved Figma frame "Find a Dealer / Map"
  // (node 3028:2852). The design is a flat two-tone map, so these are absolute
  // `color` stylers — the previous relative `saturation`/`lightness` shifts
  // only desaturated Google's default palette and never reached these values.
  { elementType: "geometry", stylers: [{ color: "#f2f3f0" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#c2c9cc" }] },
  // Ice reads a shade lighter than land in the design (Greenland, Antarctica).
  { featureType: "landscape.natural.landcover", elementType: "geometry", stylers: [{ color: "#f9f9f8" }] },
  // Labels: grey text with a halo in the surrounding fill so they stay legible
  // over both land and water. Icons off — the design shows text only.
  { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#a0a9b0" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#f2f3f0" }, { weight: 2 }] },
  { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9b9b9b" }] },
  { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#c2c9cc" }, { weight: 2 }] },
  // Country and state outlines only. Parcel and neighbourhood boundaries are
  // noise at every zoom this locator uses.
  { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c8cfd3" }] },
  { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
  { featureType: "administrative.neighborhood", stylers: [{ visibility: "off" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
  { featureType: "transit", stylers: [{ visibility: "off" }] },
  // The Figma frame is a world view, where Google draws no roads at all, so it
  // does not specify them. Roads are kept — but near-invisible — rather than
  // switched off: a buyer who zooms to a city needs street context to place an
  // installer, and an empty beige rectangle would be useless there.
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#e9eae7" }] },
  { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#b4bcc1" }] },
  { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#e2e4e0" }] }
], sn = (o) => o instanceof HTMLElement;
function mc(o, i) {
  const { advanced: s, map: l, position: u, title: c, selected: d } = i;
  return s && o.AdvancedMarkerElement ? new o.AdvancedMarkerElement({
    map: l,
    position: u,
    title: c,
    content: fc(d),
    // Advanced markers are inert unless this is set; the classic Marker is
    // clickable by default, which is an easy difference to miss.
    gmpClickable: !0
  }) : (s && console.warn("[installer-locator] AdvancedMarkerElement unavailable; using classic markers"), new o.Marker({
    map: l,
    position: u,
    icon: { url: Rs(d), anchor: new o.Point(12.5, 34) },
    title: c
  }));
}
function gc(o, i) {
  o.addListener(sn(o) ? "gmp-click" : "click", i);
}
function Ri(o, i) {
  sn(o) ? o.map = i : o.setMap(i);
}
function Vr(o) {
  sn(o) ? o.map = null : o.setMap(null);
}
function vc(o, i) {
  sn(o) ? o.position = i : o.setPosition(i);
}
function yc(o, i, s) {
  if (sn(i)) {
    const l = i.content;
    l instanceof HTMLElement && _c(l, s);
    return;
  }
  i.setIcon({ url: Rs(s), anchor: new o.Point(12.5, 34) });
}
const wc = (o) => function({ count: s, position: l }) {
  const u = s < 10 ? 34 : s < 100 ? 42 : 50, c = u / 2, d = s < 10 ? 13 : s < 100 ? 14 : 13, _ = `<svg xmlns="http://www.w3.org/2000/svg" width="${u}" height="${u}" viewBox="0 0 ${u} ${u}"><circle cx="${c}" cy="${c}" r="${c - 2}" fill="#3F1951" stroke="#2EAAAB" stroke-width="2"/><text x="${c}" y="${c}" text-anchor="middle" dominant-baseline="central" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" font-size="${d}" font-weight="700" fill="#FFFFFF">${s}</text></svg>`;
  return new o.Marker({
    position: l,
    icon: {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(_),
      scaledSize: new o.Size(u, u),
      // Centred on the cluster's position, unlike a pin which points at it.
      anchor: new o.Point(c, c)
    },
    zIndex: 1e3 + s,
    title: `${s} dealers`
  });
}, Bi = (o) => Math.max(0, Math.log2(Math.max(o, 1) / 256)), Ni = 13, ye = 24, $r = 12, Kr = (o) => o.filter((i) => i.latitude != null && i.longitude != null);
function bc({
  installers: o,
  selectedId: i,
  onSelectInstaller: s,
  onSelectCluster: l,
  clustered: u = !0,
  onViewportChange: c,
  onUserMove: d,
  center: _,
  fitBounds: f,
  mapApiKey: g,
  mapId: P
}) {
  const m = J(null), x = J(null), T = J(/* @__PURE__ */ new Map()), E = J(null), k = !!P?.trim(), b = J(null), [M, C] = _t(!1), O = J(null), V = J(o), j = J(_ != null), rt = J(!1), et = J(null), pt = J(l);
  pt.current = l;
  const dt = J(c);
  dt.current = c;
  const mt = J(d);
  mt.current = d;
  const st = J(!1), bt = J(0), ie = J(null), Lt = J(null), oe = J(null), gt = J(0), Bt = J(null);
  V.current = o, j.current = _ != null, rt.current = (f?.length ?? 0) > 0;
  const B = () => {
    const Z = Lt.current, z = m.current;
    if (!Z || !z) return ye;
    const S = Z.getBoundingClientRect(), U = z.getBoundingClientRect();
    if (S.width === 0 || U.width === 0) return ye;
    const D = Math.max(ye, S.right - U.left + 12), H = Math.max(ye, S.bottom - U.top + 12);
    return D > U.width / 2 || H > U.height / 2 ? ye : { top: H, left: D, right: ye, bottom: ye };
  }, kt = (Z, z, S) => {
    const U = O.current;
    if (!U || z.length === 0) return;
    const D = new U.LatLngBounds();
    z.forEach((tt) => D.extend({ lat: tt.latitude, lng: tt.longitude })), Z.fitBounds(D, B());
    const H = bt.current;
    U.event.addListenerOnce(Z, "idle", () => {
      if (bt.current !== H) {
        Bt.current?.();
        return;
      }
      const tt = new U.LatLngBounds();
      z.forEach((Mt) => tt.extend({ lat: Mt.latitude, lng: Mt.longitude })), Z.fitBounds(tt, B()), requestAnimationFrame(() => {
        S != null && (Z.getZoom() ?? 0) > S && Z.setZoom(S), requestAnimationFrame(() => Bt.current?.());
      });
    });
  }, N = (Z) => {
    const z = Kr(V.current);
    if (st.current || j.current || rt.current || z.length === 0) return;
    const S = O.current;
    if (!S) return;
    const U = new S.LatLngBounds();
    z.forEach((D) => U.extend({ lat: D.latitude, lng: D.longitude })), Z.fitBounds(U, 40);
  };
  xt(() => {
    let Z = !1;
    const z = m.current;
    if (!z) return;
    const S = z;
    ro(g).then((D) => {
      if (!(Z || !D || x.current)) {
        if (z.clientWidth === 0 || z.clientHeight === 0) {
          const H = () => {
            Z || x.current || z.clientWidth === 0 || z.clientHeight === 0 || (oe.current?.disconnect(), window.clearInterval(gt.current), U(D));
          }, tt = new ResizeObserver(H);
          tt.observe(z), oe.current = tt, gt.current = window.setInterval(H, 400);
          return;
        }
        U(D);
      }
    }).catch((D) => {
      console.warn("[installer-locator] Google map setup failed:", D);
    });
    function U(D) {
      if (Z || x.current) return;
      O.current = D;
      const H = new D.Map(S, {
        center: { lat: 0, lng: 0 },
        zoom: 2,
        // Google tiles the world horizontally, so zooming out showed the same
        // countries two or three times over. `restriction` clamps panning to a
        // single copy. `strictBounds` is what actually enforces it: it forbids
        // the viewport showing anything outside the bounds, so Google raises the
        // minimum zoom itself to whatever keeps one world filling the canvas.
        //
        // A fixed minZoom cannot do this — the limit depends on how wide the map
        // is. At minZoom 2 the world is 256 * 2^2 = 1024px, so any canvas wider
        // than that tiled it: on a ~1900px map Australia appeared at both edges.
        // 85 degrees is the Mercator limit. A starting minZoom is still given:
        // the real floor is recomputed from the canvas immediately after
        // creation (see setOptions below).
        minZoom: 2,
        restriction: {
          latLngBounds: { north: 85, south: -85, west: -179.9999, east: 179.9999 },
          strictBounds: !0
        },
        // Our own controls are styled to the design; Google's are suppressed.
        zoomControl: !1,
        mapTypeControl: !1,
        streetViewControl: !1,
        fullscreenControl: !1,
        clickableIcons: !1,
        // Passing BOTH a mapId and styles makes Google log a warning and drop
        // the styles, so only ever send one of them.
        ...k ? { mapId: P.trim() } : { styles: pc }
      });
      x.current = H, S.style.opacity = "0";
      const tt = () => {
        window.clearTimeout(Mt), Bt.current = null, S.style.opacity = "";
      };
      Bt.current = tt;
      const Mt = window.setTimeout(tt, 1200);
      H.setOptions({ minZoom: Bi(S.clientWidth) });
      const Et = new ResizeObserver(() => {
        const Zt = Bi(S.clientWidth);
        if (H.setOptions({ minZoom: Zt }), (H.getZoom() ?? Zt) < Zt && H.setZoom(Zt), st.current) return;
        const Rt = et.current;
        Rt && Rt.length > 0 && kt(H, Rt);
      });
      Et.observe(S), ie.current = Et;
      const zt = () => {
        st.current = !0, bt.current += 1;
      };
      S.addEventListener(
        "pointerdown",
        () => {
          st.current = !0;
        },
        { passive: !0 }
      ), D.event.addListener(H, "dragstart", zt), S.addEventListener(
        "wheel",
        () => {
          zt(), mt.current?.();
        },
        { passive: !0 }
      ), D.event.addListener(H, "dragend", () => {
        zt(), mt.current?.();
      }), D.event.addListener(H, "idle", () => {
        if (!st.current) return;
        const Zt = H.getBounds();
        if (!Zt) return;
        const Rt = Zt.getSouthWest(), $t = Zt.getNorthEast();
        dt.current?.({
          south: Rt.lat(),
          west: Rt.lng(),
          north: $t.lat(),
          east: $t.lng()
        });
      }), b.current = new D.InfoWindow({ maxWidth: 260 }), E.current = new hc({
        map: H,
        markers: [],
        onClusterClick: (Zt, Rt) => {
          const $t = new Set(Rt.markers ?? []), Kt = [];
          T.current.forEach((re, Pe) => {
            $t.has(re) && Kt.push(Pe);
          }), Kt.length > 0 && pt.current?.(Kt);
        },
        renderer: { render: wc(D) }
      }), C(!0), N(H);
    }
    return () => {
      Z = !0, oe.current?.disconnect(), oe.current = null, window.clearInterval(gt.current), ie.current?.disconnect(), ie.current = null, E.current?.clearMarkers(!0), E.current = null, T.current.forEach(Vr), T.current.clear(), b.current?.close(), x.current = null;
    };
  }, []), xt(() => {
    const Z = x.current;
    if (!Z) return;
    const z = Kr(o), S = new Set(z.map((H) => H.id));
    T.current.forEach((H, tt) => {
      S.has(tt) || (Vr(H), T.current.delete(tt));
    });
    for (const H of z) {
      const tt = { lat: H.latitude, lng: H.longitude }, Mt = T.current.get(H.id);
      if (Mt) {
        vc(Mt, tt);
        continue;
      }
      const Et = O.current;
      if (!Et) break;
      const zt = mc(Et, {
        advanced: k,
        // No map: the clusterer decides what is on the map and when.
        map: null,
        position: tt,
        title: H.name,
        selected: H.id === i
      });
      if (!zt) break;
      gc(zt, () => s(H.id)), T.current.set(H.id, zt);
    }
    const U = E.current, D = [...T.current.values()];
    if (u) {
      const H = i ? T.current.get(i) ?? null : null;
      D.forEach((tt) => Ri(tt, null)), U?.clearMarkers(!0), U?.addMarkers(D.filter((tt) => tt !== H)), H && Ri(H, Z);
    } else
      U?.clearMarkers(!0), D.forEach((H) => Ri(H, Z));
    N(Z);
  }, [o, s, M, u, i]), xt(() => {
    const Z = x.current, z = O.current;
    if (z && T.current.forEach((D, H) => yc(z, D, H === i)), !Z || !i) {
      b.current?.close();
      return;
    }
    const S = T.current.get(i), U = o.find((D) => D.id === i);
    if (S && U && b.current) {
      const D = m.current?.clientWidth ?? 0;
      D > 0 && b.current.setOptions({ maxWidth: Math.max(140, Math.min(260, D - 96)) }), b.current.setContent(
        `<span class="locator__popup-name">${Pc(U.name)}</span>`
      ), b.current.open({ map: Z, anchor: S });
    }
  }, [i, M]);
  const K = (f ?? []).map((Z) => `${Z.latitude},${Z.longitude}`).join("|");
  xt(() => {
    const Z = x.current;
    if (!Z || !f || f.length === 0) return;
    const z = O.current;
    if (!z) return;
    et.current = f, kt(Z, f, Ni);
    const S = z.event.addListenerOnce(Z, "idle", () => {
      (Z.getZoom() ?? 0) > Ni && Z.setZoom(Ni);
    });
    return () => z.event.removeListener(S);
  }, [K, M]), xt(() => {
    if (f && f.length > 0) return;
    const Z = x.current;
    Z && _ && (Z.panTo({ lat: _.latitude, lng: _.longitude }), (Z.getZoom() ?? 0) < $r && Z.setZoom($r));
  }, [i, _?.latitude, _?.longitude, M]);
  const it = () => Bi(m.current?.clientWidth ?? 0), lt = (Z) => {
    const z = x.current;
    if (!z) return;
    st.current = !0, bt.current += 1, mt.current?.();
    const S = (z.getZoom() ?? 2) + Z;
    z.setZoom(Math.min(21, Math.max(it(), S)));
  };
  return /* @__PURE__ */ y("div", { class: "locator__map locator__map--google", children: [
    /* @__PURE__ */ y("div", { class: "locator__map-canvas", ref: m }),
    /* @__PURE__ */ y("div", { class: "locator__zoom", ref: Lt, children: [
      /* @__PURE__ */ y("button", { type: "button", class: "locator__zoom-btn", "aria-label": "Zoom in", onClick: () => lt(1), children: "+" }),
      /* @__PURE__ */ y("button", { type: "button", class: "locator__zoom-btn", "aria-label": "Zoom out", onClick: () => lt(-1), children: "−" })
    ] })
  ] });
}
const xc = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Pc = (o) => o.replace(/[&<>"']/g, (i) => xc[i]);
var en = { exports: {} };
var Lc = en.exports, Yr;
function Tc() {
  return Yr || (Yr = 1, (function(o, i) {
    (function(s, l) {
      l(i);
    })(Lc, (function(s) {
      var l = "1.9.4";
      function u(t) {
        var e, n, r, a;
        for (n = 1, r = arguments.length; n < r; n++) {
          a = arguments[n];
          for (e in a)
            t[e] = a[e];
        }
        return t;
      }
      var c = Object.create || /* @__PURE__ */ (function() {
        function t() {
        }
        return function(e) {
          return t.prototype = e, new t();
        };
      })();
      function d(t, e) {
        var n = Array.prototype.slice;
        if (t.bind)
          return t.bind.apply(t, n.call(arguments, 1));
        var r = n.call(arguments, 2);
        return function() {
          return t.apply(e, r.length ? r.concat(n.call(arguments)) : arguments);
        };
      }
      var _ = 0;
      function f(t) {
        return "_leaflet_id" in t || (t._leaflet_id = ++_), t._leaflet_id;
      }
      function g(t, e, n) {
        var r, a, h, p;
        return p = function() {
          r = !1, a && (h.apply(n, a), a = !1);
        }, h = function() {
          r ? a = arguments : (t.apply(n, arguments), setTimeout(p, e), r = !0);
        }, h;
      }
      function P(t, e, n) {
        var r = e[1], a = e[0], h = r - a;
        return t === r && n ? t : ((t - a) % h + h) % h + a;
      }
      function m() {
        return !1;
      }
      function x(t, e) {
        if (e === !1)
          return t;
        var n = Math.pow(10, e === void 0 ? 6 : e);
        return Math.round(t * n) / n;
      }
      function T(t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
      }
      function E(t) {
        return T(t).split(/\s+/);
      }
      function k(t, e) {
        Object.prototype.hasOwnProperty.call(t, "options") || (t.options = t.options ? c(t.options) : {});
        for (var n in e)
          t.options[n] = e[n];
        return t.options;
      }
      function b(t, e, n) {
        var r = [];
        for (var a in t)
          r.push(encodeURIComponent(n ? a.toUpperCase() : a) + "=" + encodeURIComponent(t[a]));
        return (!e || e.indexOf("?") === -1 ? "?" : "&") + r.join("&");
      }
      var M = /\{ *([\w_ -]+) *\}/g;
      function C(t, e) {
        return t.replace(M, function(n, r) {
          var a = e[r];
          if (a === void 0)
            throw new Error("No value provided for variable " + n);
          return typeof a == "function" && (a = a(e)), a;
        });
      }
      var O = Array.isArray || function(t) {
        return Object.prototype.toString.call(t) === "[object Array]";
      };
      function V(t, e) {
        for (var n = 0; n < t.length; n++)
          if (t[n] === e)
            return n;
        return -1;
      }
      var j = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
      function rt(t) {
        return window["webkit" + t] || window["moz" + t] || window["ms" + t];
      }
      var et = 0;
      function pt(t) {
        var e = +/* @__PURE__ */ new Date(), n = Math.max(0, 16 - (e - et));
        return et = e + n, window.setTimeout(t, n);
      }
      var dt = window.requestAnimationFrame || rt("RequestAnimationFrame") || pt, mt = window.cancelAnimationFrame || rt("CancelAnimationFrame") || rt("CancelRequestAnimationFrame") || function(t) {
        window.clearTimeout(t);
      };
      function st(t, e, n) {
        if (n && dt === pt)
          t.call(e);
        else
          return dt.call(window, d(t, e));
      }
      function bt(t) {
        t && mt.call(window, t);
      }
      var ie = {
        __proto__: null,
        extend: u,
        create: c,
        bind: d,
        get lastId() {
          return _;
        },
        stamp: f,
        throttle: g,
        wrapNum: P,
        falseFn: m,
        formatNum: x,
        trim: T,
        splitWords: E,
        setOptions: k,
        getParamString: b,
        template: C,
        isArray: O,
        indexOf: V,
        emptyImageUrl: j,
        requestFn: dt,
        cancelFn: mt,
        requestAnimFrame: st,
        cancelAnimFrame: bt
      };
      function Lt() {
      }
      Lt.extend = function(t) {
        var e = function() {
          k(this), this.initialize && this.initialize.apply(this, arguments), this.callInitHooks();
        }, n = e.__super__ = this.prototype, r = c(n);
        r.constructor = e, e.prototype = r;
        for (var a in this)
          Object.prototype.hasOwnProperty.call(this, a) && a !== "prototype" && a !== "__super__" && (e[a] = this[a]);
        return t.statics && u(e, t.statics), t.includes && (oe(t.includes), u.apply(null, [r].concat(t.includes))), u(r, t), delete r.statics, delete r.includes, r.options && (r.options = n.options ? c(n.options) : {}, u(r.options, t.options)), r._initHooks = [], r.callInitHooks = function() {
          if (!this._initHooksCalled) {
            n.callInitHooks && n.callInitHooks.call(this), this._initHooksCalled = !0;
            for (var h = 0, p = r._initHooks.length; h < p; h++)
              r._initHooks[h].call(this);
          }
        }, e;
      }, Lt.include = function(t) {
        var e = this.prototype.options;
        return u(this.prototype, t), t.options && (this.prototype.options = e, this.mergeOptions(t.options)), this;
      }, Lt.mergeOptions = function(t) {
        return u(this.prototype.options, t), this;
      }, Lt.addInitHook = function(t) {
        var e = Array.prototype.slice.call(arguments, 1), n = typeof t == "function" ? t : function() {
          this[t].apply(this, e);
        };
        return this.prototype._initHooks = this.prototype._initHooks || [], this.prototype._initHooks.push(n), this;
      };
      function oe(t) {
        if (!(typeof L > "u" || !L || !L.Mixin)) {
          t = O(t) ? t : [t];
          for (var e = 0; e < t.length; e++)
            t[e] === L.Mixin.Events && console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
        }
      }
      var gt = {
        /* @method on(type: String, fn: Function, context?: Object): this
         * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
         *
         * @alternative
         * @method on(eventMap: Object): this
         * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
         */
        on: function(t, e, n) {
          if (typeof t == "object")
            for (var r in t)
              this._on(r, t[r], e);
          else {
            t = E(t);
            for (var a = 0, h = t.length; a < h; a++)
              this._on(t[a], e, n);
          }
          return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
         * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
         *
         * @alternative
         * @method off(eventMap: Object): this
         * Removes a set of type/listener pairs.
         *
         * @alternative
         * @method off: this
         * Removes all listeners to all events on the object. This includes implicitly attached events.
         */
        off: function(t, e, n) {
          if (!arguments.length)
            delete this._events;
          else if (typeof t == "object")
            for (var r in t)
              this._off(r, t[r], e);
          else {
            t = E(t);
            for (var a = arguments.length === 1, h = 0, p = t.length; h < p; h++)
              a ? this._off(t[h]) : this._off(t[h], e, n);
          }
          return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(t, e, n, r) {
          if (typeof e != "function") {
            console.warn("wrong listener type: " + typeof e);
            return;
          }
          if (this._listens(t, e, n) === !1) {
            n === this && (n = void 0);
            var a = { fn: e, ctx: n };
            r && (a.once = !0), this._events = this._events || {}, this._events[t] = this._events[t] || [], this._events[t].push(a);
          }
        },
        _off: function(t, e, n) {
          var r, a, h;
          if (this._events && (r = this._events[t], !!r)) {
            if (arguments.length === 1) {
              if (this._firingCount)
                for (a = 0, h = r.length; a < h; a++)
                  r[a].fn = m;
              delete this._events[t];
              return;
            }
            if (typeof e != "function") {
              console.warn("wrong listener type: " + typeof e);
              return;
            }
            var p = this._listens(t, e, n);
            if (p !== !1) {
              var v = r[p];
              this._firingCount && (v.fn = m, this._events[t] = r = r.slice()), r.splice(p, 1);
            }
          }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(t, e, n) {
          if (!this.listens(t, n))
            return this;
          var r = u({}, e, {
            type: t,
            target: this,
            sourceTarget: e && e.sourceTarget || this
          });
          if (this._events) {
            var a = this._events[t];
            if (a) {
              this._firingCount = this._firingCount + 1 || 1;
              for (var h = 0, p = a.length; h < p; h++) {
                var v = a[h], w = v.fn;
                v.once && this.off(t, w, v.ctx), w.call(v.ctx || this, r);
              }
              this._firingCount--;
            }
          }
          return n && this._propagateEvent(r), this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(t, e, n, r) {
          typeof t != "string" && console.warn('"string" type argument expected');
          var a = e;
          typeof e != "function" && (r = !!e, a = void 0, n = void 0);
          var h = this._events && this._events[t];
          if (h && h.length && this._listens(t, a, n) !== !1)
            return !0;
          if (r) {
            for (var p in this._eventParents)
              if (this._eventParents[p].listens(t, e, n, r))
                return !0;
          }
          return !1;
        },
        // returns the index (number) or false
        _listens: function(t, e, n) {
          if (!this._events)
            return !1;
          var r = this._events[t] || [];
          if (!e)
            return !!r.length;
          n === this && (n = void 0);
          for (var a = 0, h = r.length; a < h; a++)
            if (r[a].fn === e && r[a].ctx === n)
              return a;
          return !1;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(t, e, n) {
          if (typeof t == "object")
            for (var r in t)
              this._on(r, t[r], e, !0);
          else {
            t = E(t);
            for (var a = 0, h = t.length; a < h; a++)
              this._on(t[a], e, n, !0);
          }
          return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(t) {
          return this._eventParents = this._eventParents || {}, this._eventParents[f(t)] = t, this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(t) {
          return this._eventParents && delete this._eventParents[f(t)], this;
        },
        _propagateEvent: function(t) {
          for (var e in this._eventParents)
            this._eventParents[e].fire(t.type, u({
              layer: t.target,
              propagatedFrom: t.target
            }, t), !0);
        }
      };
      gt.addEventListener = gt.on, gt.removeEventListener = gt.clearAllEventListeners = gt.off, gt.addOneTimeEventListener = gt.once, gt.fireEvent = gt.fire, gt.hasEventListeners = gt.listens;
      var Bt = Lt.extend(gt);
      function B(t, e, n) {
        this.x = n ? Math.round(t) : t, this.y = n ? Math.round(e) : e;
      }
      var kt = Math.trunc || function(t) {
        return t > 0 ? Math.floor(t) : Math.ceil(t);
      };
      B.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
          return new B(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(t) {
          return this.clone()._add(N(t));
        },
        _add: function(t) {
          return this.x += t.x, this.y += t.y, this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(t) {
          return this.clone()._subtract(N(t));
        },
        _subtract: function(t) {
          return this.x -= t.x, this.y -= t.y, this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(t) {
          return this.clone()._divideBy(t);
        },
        _divideBy: function(t) {
          return this.x /= t, this.y /= t, this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(t) {
          return this.clone()._multiplyBy(t);
        },
        _multiplyBy: function(t) {
          return this.x *= t, this.y *= t, this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(t) {
          return new B(this.x * t.x, this.y * t.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(t) {
          return new B(this.x / t.x, this.y / t.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
          return this.clone()._round();
        },
        _round: function() {
          return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
          return this.clone()._floor();
        },
        _floor: function() {
          return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
          return this.clone()._ceil();
        },
        _ceil: function() {
          return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
          return this.clone()._trunc();
        },
        _trunc: function() {
          return this.x = kt(this.x), this.y = kt(this.y), this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(t) {
          t = N(t);
          var e = t.x - this.x, n = t.y - this.y;
          return Math.sqrt(e * e + n * n);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(t) {
          return t = N(t), t.x === this.x && t.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(t) {
          return t = N(t), Math.abs(t.x) <= Math.abs(this.x) && Math.abs(t.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
          return "Point(" + x(this.x) + ", " + x(this.y) + ")";
        }
      };
      function N(t, e, n) {
        return t instanceof B ? t : O(t) ? new B(t[0], t[1]) : t == null ? t : typeof t == "object" && "x" in t && "y" in t ? new B(t.x, t.y) : new B(t, e, n);
      }
      function K(t, e) {
        if (t)
          for (var n = e ? [t, e] : t, r = 0, a = n.length; r < a; r++)
            this.extend(n[r]);
      }
      K.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(t) {
          var e, n;
          if (!t)
            return this;
          if (t instanceof B || typeof t[0] == "number" || "x" in t)
            e = n = N(t);
          else if (t = it(t), e = t.min, n = t.max, !e || !n)
            return this;
          return !this.min && !this.max ? (this.min = e.clone(), this.max = n.clone()) : (this.min.x = Math.min(e.x, this.min.x), this.max.x = Math.max(n.x, this.max.x), this.min.y = Math.min(e.y, this.min.y), this.max.y = Math.max(n.y, this.max.y)), this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(t) {
          return N(
            (this.min.x + this.max.x) / 2,
            (this.min.y + this.max.y) / 2,
            t
          );
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
          return N(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
          return N(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
          return this.min;
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
          return this.max;
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
          return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(t) {
          var e, n;
          return typeof t[0] == "number" || t instanceof B ? t = N(t) : t = it(t), t instanceof K ? (e = t.min, n = t.max) : e = n = t, e.x >= this.min.x && n.x <= this.max.x && e.y >= this.min.y && n.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(t) {
          t = it(t);
          var e = this.min, n = this.max, r = t.min, a = t.max, h = a.x >= e.x && r.x <= n.x, p = a.y >= e.y && r.y <= n.y;
          return h && p;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(t) {
          t = it(t);
          var e = this.min, n = this.max, r = t.min, a = t.max, h = a.x > e.x && r.x < n.x, p = a.y > e.y && r.y < n.y;
          return h && p;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(t) {
          var e = this.min, n = this.max, r = Math.abs(e.x - n.x) * t, a = Math.abs(e.y - n.y) * t;
          return it(
            N(e.x - r, e.y - a),
            N(n.x + r, n.y + a)
          );
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(t) {
          return t ? (t = it(t), this.min.equals(t.getTopLeft()) && this.max.equals(t.getBottomRight())) : !1;
        }
      };
      function it(t, e) {
        return !t || t instanceof K ? t : new K(t, e);
      }
      function lt(t, e) {
        if (t)
          for (var n = e ? [t, e] : t, r = 0, a = n.length; r < a; r++)
            this.extend(n[r]);
      }
      lt.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(t) {
          var e = this._southWest, n = this._northEast, r, a;
          if (t instanceof z)
            r = t, a = t;
          else if (t instanceof lt) {
            if (r = t._southWest, a = t._northEast, !r || !a)
              return this;
          } else
            return t ? this.extend(S(t) || Z(t)) : this;
          return !e && !n ? (this._southWest = new z(r.lat, r.lng), this._northEast = new z(a.lat, a.lng)) : (e.lat = Math.min(r.lat, e.lat), e.lng = Math.min(r.lng, e.lng), n.lat = Math.max(a.lat, n.lat), n.lng = Math.max(a.lng, n.lng)), this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(t) {
          var e = this._southWest, n = this._northEast, r = Math.abs(e.lat - n.lat) * t, a = Math.abs(e.lng - n.lng) * t;
          return new lt(
            new z(e.lat - r, e.lng - a),
            new z(n.lat + r, n.lng + a)
          );
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
          return new z(
            (this._southWest.lat + this._northEast.lat) / 2,
            (this._southWest.lng + this._northEast.lng) / 2
          );
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
          return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
          return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
          return new z(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
          return new z(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
          return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
          return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
          return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
          return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(t) {
          typeof t[0] == "number" || t instanceof z || "lat" in t ? t = S(t) : t = Z(t);
          var e = this._southWest, n = this._northEast, r, a;
          return t instanceof lt ? (r = t.getSouthWest(), a = t.getNorthEast()) : r = a = t, r.lat >= e.lat && a.lat <= n.lat && r.lng >= e.lng && a.lng <= n.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(t) {
          t = Z(t);
          var e = this._southWest, n = this._northEast, r = t.getSouthWest(), a = t.getNorthEast(), h = a.lat >= e.lat && r.lat <= n.lat, p = a.lng >= e.lng && r.lng <= n.lng;
          return h && p;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(t) {
          t = Z(t);
          var e = this._southWest, n = this._northEast, r = t.getSouthWest(), a = t.getNorthEast(), h = a.lat > e.lat && r.lat < n.lat, p = a.lng > e.lng && r.lng < n.lng;
          return h && p;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
          return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(t, e) {
          return t ? (t = Z(t), this._southWest.equals(t.getSouthWest(), e) && this._northEast.equals(t.getNorthEast(), e)) : !1;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
          return !!(this._southWest && this._northEast);
        }
      };
      function Z(t, e) {
        return t instanceof lt ? t : new lt(t, e);
      }
      function z(t, e, n) {
        if (isNaN(t) || isNaN(e))
          throw new Error("Invalid LatLng object: (" + t + ", " + e + ")");
        this.lat = +t, this.lng = +e, n !== void 0 && (this.alt = +n);
      }
      z.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(t, e) {
          if (!t)
            return !1;
          t = S(t);
          var n = Math.max(
            Math.abs(this.lat - t.lat),
            Math.abs(this.lng - t.lng)
          );
          return n <= (e === void 0 ? 1e-9 : e);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(t) {
          return "LatLng(" + x(this.lat, t) + ", " + x(this.lng, t) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(t) {
          return D.distance(this, S(t));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
          return D.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(t) {
          var e = 180 * t / 40075017, n = e / Math.cos(Math.PI / 180 * this.lat);
          return Z(
            [this.lat - e, this.lng - n],
            [this.lat + e, this.lng + n]
          );
        },
        clone: function() {
          return new z(this.lat, this.lng, this.alt);
        }
      };
      function S(t, e, n) {
        return t instanceof z ? t : O(t) && typeof t[0] != "object" ? t.length === 3 ? new z(t[0], t[1], t[2]) : t.length === 2 ? new z(t[0], t[1]) : null : t == null ? t : typeof t == "object" && "lat" in t ? new z(t.lat, "lng" in t ? t.lng : t.lon, t.alt) : e === void 0 ? null : new z(t, e, n);
      }
      var U = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(t, e) {
          var n = this.projection.project(t), r = this.scale(e);
          return this.transformation._transform(n, r);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(t, e) {
          var n = this.scale(e), r = this.transformation.untransform(t, n);
          return this.projection.unproject(r);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(t) {
          return this.projection.project(t);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(t) {
          return this.projection.unproject(t);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(t) {
          return 256 * Math.pow(2, t);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(t) {
          return Math.log(t / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(t) {
          if (this.infinite)
            return null;
          var e = this.projection.bounds, n = this.scale(t), r = this.transformation.transform(e.min, n), a = this.transformation.transform(e.max, n);
          return new K(r, a);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: !1,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(t) {
          var e = this.wrapLng ? P(t.lng, this.wrapLng, !0) : t.lng, n = this.wrapLat ? P(t.lat, this.wrapLat, !0) : t.lat, r = t.alt;
          return new z(n, e, r);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(t) {
          var e = t.getCenter(), n = this.wrapLatLng(e), r = e.lat - n.lat, a = e.lng - n.lng;
          if (r === 0 && a === 0)
            return t;
          var h = t.getSouthWest(), p = t.getNorthEast(), v = new z(h.lat - r, h.lng - a), w = new z(p.lat - r, p.lng - a);
          return new lt(v, w);
        }
      }, D = u({}, U, {
        wrapLng: [-180, 180],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371e3,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(t, e) {
          var n = Math.PI / 180, r = t.lat * n, a = e.lat * n, h = Math.sin((e.lat - t.lat) * n / 2), p = Math.sin((e.lng - t.lng) * n / 2), v = h * h + Math.cos(r) * Math.cos(a) * p * p, w = 2 * Math.atan2(Math.sqrt(v), Math.sqrt(1 - v));
          return this.R * w;
        }
      }), H = 6378137, tt = {
        R: H,
        MAX_LATITUDE: 85.0511287798,
        project: function(t) {
          var e = Math.PI / 180, n = this.MAX_LATITUDE, r = Math.max(Math.min(n, t.lat), -n), a = Math.sin(r * e);
          return new B(
            this.R * t.lng * e,
            this.R * Math.log((1 + a) / (1 - a)) / 2
          );
        },
        unproject: function(t) {
          var e = 180 / Math.PI;
          return new z(
            (2 * Math.atan(Math.exp(t.y / this.R)) - Math.PI / 2) * e,
            t.x * e / this.R
          );
        },
        bounds: (function() {
          var t = H * Math.PI;
          return new K([-t, -t], [t, t]);
        })()
      };
      function Mt(t, e, n, r) {
        if (O(t)) {
          this._a = t[0], this._b = t[1], this._c = t[2], this._d = t[3];
          return;
        }
        this._a = t, this._b = e, this._c = n, this._d = r;
      }
      Mt.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(t, e) {
          return this._transform(t.clone(), e);
        },
        // destructive transform (faster)
        _transform: function(t, e) {
          return e = e || 1, t.x = e * (this._a * t.x + this._b), t.y = e * (this._c * t.y + this._d), t;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(t, e) {
          return e = e || 1, new B(
            (t.x / e - this._b) / this._a,
            (t.y / e - this._d) / this._c
          );
        }
      };
      function Et(t, e, n, r) {
        return new Mt(t, e, n, r);
      }
      var zt = u({}, D, {
        code: "EPSG:3857",
        projection: tt,
        transformation: (function() {
          var t = 0.5 / (Math.PI * tt.R);
          return Et(t, 0.5, -t, 0.5);
        })()
      }), Zt = u({}, zt, {
        code: "EPSG:900913"
      });
      function Rt(t) {
        return document.createElementNS("http://www.w3.org/2000/svg", t);
      }
      function $t(t, e) {
        var n = "", r, a, h, p, v, w;
        for (r = 0, h = t.length; r < h; r++) {
          for (v = t[r], a = 0, p = v.length; a < p; a++)
            w = v[a], n += (a ? "L" : "M") + w.x + " " + w.y;
          n += e ? R.svg ? "z" : "x" : "";
        }
        return n || "M0 0";
      }
      var Kt = document.documentElement.style, re = "ActiveXObject" in window, Pe = re && !document.addEventListener, an = "msLaunchUri" in navigator && !("documentMode" in document), Re = Wt("webkit"), ln = Wt("android"), un = Wt("android 2") || Wt("android 3"), Qn = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10), ti = ln && Wt("Google") && Qn < 537 && !("AudioNode" in window), se = !!window.opera, Be = !an && Wt("chrome"), cn = Wt("gecko") && !Re && !se && !re, ei = !Be && Wt("safari"), hn = Wt("phantom"), dn = "OTransition" in Kt, X = navigator.platform.indexOf("Win") === 0, ot = re && "transition" in Kt, St = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !un, so = "MozPerspective" in Kt, Bs = !window.L_DISABLE_3D && (ot || St || so) && !dn && !hn, Ne = typeof orientation < "u" || Wt("mobile"), Ns = Ne && Re, Ds = Ne && St, ao = !window.PointerEvent && window.MSPointerEvent, lo = !!(window.PointerEvent || ao), uo = "ontouchstart" in window || !!window.TouchEvent, Fs = !window.L_NO_TOUCH && (uo || lo), Hs = Ne && se, Us = Ne && cn, Ws = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1, qs = (function() {
        var t = !1;
        try {
          var e = Object.defineProperty({}, "passive", {
            get: function() {
              t = !0;
            }
          });
          window.addEventListener("testPassiveEventSupport", m, e), window.removeEventListener("testPassiveEventSupport", m, e);
        } catch {
        }
        return t;
      })(), js = (function() {
        return !!document.createElement("canvas").getContext;
      })(), ni = !!(document.createElementNS && Rt("svg").createSVGRect), Gs = !!ni && (function() {
        var t = document.createElement("div");
        return t.innerHTML = "<svg/>", (t.firstChild && t.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
      })(), Vs = !ni && (function() {
        try {
          var t = document.createElement("div");
          t.innerHTML = '<v:shape adj="1"/>';
          var e = t.firstChild;
          return e.style.behavior = "url(#default#VML)", e && typeof e.adj == "object";
        } catch {
          return !1;
        }
      })(), $s = navigator.platform.indexOf("Mac") === 0, Ks = navigator.platform.indexOf("Linux") === 0;
      function Wt(t) {
        return navigator.userAgent.toLowerCase().indexOf(t) >= 0;
      }
      var R = {
        ie: re,
        ielt9: Pe,
        edge: an,
        webkit: Re,
        android: ln,
        android23: un,
        androidStock: ti,
        opera: se,
        chrome: Be,
        gecko: cn,
        safari: ei,
        phantom: hn,
        opera12: dn,
        win: X,
        ie3d: ot,
        webkit3d: St,
        gecko3d: so,
        any3d: Bs,
        mobile: Ne,
        mobileWebkit: Ns,
        mobileWebkit3d: Ds,
        msPointer: ao,
        pointer: lo,
        touch: Fs,
        touchNative: uo,
        mobileOpera: Hs,
        mobileGecko: Us,
        retina: Ws,
        passiveEvents: qs,
        canvas: js,
        svg: ni,
        vml: Vs,
        inlineSvg: Gs,
        mac: $s,
        linux: Ks
      }, co = R.msPointer ? "MSPointerDown" : "pointerdown", ho = R.msPointer ? "MSPointerMove" : "pointermove", fo = R.msPointer ? "MSPointerUp" : "pointerup", _o = R.msPointer ? "MSPointerCancel" : "pointercancel", ii = {
        touchstart: co,
        touchmove: ho,
        touchend: fo,
        touchcancel: _o
      }, po = {
        touchstart: ea,
        touchmove: fn,
        touchend: fn,
        touchcancel: fn
      }, Le = {}, mo = !1;
      function Ys(t, e, n) {
        return e === "touchstart" && ta(), po[e] ? (n = po[e].bind(this, n), t.addEventListener(ii[e], n, !1), n) : (console.warn("wrong event specified:", e), m);
      }
      function Js(t, e, n) {
        if (!ii[e]) {
          console.warn("wrong event specified:", e);
          return;
        }
        t.removeEventListener(ii[e], n, !1);
      }
      function Xs(t) {
        Le[t.pointerId] = t;
      }
      function Qs(t) {
        Le[t.pointerId] && (Le[t.pointerId] = t);
      }
      function go(t) {
        delete Le[t.pointerId];
      }
      function ta() {
        mo || (document.addEventListener(co, Xs, !0), document.addEventListener(ho, Qs, !0), document.addEventListener(fo, go, !0), document.addEventListener(_o, go, !0), mo = !0);
      }
      function fn(t, e) {
        if (e.pointerType !== (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
          e.touches = [];
          for (var n in Le)
            e.touches.push(Le[n]);
          e.changedTouches = [e], t(e);
        }
      }
      function ea(t, e) {
        e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH && Tt(e), fn(t, e);
      }
      function na(t) {
        var e = {}, n, r;
        for (r in t)
          n = t[r], e[r] = n && n.bind ? n.bind(t) : n;
        return t = e, e.type = "dblclick", e.detail = 2, e.isTrusted = !1, e._simulated = !0, e;
      }
      var ia = 200;
      function oa(t, e) {
        t.addEventListener("dblclick", e);
        var n = 0, r;
        function a(h) {
          if (h.detail !== 1) {
            r = h.detail;
            return;
          }
          if (!(h.pointerType === "mouse" || h.sourceCapabilities && !h.sourceCapabilities.firesTouchEvents)) {
            var p = xo(h);
            if (!(p.some(function(w) {
              return w instanceof HTMLLabelElement && w.attributes.for;
            }) && !p.some(function(w) {
              return w instanceof HTMLInputElement || w instanceof HTMLSelectElement;
            }))) {
              var v = Date.now();
              v - n <= ia ? (r++, r === 2 && e(na(h))) : r = 1, n = v;
            }
          }
        }
        return t.addEventListener("click", a), {
          dblclick: e,
          simDblclick: a
        };
      }
      function ra(t, e) {
        t.removeEventListener("dblclick", e.dblclick), t.removeEventListener("click", e.simDblclick);
      }
      var oi = mn(
        ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
      ), De = mn(
        ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
      ), vo = De === "webkitTransition" || De === "OTransition" ? De + "End" : "transitionend";
      function yo(t) {
        return typeof t == "string" ? document.getElementById(t) : t;
      }
      function Fe(t, e) {
        var n = t.style[e] || t.currentStyle && t.currentStyle[e];
        if ((!n || n === "auto") && document.defaultView) {
          var r = document.defaultView.getComputedStyle(t, null);
          n = r ? r[e] : null;
        }
        return n === "auto" ? null : n;
      }
      function Q(t, e, n) {
        var r = document.createElement(t);
        return r.className = e || "", n && n.appendChild(r), r;
      }
      function ut(t) {
        var e = t.parentNode;
        e && e.removeChild(t);
      }
      function _n(t) {
        for (; t.firstChild; )
          t.removeChild(t.firstChild);
      }
      function Te(t) {
        var e = t.parentNode;
        e && e.lastChild !== t && e.appendChild(t);
      }
      function ke(t) {
        var e = t.parentNode;
        e && e.firstChild !== t && e.insertBefore(t, e.firstChild);
      }
      function ri(t, e) {
        if (t.classList !== void 0)
          return t.classList.contains(e);
        var n = pn(t);
        return n.length > 0 && new RegExp("(^|\\s)" + e + "(\\s|$)").test(n);
      }
      function G(t, e) {
        if (t.classList !== void 0)
          for (var n = E(e), r = 0, a = n.length; r < a; r++)
            t.classList.add(n[r]);
        else if (!ri(t, e)) {
          var h = pn(t);
          si(t, (h ? h + " " : "") + e);
        }
      }
      function ft(t, e) {
        t.classList !== void 0 ? t.classList.remove(e) : si(t, T((" " + pn(t) + " ").replace(" " + e + " ", " ")));
      }
      function si(t, e) {
        t.className.baseVal === void 0 ? t.className = e : t.className.baseVal = e;
      }
      function pn(t) {
        return t.correspondingElement && (t = t.correspondingElement), t.className.baseVal === void 0 ? t.className : t.className.baseVal;
      }
      function Nt(t, e) {
        "opacity" in t.style ? t.style.opacity = e : "filter" in t.style && sa(t, e);
      }
      function sa(t, e) {
        var n = !1, r = "DXImageTransform.Microsoft.Alpha";
        try {
          n = t.filters.item(r);
        } catch {
          if (e === 1)
            return;
        }
        e = Math.round(e * 100), n ? (n.Enabled = e !== 100, n.Opacity = e) : t.style.filter += " progid:" + r + "(opacity=" + e + ")";
      }
      function mn(t) {
        for (var e = document.documentElement.style, n = 0; n < t.length; n++)
          if (t[n] in e)
            return t[n];
        return !1;
      }
      function fe(t, e, n) {
        var r = e || new B(0, 0);
        t.style[oi] = (R.ie3d ? "translate(" + r.x + "px," + r.y + "px)" : "translate3d(" + r.x + "px," + r.y + "px,0)") + (n ? " scale(" + n + ")" : "");
      }
      function vt(t, e) {
        t._leaflet_pos = e, R.any3d ? fe(t, e) : (t.style.left = e.x + "px", t.style.top = e.y + "px");
      }
      function _e(t) {
        return t._leaflet_pos || new B(0, 0);
      }
      var He, Ue, ai;
      if ("onselectstart" in document)
        He = function() {
          W(window, "selectstart", Tt);
        }, Ue = function() {
          nt(window, "selectstart", Tt);
        };
      else {
        var We = mn(
          ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
        );
        He = function() {
          if (We) {
            var t = document.documentElement.style;
            ai = t[We], t[We] = "none";
          }
        }, Ue = function() {
          We && (document.documentElement.style[We] = ai, ai = void 0);
        };
      }
      function li() {
        W(window, "dragstart", Tt);
      }
      function ui() {
        nt(window, "dragstart", Tt);
      }
      var gn, ci;
      function hi(t) {
        for (; t.tabIndex === -1; )
          t = t.parentNode;
        t.style && (vn(), gn = t, ci = t.style.outlineStyle, t.style.outlineStyle = "none", W(window, "keydown", vn));
      }
      function vn() {
        gn && (gn.style.outlineStyle = ci, gn = void 0, ci = void 0, nt(window, "keydown", vn));
      }
      function wo(t) {
        do
          t = t.parentNode;
        while ((!t.offsetWidth || !t.offsetHeight) && t !== document.body);
        return t;
      }
      function di(t) {
        var e = t.getBoundingClientRect();
        return {
          x: e.width / t.offsetWidth || 1,
          y: e.height / t.offsetHeight || 1,
          boundingClientRect: e
        };
      }
      var aa = {
        __proto__: null,
        TRANSFORM: oi,
        TRANSITION: De,
        TRANSITION_END: vo,
        get: yo,
        getStyle: Fe,
        create: Q,
        remove: ut,
        empty: _n,
        toFront: Te,
        toBack: ke,
        hasClass: ri,
        addClass: G,
        removeClass: ft,
        setClass: si,
        getClass: pn,
        setOpacity: Nt,
        testProp: mn,
        setTransform: fe,
        setPosition: vt,
        getPosition: _e,
        get disableTextSelection() {
          return He;
        },
        get enableTextSelection() {
          return Ue;
        },
        disableImageDrag: li,
        enableImageDrag: ui,
        preventOutline: hi,
        restoreOutline: vn,
        getSizedParentNode: wo,
        getScale: di
      };
      function W(t, e, n, r) {
        if (e && typeof e == "object")
          for (var a in e)
            _i(t, a, e[a], n);
        else {
          e = E(e);
          for (var h = 0, p = e.length; h < p; h++)
            _i(t, e[h], n, r);
        }
        return this;
      }
      var qt = "_leaflet_events";
      function nt(t, e, n, r) {
        if (arguments.length === 1)
          bo(t), delete t[qt];
        else if (e && typeof e == "object")
          for (var a in e)
            pi(t, a, e[a], n);
        else if (e = E(e), arguments.length === 2)
          bo(t, function(v) {
            return V(e, v) !== -1;
          });
        else
          for (var h = 0, p = e.length; h < p; h++)
            pi(t, e[h], n, r);
        return this;
      }
      function bo(t, e) {
        for (var n in t[qt]) {
          var r = n.split(/\d/)[0];
          (!e || e(r)) && pi(t, r, null, null, n);
        }
      }
      var fi = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
      };
      function _i(t, e, n, r) {
        var a = e + f(n) + (r ? "_" + f(r) : "");
        if (t[qt] && t[qt][a])
          return this;
        var h = function(v) {
          return n.call(r || t, v || window.event);
        }, p = h;
        !R.touchNative && R.pointer && e.indexOf("touch") === 0 ? h = Ys(t, e, h) : R.touch && e === "dblclick" ? h = oa(t, h) : "addEventListener" in t ? e === "touchstart" || e === "touchmove" || e === "wheel" || e === "mousewheel" ? t.addEventListener(fi[e] || e, h, R.passiveEvents ? { passive: !1 } : !1) : e === "mouseenter" || e === "mouseleave" ? (h = function(v) {
          v = v || window.event, gi(t, v) && p(v);
        }, t.addEventListener(fi[e], h, !1)) : t.addEventListener(e, p, !1) : t.attachEvent("on" + e, h), t[qt] = t[qt] || {}, t[qt][a] = h;
      }
      function pi(t, e, n, r, a) {
        a = a || e + f(n) + (r ? "_" + f(r) : "");
        var h = t[qt] && t[qt][a];
        if (!h)
          return this;
        !R.touchNative && R.pointer && e.indexOf("touch") === 0 ? Js(t, e, h) : R.touch && e === "dblclick" ? ra(t, h) : "removeEventListener" in t ? t.removeEventListener(fi[e] || e, h, !1) : t.detachEvent("on" + e, h), t[qt][a] = null;
      }
      function pe(t) {
        return t.stopPropagation ? t.stopPropagation() : t.originalEvent ? t.originalEvent._stopped = !0 : t.cancelBubble = !0, this;
      }
      function mi(t) {
        return _i(t, "wheel", pe), this;
      }
      function qe(t) {
        return W(t, "mousedown touchstart dblclick contextmenu", pe), t._leaflet_disable_click = !0, this;
      }
      function Tt(t) {
        return t.preventDefault ? t.preventDefault() : t.returnValue = !1, this;
      }
      function me(t) {
        return Tt(t), pe(t), this;
      }
      function xo(t) {
        if (t.composedPath)
          return t.composedPath();
        for (var e = [], n = t.target; n; )
          e.push(n), n = n.parentNode;
        return e;
      }
      function Po(t, e) {
        if (!e)
          return new B(t.clientX, t.clientY);
        var n = di(e), r = n.boundingClientRect;
        return new B(
          // offset.left/top values are in page scale (like clientX/Y),
          // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
          (t.clientX - r.left) / n.x - e.clientLeft,
          (t.clientY - r.top) / n.y - e.clientTop
        );
      }
      var la = R.linux && R.chrome ? window.devicePixelRatio : R.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
      function Lo(t) {
        return R.edge ? t.wheelDeltaY / 2 : (
          // Don't trust window-geometry-based delta
          t.deltaY && t.deltaMode === 0 ? -t.deltaY / la : (
            // Pixels
            t.deltaY && t.deltaMode === 1 ? -t.deltaY * 20 : (
              // Lines
              t.deltaY && t.deltaMode === 2 ? -t.deltaY * 60 : (
                // Pages
                t.deltaX || t.deltaZ ? 0 : (
                  // Skip horizontal/depth wheel events
                  t.wheelDelta ? (t.wheelDeltaY || t.wheelDelta) / 2 : (
                    // Legacy IE pixels
                    t.detail && Math.abs(t.detail) < 32765 ? -t.detail * 20 : (
                      // Legacy Moz lines
                      t.detail ? t.detail / -32765 * 60 : (
                        // Legacy Moz pages
                        0
                      )
                    )
                  )
                )
              )
            )
          )
        );
      }
      function gi(t, e) {
        var n = e.relatedTarget;
        if (!n)
          return !0;
        try {
          for (; n && n !== t; )
            n = n.parentNode;
        } catch {
          return !1;
        }
        return n !== t;
      }
      var ua = {
        __proto__: null,
        on: W,
        off: nt,
        stopPropagation: pe,
        disableScrollPropagation: mi,
        disableClickPropagation: qe,
        preventDefault: Tt,
        stop: me,
        getPropagationPath: xo,
        getMousePosition: Po,
        getWheelDelta: Lo,
        isExternalTarget: gi,
        addListener: W,
        removeListener: nt
      }, To = Bt.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(t, e, n, r) {
          this.stop(), this._el = t, this._inProgress = !0, this._duration = n || 0.25, this._easeOutPower = 1 / Math.max(r || 0.5, 0.2), this._startPos = _e(t), this._offset = e.subtract(this._startPos), this._startTime = +/* @__PURE__ */ new Date(), this.fire("start"), this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
          this._inProgress && (this._step(!0), this._complete());
        },
        _animate: function() {
          this._animId = st(this._animate, this), this._step();
        },
        _step: function(t) {
          var e = +/* @__PURE__ */ new Date() - this._startTime, n = this._duration * 1e3;
          e < n ? this._runFrame(this._easeOut(e / n), t) : (this._runFrame(1), this._complete());
        },
        _runFrame: function(t, e) {
          var n = this._startPos.add(this._offset.multiplyBy(t));
          e && n._round(), vt(this._el, n), this.fire("step");
        },
        _complete: function() {
          bt(this._animId), this._inProgress = !1, this.fire("end");
        },
        _easeOut: function(t) {
          return 1 - Math.pow(1 - t, this._easeOutPower);
        }
      }), Y = Bt.extend({
        options: {
          // @section Map State Options
          // @option crs: CRS = L.CRS.EPSG3857
          // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
          // sure what it means.
          crs: zt,
          // @option center: LatLng = undefined
          // Initial geographic center of the map
          center: void 0,
          // @option zoom: Number = undefined
          // Initial map zoom level
          zoom: void 0,
          // @option minZoom: Number = *
          // Minimum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the lowest of their `minZoom` options will be used instead.
          minZoom: void 0,
          // @option maxZoom: Number = *
          // Maximum zoom level of the map.
          // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
          // the highest of their `maxZoom` options will be used instead.
          maxZoom: void 0,
          // @option layers: Layer[] = []
          // Array of layers that will be added to the map initially
          layers: [],
          // @option maxBounds: LatLngBounds = null
          // When this option is set, the map restricts the view to the given
          // geographical bounds, bouncing the user back if the user tries to pan
          // outside the view. To set the restriction dynamically, use
          // [`setMaxBounds`](#map-setmaxbounds) method.
          maxBounds: void 0,
          // @option renderer: Renderer = *
          // The default method for drawing vector layers on the map. `L.SVG`
          // or `L.Canvas` by default depending on browser support.
          renderer: void 0,
          // @section Animation Options
          // @option zoomAnimation: Boolean = true
          // Whether the map zoom animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          zoomAnimation: !0,
          // @option zoomAnimationThreshold: Number = 4
          // Won't animate zoom if the zoom difference exceeds this value.
          zoomAnimationThreshold: 4,
          // @option fadeAnimation: Boolean = true
          // Whether the tile fade animation is enabled. By default it's enabled
          // in all browsers that support CSS3 Transitions except Android.
          fadeAnimation: !0,
          // @option markerZoomAnimation: Boolean = true
          // Whether markers animate their zoom with the zoom animation, if disabled
          // they will disappear for the length of the animation. By default it's
          // enabled in all browsers that support CSS3 Transitions except Android.
          markerZoomAnimation: !0,
          // @option transform3DLimit: Number = 2^23
          // Defines the maximum size of a CSS translation transform. The default
          // value should not be changed unless a web browser positions layers in
          // the wrong place after doing a large `panBy`.
          transform3DLimit: 8388608,
          // Precision limit of a 32-bit float
          // @section Interaction Options
          // @option zoomSnap: Number = 1
          // Forces the map's zoom level to always be a multiple of this, particularly
          // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
          // By default, the zoom level snaps to the nearest integer; lower values
          // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
          // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
          zoomSnap: 1,
          // @option zoomDelta: Number = 1
          // Controls how much the map's zoom level will change after a
          // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
          // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
          // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
          zoomDelta: 1,
          // @option trackResize: Boolean = true
          // Whether the map automatically handles browser window resize to update itself.
          trackResize: !0
        },
        initialize: function(t, e) {
          e = k(this, e), this._handlers = [], this._layers = {}, this._zoomBoundLayers = {}, this._sizeChanged = !0, this._initContainer(t), this._initLayout(), this._onResize = d(this._onResize, this), this._initEvents(), e.maxBounds && this.setMaxBounds(e.maxBounds), e.zoom !== void 0 && (this._zoom = this._limitZoom(e.zoom)), e.center && e.zoom !== void 0 && this.setView(S(e.center), e.zoom, { reset: !0 }), this.callInitHooks(), this._zoomAnimated = De && R.any3d && !R.mobileOpera && this.options.zoomAnimation, this._zoomAnimated && (this._createAnimProxy(), W(this._proxy, vo, this._catchTransitionEnd, this)), this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(t, e, n) {
          if (e = e === void 0 ? this._zoom : this._limitZoom(e), t = this._limitCenter(S(t), e, this.options.maxBounds), n = n || {}, this._stop(), this._loaded && !n.reset && n !== !0) {
            n.animate !== void 0 && (n.zoom = u({ animate: n.animate }, n.zoom), n.pan = u({ animate: n.animate, duration: n.duration }, n.pan));
            var r = this._zoom !== e ? this._tryAnimatedZoom && this._tryAnimatedZoom(t, e, n.zoom) : this._tryAnimatedPan(t, n.pan);
            if (r)
              return clearTimeout(this._sizeTimer), this;
          }
          return this._resetView(t, e, n.pan && n.pan.noMoveStart), this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(t, e) {
          return this._loaded ? this.setView(this.getCenter(), t, { zoom: e }) : (this._zoom = t, this);
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(t, e) {
          return t = t || (R.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom + t, e);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(t, e) {
          return t = t || (R.any3d ? this.options.zoomDelta : 1), this.setZoom(this._zoom - t, e);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(t, e, n) {
          var r = this.getZoomScale(e), a = this.getSize().divideBy(2), h = t instanceof B ? t : this.latLngToContainerPoint(t), p = h.subtract(a).multiplyBy(1 - 1 / r), v = this.containerPointToLatLng(a.add(p));
          return this.setView(v, e, { zoom: n });
        },
        _getBoundsCenterZoom: function(t, e) {
          e = e || {}, t = t.getBounds ? t.getBounds() : Z(t);
          var n = N(e.paddingTopLeft || e.padding || [0, 0]), r = N(e.paddingBottomRight || e.padding || [0, 0]), a = this.getBoundsZoom(t, !1, n.add(r));
          if (a = typeof e.maxZoom == "number" ? Math.min(e.maxZoom, a) : a, a === 1 / 0)
            return {
              center: t.getCenter(),
              zoom: a
            };
          var h = r.subtract(n).divideBy(2), p = this.project(t.getSouthWest(), a), v = this.project(t.getNorthEast(), a), w = this.unproject(p.add(v).divideBy(2).add(h), a);
          return {
            center: w,
            zoom: a
          };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(t, e) {
          if (t = Z(t), !t.isValid())
            throw new Error("Bounds are not valid.");
          var n = this._getBoundsCenterZoom(t, e);
          return this.setView(n.center, n.zoom, e);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(t) {
          return this.fitBounds([[-90, -180], [90, 180]], t);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(t, e) {
          return this.setView(t, this._zoom, { pan: e });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(t, e) {
          if (t = N(t).round(), e = e || {}, !t.x && !t.y)
            return this.fire("moveend");
          if (e.animate !== !0 && !this.getSize().contains(t))
            return this._resetView(this.unproject(this.project(this.getCenter()).add(t)), this.getZoom()), this;
          if (this._panAnim || (this._panAnim = new To(), this._panAnim.on({
            step: this._onPanTransitionStep,
            end: this._onPanTransitionEnd
          }, this)), e.noMoveStart || this.fire("movestart"), e.animate !== !1) {
            G(this._mapPane, "leaflet-pan-anim");
            var n = this._getMapPanePos().subtract(t).round();
            this._panAnim.run(this._mapPane, n, e.duration || 0.25, e.easeLinearity);
          } else
            this._rawPanBy(t), this.fire("move").fire("moveend");
          return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(t, e, n) {
          if (n = n || {}, n.animate === !1 || !R.any3d)
            return this.setView(t, e, n);
          this._stop();
          var r = this.project(this.getCenter()), a = this.project(t), h = this.getSize(), p = this._zoom;
          t = S(t), e = e === void 0 ? p : e;
          var v = Math.max(h.x, h.y), w = v * this.getZoomScale(p, e), A = a.distanceTo(r) || 1, I = 1.42, F = I * I;
          function $(yt) {
            var En = yt ? -1 : 1, Ja = yt ? w : v, Xa = w * w - v * v + En * F * F * A * A, Qa = 2 * Ja * F * A, Ai = Xa / Qa, rr = Math.sqrt(Ai * Ai + 1) - Ai, tl = rr < 1e-9 ? -18 : Math.log(rr);
            return tl;
          }
          function At(yt) {
            return (Math.exp(yt) - Math.exp(-yt)) / 2;
          }
          function Pt(yt) {
            return (Math.exp(yt) + Math.exp(-yt)) / 2;
          }
          function Ft(yt) {
            return At(yt) / Pt(yt);
          }
          var It = $(0);
          function Ie(yt) {
            return v * (Pt(It) / Pt(It + I * yt));
          }
          function Va(yt) {
            return v * (Pt(It) * Ft(It + I * yt) - At(It)) / F;
          }
          function $a(yt) {
            return 1 - Math.pow(1 - yt, 1.5);
          }
          var Ka = Date.now(), ir = ($(1) - It) / I, Ya = n.duration ? 1e3 * n.duration : 1e3 * ir * 0.8;
          function or() {
            var yt = (Date.now() - Ka) / Ya, En = $a(yt) * ir;
            yt <= 1 ? (this._flyToFrame = st(or, this), this._move(
              this.unproject(r.add(a.subtract(r).multiplyBy(Va(En) / A)), p),
              this.getScaleZoom(v / Ie(En), p),
              { flyTo: !0 }
            )) : this._move(t, e)._moveEnd(!0);
          }
          return this._moveStart(!0, n.noMoveStart), or.call(this), this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(t, e) {
          var n = this._getBoundsCenterZoom(t, e);
          return this.flyTo(n.center, n.zoom, e);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(t) {
          return t = Z(t), this.listens("moveend", this._panInsideMaxBounds) && this.off("moveend", this._panInsideMaxBounds), t.isValid() ? (this.options.maxBounds = t, this._loaded && this._panInsideMaxBounds(), this.on("moveend", this._panInsideMaxBounds)) : (this.options.maxBounds = null, this);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(t) {
          var e = this.options.minZoom;
          return this.options.minZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() < this.options.minZoom) ? this.setZoom(t) : this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(t) {
          var e = this.options.maxZoom;
          return this.options.maxZoom = t, this._loaded && e !== t && (this.fire("zoomlevelschange"), this.getZoom() > this.options.maxZoom) ? this.setZoom(t) : this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(t, e) {
          this._enforcingBounds = !0;
          var n = this.getCenter(), r = this._limitCenter(n, this._zoom, Z(t));
          return n.equals(r) || this.panTo(r, e), this._enforcingBounds = !1, this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(t, e) {
          e = e || {};
          var n = N(e.paddingTopLeft || e.padding || [0, 0]), r = N(e.paddingBottomRight || e.padding || [0, 0]), a = this.project(this.getCenter()), h = this.project(t), p = this.getPixelBounds(), v = it([p.min.add(n), p.max.subtract(r)]), w = v.getSize();
          if (!v.contains(h)) {
            this._enforcingBounds = !0;
            var A = h.subtract(v.getCenter()), I = v.extend(h).getSize().subtract(w);
            a.x += A.x < 0 ? -I.x : I.x, a.y += A.y < 0 ? -I.y : I.y, this.panTo(this.unproject(a), e), this._enforcingBounds = !1;
          }
          return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(t) {
          if (!this._loaded)
            return this;
          t = u({
            animate: !1,
            pan: !0
          }, t === !0 ? { animate: !0 } : t);
          var e = this.getSize();
          this._sizeChanged = !0, this._lastCenter = null;
          var n = this.getSize(), r = e.divideBy(2).round(), a = n.divideBy(2).round(), h = r.subtract(a);
          return !h.x && !h.y ? this : (t.animate && t.pan ? this.panBy(h) : (t.pan && this._rawPanBy(h), this.fire("move"), t.debounceMoveend ? (clearTimeout(this._sizeTimer), this._sizeTimer = setTimeout(d(this.fire, this, "moveend"), 200)) : this.fire("moveend")), this.fire("resize", {
            oldSize: e,
            newSize: n
          }));
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
          return this.setZoom(this._limitZoom(this._zoom)), this.options.zoomSnap || this.fire("viewreset"), this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(t) {
          if (t = this._locateOptions = u({
            timeout: 1e4,
            watch: !1
            // setView: false
            // maxZoom: <Number>
            // maximumAge: 0
            // enableHighAccuracy: false
          }, t), !("geolocation" in navigator))
            return this._handleGeolocationError({
              code: 0,
              message: "Geolocation not supported."
            }), this;
          var e = d(this._handleGeolocationResponse, this), n = d(this._handleGeolocationError, this);
          return t.watch ? this._locationWatchId = navigator.geolocation.watchPosition(e, n, t) : navigator.geolocation.getCurrentPosition(e, n, t), this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
          return navigator.geolocation && navigator.geolocation.clearWatch && navigator.geolocation.clearWatch(this._locationWatchId), this._locateOptions && (this._locateOptions.setView = !1), this;
        },
        _handleGeolocationError: function(t) {
          if (this._container._leaflet_id) {
            var e = t.code, n = t.message || (e === 1 ? "permission denied" : e === 2 ? "position unavailable" : "timeout");
            this._locateOptions.setView && !this._loaded && this.fitWorld(), this.fire("locationerror", {
              code: e,
              message: "Geolocation error: " + n + "."
            });
          }
        },
        _handleGeolocationResponse: function(t) {
          if (this._container._leaflet_id) {
            var e = t.coords.latitude, n = t.coords.longitude, r = new z(e, n), a = r.toBounds(t.coords.accuracy * 2), h = this._locateOptions;
            if (h.setView) {
              var p = this.getBoundsZoom(a);
              this.setView(r, h.maxZoom ? Math.min(p, h.maxZoom) : p);
            }
            var v = {
              latlng: r,
              bounds: a,
              timestamp: t.timestamp
            };
            for (var w in t.coords)
              typeof t.coords[w] == "number" && (v[w] = t.coords[w]);
            this.fire("locationfound", v);
          }
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(t, e) {
          if (!e)
            return this;
          var n = this[t] = new e(this);
          return this._handlers.push(n), this.options[t] && n.enable(), this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
          if (this._initEvents(!0), this.options.maxBounds && this.off("moveend", this._panInsideMaxBounds), this._containerId !== this._container._leaflet_id)
            throw new Error("Map container is being reused by another instance");
          try {
            delete this._container._leaflet_id, delete this._containerId;
          } catch {
            this._container._leaflet_id = void 0, this._containerId = void 0;
          }
          this._locationWatchId !== void 0 && this.stopLocate(), this._stop(), ut(this._mapPane), this._clearControlPos && this._clearControlPos(), this._resizeRequest && (bt(this._resizeRequest), this._resizeRequest = null), this._clearHandlers(), this._loaded && this.fire("unload");
          var t;
          for (t in this._layers)
            this._layers[t].remove();
          for (t in this._panes)
            ut(this._panes[t]);
          return this._layers = [], this._panes = [], delete this._mapPane, delete this._renderer, this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(t, e) {
          var n = "leaflet-pane" + (t ? " leaflet-" + t.replace("Pane", "") + "-pane" : ""), r = Q("div", n, e || this._mapPane);
          return t && (this._panes[t] = r), r;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
          return this._checkIfLoaded(), this._lastCenter && !this._moved() ? this._lastCenter.clone() : this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
          return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
          var t = this.getPixelBounds(), e = this.unproject(t.getBottomLeft()), n = this.unproject(t.getTopRight());
          return new lt(e, n);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
          return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
          return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? 1 / 0 : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(t, e, n) {
          t = Z(t), n = N(n || [0, 0]);
          var r = this.getZoom() || 0, a = this.getMinZoom(), h = this.getMaxZoom(), p = t.getNorthWest(), v = t.getSouthEast(), w = this.getSize().subtract(n), A = it(this.project(v, r), this.project(p, r)).getSize(), I = R.any3d ? this.options.zoomSnap : 1, F = w.x / A.x, $ = w.y / A.y, At = e ? Math.max(F, $) : Math.min(F, $);
          return r = this.getScaleZoom(At, r), I && (r = Math.round(r / (I / 100)) * (I / 100), r = e ? Math.ceil(r / I) * I : Math.floor(r / I) * I), Math.max(a, Math.min(h, r));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
          return (!this._size || this._sizeChanged) && (this._size = new B(
            this._container.clientWidth || 0,
            this._container.clientHeight || 0
          ), this._sizeChanged = !1), this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(t, e) {
          var n = this._getTopLeftPoint(t, e);
          return new K(n, n.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
          return this._checkIfLoaded(), this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(t) {
          return this.options.crs.getProjectedBounds(t === void 0 ? this.getZoom() : t);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(t) {
          return typeof t == "string" ? this._panes[t] : t;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
          return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
          return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(t, e) {
          var n = this.options.crs;
          return e = e === void 0 ? this._zoom : e, n.scale(t) / n.scale(e);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(t, e) {
          var n = this.options.crs;
          e = e === void 0 ? this._zoom : e;
          var r = n.zoom(t * n.scale(e));
          return isNaN(r) ? 1 / 0 : r;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(t, e) {
          return e = e === void 0 ? this._zoom : e, this.options.crs.latLngToPoint(S(t), e);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(t, e) {
          return e = e === void 0 ? this._zoom : e, this.options.crs.pointToLatLng(N(t), e);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(t) {
          var e = N(t).add(this.getPixelOrigin());
          return this.unproject(e);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(t) {
          var e = this.project(S(t))._round();
          return e._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(t) {
          return this.options.crs.wrapLatLng(S(t));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(t) {
          return this.options.crs.wrapLatLngBounds(Z(t));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(t, e) {
          return this.options.crs.distance(S(t), S(e));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(t) {
          return N(t).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(t) {
          return N(t).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(t) {
          var e = this.containerPointToLayerPoint(N(t));
          return this.layerPointToLatLng(e);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(t) {
          return this.layerPointToContainerPoint(this.latLngToLayerPoint(S(t)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(t) {
          return Po(t, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(t) {
          return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(t));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(t) {
          return this.layerPointToLatLng(this.mouseEventToLayerPoint(t));
        },
        // map initialization methods
        _initContainer: function(t) {
          var e = this._container = yo(t);
          if (e) {
            if (e._leaflet_id)
              throw new Error("Map container is already initialized.");
          } else throw new Error("Map container not found.");
          W(e, "scroll", this._onScroll, this), this._containerId = f(e);
        },
        _initLayout: function() {
          var t = this._container;
          this._fadeAnimated = this.options.fadeAnimation && R.any3d, G(t, "leaflet-container" + (R.touch ? " leaflet-touch" : "") + (R.retina ? " leaflet-retina" : "") + (R.ielt9 ? " leaflet-oldie" : "") + (R.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
          var e = Fe(t, "position");
          e !== "absolute" && e !== "relative" && e !== "fixed" && e !== "sticky" && (t.style.position = "relative"), this._initPanes(), this._initControlPos && this._initControlPos();
        },
        _initPanes: function() {
          var t = this._panes = {};
          this._paneRenderers = {}, this._mapPane = this.createPane("mapPane", this._container), vt(this._mapPane, new B(0, 0)), this.createPane("tilePane"), this.createPane("overlayPane"), this.createPane("shadowPane"), this.createPane("markerPane"), this.createPane("tooltipPane"), this.createPane("popupPane"), this.options.markerZoomAnimation || (G(t.markerPane, "leaflet-zoom-hide"), G(t.shadowPane, "leaflet-zoom-hide"));
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(t, e, n) {
          vt(this._mapPane, new B(0, 0));
          var r = !this._loaded;
          this._loaded = !0, e = this._limitZoom(e), this.fire("viewprereset");
          var a = this._zoom !== e;
          this._moveStart(a, n)._move(t, e)._moveEnd(a), this.fire("viewreset"), r && this.fire("load");
        },
        _moveStart: function(t, e) {
          return t && this.fire("zoomstart"), e || this.fire("movestart"), this;
        },
        _move: function(t, e, n, r) {
          e === void 0 && (e = this._zoom);
          var a = this._zoom !== e;
          return this._zoom = e, this._lastCenter = t, this._pixelOrigin = this._getNewPixelOrigin(t), r ? n && n.pinch && this.fire("zoom", n) : ((a || n && n.pinch) && this.fire("zoom", n), this.fire("move", n)), this;
        },
        _moveEnd: function(t) {
          return t && this.fire("zoomend"), this.fire("moveend");
        },
        _stop: function() {
          return bt(this._flyToFrame), this._panAnim && this._panAnim.stop(), this;
        },
        _rawPanBy: function(t) {
          vt(this._mapPane, this._getMapPanePos().subtract(t));
        },
        _getZoomSpan: function() {
          return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
          this._enforcingBounds || this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
          if (!this._loaded)
            throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(t) {
          this._targets = {}, this._targets[f(this._container)] = this;
          var e = t ? nt : W;
          e(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this), this.options.trackResize && e(window, "resize", this._onResize, this), R.any3d && this.options.transform3DLimit && (t ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
          bt(this._resizeRequest), this._resizeRequest = st(
            function() {
              this.invalidateSize({ debounceMoveend: !0 });
            },
            this
          );
        },
        _onScroll: function() {
          this._container.scrollTop = 0, this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
          var t = this._getMapPanePos();
          Math.max(Math.abs(t.x), Math.abs(t.y)) >= this.options.transform3DLimit && this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(t, e) {
          for (var n = [], r, a = e === "mouseout" || e === "mouseover", h = t.target || t.srcElement, p = !1; h; ) {
            if (r = this._targets[f(h)], r && (e === "click" || e === "preclick") && this._draggableMoved(r)) {
              p = !0;
              break;
            }
            if (r && r.listens(e, !0) && (a && !gi(h, t) || (n.push(r), a)) || h === this._container)
              break;
            h = h.parentNode;
          }
          return !n.length && !p && !a && this.listens(e, !0) && (n = [this]), n;
        },
        _isClickDisabled: function(t) {
          for (; t && t !== this._container; ) {
            if (t._leaflet_disable_click)
              return !0;
            t = t.parentNode;
          }
        },
        _handleDOMEvent: function(t) {
          var e = t.target || t.srcElement;
          if (!(!this._loaded || e._leaflet_disable_events || t.type === "click" && this._isClickDisabled(e))) {
            var n = t.type;
            n === "mousedown" && hi(e), this._fireDOMEvent(t, n);
          }
        },
        _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
        _fireDOMEvent: function(t, e, n) {
          if (t.type === "click") {
            var r = u({}, t);
            r.type = "preclick", this._fireDOMEvent(r, r.type, n);
          }
          var a = this._findEventTargets(t, e);
          if (n) {
            for (var h = [], p = 0; p < n.length; p++)
              n[p].listens(e, !0) && h.push(n[p]);
            a = h.concat(a);
          }
          if (a.length) {
            e === "contextmenu" && Tt(t);
            var v = a[0], w = {
              originalEvent: t
            };
            if (t.type !== "keypress" && t.type !== "keydown" && t.type !== "keyup") {
              var A = v.getLatLng && (!v._radius || v._radius <= 10);
              w.containerPoint = A ? this.latLngToContainerPoint(v.getLatLng()) : this.mouseEventToContainerPoint(t), w.layerPoint = this.containerPointToLayerPoint(w.containerPoint), w.latlng = A ? v.getLatLng() : this.layerPointToLatLng(w.layerPoint);
            }
            for (p = 0; p < a.length; p++)
              if (a[p].fire(e, w, !0), w.originalEvent._stopped || a[p].options.bubblingMouseEvents === !1 && V(this._mouseEvents, e) !== -1)
                return;
          }
        },
        _draggableMoved: function(t) {
          return t = t.dragging && t.dragging.enabled() ? t : this, t.dragging && t.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
          for (var t = 0, e = this._handlers.length; t < e; t++)
            this._handlers[t].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(t, e) {
          return this._loaded ? t.call(e || this, { target: this }) : this.on("load", t, e), this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
          return _e(this._mapPane) || new B(0, 0);
        },
        _moved: function() {
          var t = this._getMapPanePos();
          return t && !t.equals([0, 0]);
        },
        _getTopLeftPoint: function(t, e) {
          var n = t && e !== void 0 ? this._getNewPixelOrigin(t, e) : this.getPixelOrigin();
          return n.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(t, e) {
          var n = this.getSize()._divideBy(2);
          return this.project(t, e)._subtract(n)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(t, e, n) {
          var r = this._getNewPixelOrigin(n, e);
          return this.project(t, e)._subtract(r);
        },
        _latLngBoundsToNewLayerBounds: function(t, e, n) {
          var r = this._getNewPixelOrigin(n, e);
          return it([
            this.project(t.getSouthWest(), e)._subtract(r),
            this.project(t.getNorthWest(), e)._subtract(r),
            this.project(t.getSouthEast(), e)._subtract(r),
            this.project(t.getNorthEast(), e)._subtract(r)
          ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
          return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(t) {
          return this.latLngToLayerPoint(t).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(t, e, n) {
          if (!n)
            return t;
          var r = this.project(t, e), a = this.getSize().divideBy(2), h = new K(r.subtract(a), r.add(a)), p = this._getBoundsOffset(h, n, e);
          return Math.abs(p.x) <= 1 && Math.abs(p.y) <= 1 ? t : this.unproject(r.add(p), e);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(t, e) {
          if (!e)
            return t;
          var n = this.getPixelBounds(), r = new K(n.min.add(t), n.max.add(t));
          return t.add(this._getBoundsOffset(r, e));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(t, e, n) {
          var r = it(
            this.project(e.getNorthEast(), n),
            this.project(e.getSouthWest(), n)
          ), a = r.min.subtract(t.min), h = r.max.subtract(t.max), p = this._rebound(a.x, -h.x), v = this._rebound(a.y, -h.y);
          return new B(p, v);
        },
        _rebound: function(t, e) {
          return t + e > 0 ? Math.round(t - e) / 2 : Math.max(0, Math.ceil(t)) - Math.max(0, Math.floor(e));
        },
        _limitZoom: function(t) {
          var e = this.getMinZoom(), n = this.getMaxZoom(), r = R.any3d ? this.options.zoomSnap : 1;
          return r && (t = Math.round(t / r) * r), Math.max(e, Math.min(n, t));
        },
        _onPanTransitionStep: function() {
          this.fire("move");
        },
        _onPanTransitionEnd: function() {
          ft(this._mapPane, "leaflet-pan-anim"), this.fire("moveend");
        },
        _tryAnimatedPan: function(t, e) {
          var n = this._getCenterOffset(t)._trunc();
          return (e && e.animate) !== !0 && !this.getSize().contains(n) ? !1 : (this.panBy(n, e), !0);
        },
        _createAnimProxy: function() {
          var t = this._proxy = Q("div", "leaflet-proxy leaflet-zoom-animated");
          this._panes.mapPane.appendChild(t), this.on("zoomanim", function(e) {
            var n = oi, r = this._proxy.style[n];
            fe(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1)), r === this._proxy.style[n] && this._animatingZoom && this._onZoomTransitionEnd();
          }, this), this.on("load moveend", this._animMoveEnd, this), this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
          ut(this._proxy), this.off("load moveend", this._animMoveEnd, this), delete this._proxy;
        },
        _animMoveEnd: function() {
          var t = this.getCenter(), e = this.getZoom();
          fe(this._proxy, this.project(t, e), this.getZoomScale(e, 1));
        },
        _catchTransitionEnd: function(t) {
          this._animatingZoom && t.propertyName.indexOf("transform") >= 0 && this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
          return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(t, e, n) {
          if (this._animatingZoom)
            return !0;
          if (n = n || {}, !this._zoomAnimated || n.animate === !1 || this._nothingToAnimate() || Math.abs(e - this._zoom) > this.options.zoomAnimationThreshold)
            return !1;
          var r = this.getZoomScale(e), a = this._getCenterOffset(t)._divideBy(1 - 1 / r);
          return n.animate !== !0 && !this.getSize().contains(a) ? !1 : (st(function() {
            this._moveStart(!0, n.noMoveStart || !1)._animateZoom(t, e, !0);
          }, this), !0);
        },
        _animateZoom: function(t, e, n, r) {
          this._mapPane && (n && (this._animatingZoom = !0, this._animateToCenter = t, this._animateToZoom = e, G(this._mapPane, "leaflet-zoom-anim")), this.fire("zoomanim", {
            center: t,
            zoom: e,
            noUpdate: r
          }), this._tempFireZoomEvent || (this._tempFireZoomEvent = this._zoom !== this._animateToZoom), this._move(this._animateToCenter, this._animateToZoom, void 0, !0), setTimeout(d(this._onZoomTransitionEnd, this), 250));
        },
        _onZoomTransitionEnd: function() {
          this._animatingZoom && (this._mapPane && ft(this._mapPane, "leaflet-zoom-anim"), this._animatingZoom = !1, this._move(this._animateToCenter, this._animateToZoom, void 0, !0), this._tempFireZoomEvent && this.fire("zoom"), delete this._tempFireZoomEvent, this.fire("move"), this._moveEnd(!0));
        }
      });
      function ca(t, e) {
        return new Y(t, e);
      }
      var Ht = Lt.extend({
        // @section
        // @aka Control Options
        options: {
          // @option position: String = 'topright'
          // The position of the control (one of the map corners). Possible values are `'topleft'`,
          // `'topright'`, `'bottomleft'` or `'bottomright'`
          position: "topright"
        },
        initialize: function(t) {
          k(this, t);
        },
        /* @section
         * Classes extending L.Control will inherit the following methods:
         *
         * @method getPosition: string
         * Returns the position of the control.
         */
        getPosition: function() {
          return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(t) {
          var e = this._map;
          return e && e.removeControl(this), this.options.position = t, e && e.addControl(this), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
          return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(t) {
          this.remove(), this._map = t;
          var e = this._container = this.onAdd(t), n = this.getPosition(), r = t._controlCorners[n];
          return G(e, "leaflet-control"), n.indexOf("bottom") !== -1 ? r.insertBefore(e, r.firstChild) : r.appendChild(e), this._map.on("unload", this.remove, this), this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
          return this._map ? (ut(this._container), this.onRemove && this.onRemove(this._map), this._map.off("unload", this.remove, this), this._map = null, this) : this;
        },
        _refocusOnMap: function(t) {
          this._map && t && t.screenX > 0 && t.screenY > 0 && this._map.getContainer().focus();
        }
      }), je = function(t) {
        return new Ht(t);
      };
      Y.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(t) {
          return t.addTo(this), this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(t) {
          return t.remove(), this;
        },
        _initControlPos: function() {
          var t = this._controlCorners = {}, e = "leaflet-", n = this._controlContainer = Q("div", e + "control-container", this._container);
          function r(a, h) {
            var p = e + a + " " + e + h;
            t[a + h] = Q("div", p, n);
          }
          r("top", "left"), r("top", "right"), r("bottom", "left"), r("bottom", "right");
        },
        _clearControlPos: function() {
          for (var t in this._controlCorners)
            ut(this._controlCorners[t]);
          ut(this._controlContainer), delete this._controlCorners, delete this._controlContainer;
        }
      });
      var ko = Ht.extend({
        // @section
        // @aka Control.Layers options
        options: {
          // @option collapsed: Boolean = true
          // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
          collapsed: !0,
          position: "topright",
          // @option autoZIndex: Boolean = true
          // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
          autoZIndex: !0,
          // @option hideSingleBase: Boolean = false
          // If `true`, the base layers in the control will be hidden when there is only one.
          hideSingleBase: !1,
          // @option sortLayers: Boolean = false
          // Whether to sort the layers. When `false`, layers will keep the order
          // in which they were added to the control.
          sortLayers: !1,
          // @option sortFunction: Function = *
          // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
          // that will be used for sorting the layers, when `sortLayers` is `true`.
          // The function receives both the `L.Layer` instances and their names, as in
          // `sortFunction(layerA, layerB, nameA, nameB)`.
          // By default, it sorts layers alphabetically by their name.
          sortFunction: function(t, e, n, r) {
            return n < r ? -1 : r < n ? 1 : 0;
          }
        },
        initialize: function(t, e, n) {
          k(this, n), this._layerControlInputs = [], this._layers = [], this._lastZIndex = 0, this._handlingClick = !1, this._preventClick = !1;
          for (var r in t)
            this._addLayer(t[r], r);
          for (r in e)
            this._addLayer(e[r], r, !0);
        },
        onAdd: function(t) {
          this._initLayout(), this._update(), this._map = t, t.on("zoomend", this._checkDisabledLayers, this);
          for (var e = 0; e < this._layers.length; e++)
            this._layers[e].layer.on("add remove", this._onLayerChange, this);
          return this._container;
        },
        addTo: function(t) {
          return Ht.prototype.addTo.call(this, t), this._expandIfNotCollapsed();
        },
        onRemove: function() {
          this._map.off("zoomend", this._checkDisabledLayers, this);
          for (var t = 0; t < this._layers.length; t++)
            this._layers[t].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(t, e) {
          return this._addLayer(t, e), this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(t, e) {
          return this._addLayer(t, e, !0), this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(t) {
          t.off("add remove", this._onLayerChange, this);
          var e = this._getLayer(f(t));
          return e && this._layers.splice(this._layers.indexOf(e), 1), this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
          G(this._container, "leaflet-control-layers-expanded"), this._section.style.height = null;
          var t = this._map.getSize().y - (this._container.offsetTop + 50);
          return t < this._section.clientHeight ? (G(this._section, "leaflet-control-layers-scrollbar"), this._section.style.height = t + "px") : ft(this._section, "leaflet-control-layers-scrollbar"), this._checkDisabledLayers(), this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
          return ft(this._container, "leaflet-control-layers-expanded"), this;
        },
        _initLayout: function() {
          var t = "leaflet-control-layers", e = this._container = Q("div", t), n = this.options.collapsed;
          e.setAttribute("aria-haspopup", !0), qe(e), mi(e);
          var r = this._section = Q("section", t + "-list");
          n && (this._map.on("click", this.collapse, this), W(e, {
            mouseenter: this._expandSafely,
            mouseleave: this.collapse
          }, this));
          var a = this._layersLink = Q("a", t + "-toggle", e);
          a.href = "#", a.title = "Layers", a.setAttribute("role", "button"), W(a, {
            keydown: function(h) {
              h.keyCode === 13 && this._expandSafely();
            },
            // Certain screen readers intercept the key event and instead send a click event
            click: function(h) {
              Tt(h), this._expandSafely();
            }
          }, this), n || this.expand(), this._baseLayersList = Q("div", t + "-base", r), this._separator = Q("div", t + "-separator", r), this._overlaysList = Q("div", t + "-overlays", r), e.appendChild(r);
        },
        _getLayer: function(t) {
          for (var e = 0; e < this._layers.length; e++)
            if (this._layers[e] && f(this._layers[e].layer) === t)
              return this._layers[e];
        },
        _addLayer: function(t, e, n) {
          this._map && t.on("add remove", this._onLayerChange, this), this._layers.push({
            layer: t,
            name: e,
            overlay: n
          }), this.options.sortLayers && this._layers.sort(d(function(r, a) {
            return this.options.sortFunction(r.layer, a.layer, r.name, a.name);
          }, this)), this.options.autoZIndex && t.setZIndex && (this._lastZIndex++, t.setZIndex(this._lastZIndex)), this._expandIfNotCollapsed();
        },
        _update: function() {
          if (!this._container)
            return this;
          _n(this._baseLayersList), _n(this._overlaysList), this._layerControlInputs = [];
          var t, e, n, r, a = 0;
          for (n = 0; n < this._layers.length; n++)
            r = this._layers[n], this._addItem(r), e = e || r.overlay, t = t || !r.overlay, a += r.overlay ? 0 : 1;
          return this.options.hideSingleBase && (t = t && a > 1, this._baseLayersList.style.display = t ? "" : "none"), this._separator.style.display = e && t ? "" : "none", this;
        },
        _onLayerChange: function(t) {
          this._handlingClick || this._update();
          var e = this._getLayer(f(t.target)), n = e.overlay ? t.type === "add" ? "overlayadd" : "overlayremove" : t.type === "add" ? "baselayerchange" : null;
          n && this._map.fire(n, e);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(t, e) {
          var n = '<input type="radio" class="leaflet-control-layers-selector" name="' + t + '"' + (e ? ' checked="checked"' : "") + "/>", r = document.createElement("div");
          return r.innerHTML = n, r.firstChild;
        },
        _addItem: function(t) {
          var e = document.createElement("label"), n = this._map.hasLayer(t.layer), r;
          t.overlay ? (r = document.createElement("input"), r.type = "checkbox", r.className = "leaflet-control-layers-selector", r.defaultChecked = n) : r = this._createRadioElement("leaflet-base-layers_" + f(this), n), this._layerControlInputs.push(r), r.layerId = f(t.layer), W(r, "click", this._onInputClick, this);
          var a = document.createElement("span");
          a.innerHTML = " " + t.name;
          var h = document.createElement("span");
          e.appendChild(h), h.appendChild(r), h.appendChild(a);
          var p = t.overlay ? this._overlaysList : this._baseLayersList;
          return p.appendChild(e), this._checkDisabledLayers(), e;
        },
        _onInputClick: function() {
          if (!this._preventClick) {
            var t = this._layerControlInputs, e, n, r = [], a = [];
            this._handlingClick = !0;
            for (var h = t.length - 1; h >= 0; h--)
              e = t[h], n = this._getLayer(e.layerId).layer, e.checked ? r.push(n) : e.checked || a.push(n);
            for (h = 0; h < a.length; h++)
              this._map.hasLayer(a[h]) && this._map.removeLayer(a[h]);
            for (h = 0; h < r.length; h++)
              this._map.hasLayer(r[h]) || this._map.addLayer(r[h]);
            this._handlingClick = !1, this._refocusOnMap();
          }
        },
        _checkDisabledLayers: function() {
          for (var t = this._layerControlInputs, e, n, r = this._map.getZoom(), a = t.length - 1; a >= 0; a--)
            e = t[a], n = this._getLayer(e.layerId).layer, e.disabled = n.options.minZoom !== void 0 && r < n.options.minZoom || n.options.maxZoom !== void 0 && r > n.options.maxZoom;
        },
        _expandIfNotCollapsed: function() {
          return this._map && !this.options.collapsed && this.expand(), this;
        },
        _expandSafely: function() {
          var t = this._section;
          this._preventClick = !0, W(t, "click", Tt), this.expand();
          var e = this;
          setTimeout(function() {
            nt(t, "click", Tt), e._preventClick = !1;
          });
        }
      }), ha = function(t, e, n) {
        return new ko(t, e, n);
      }, vi = Ht.extend({
        // @section
        // @aka Control.Zoom options
        options: {
          position: "topleft",
          // @option zoomInText: String = '<span aria-hidden="true">+</span>'
          // The text set on the 'zoom in' button.
          zoomInText: '<span aria-hidden="true">+</span>',
          // @option zoomInTitle: String = 'Zoom in'
          // The title set on the 'zoom in' button.
          zoomInTitle: "Zoom in",
          // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
          // The text set on the 'zoom out' button.
          zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
          // @option zoomOutTitle: String = 'Zoom out'
          // The title set on the 'zoom out' button.
          zoomOutTitle: "Zoom out"
        },
        onAdd: function(t) {
          var e = "leaflet-control-zoom", n = Q("div", e + " leaflet-bar"), r = this.options;
          return this._zoomInButton = this._createButton(
            r.zoomInText,
            r.zoomInTitle,
            e + "-in",
            n,
            this._zoomIn
          ), this._zoomOutButton = this._createButton(
            r.zoomOutText,
            r.zoomOutTitle,
            e + "-out",
            n,
            this._zoomOut
          ), this._updateDisabled(), t.on("zoomend zoomlevelschange", this._updateDisabled, this), n;
        },
        onRemove: function(t) {
          t.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
          return this._disabled = !0, this._updateDisabled(), this;
        },
        enable: function() {
          return this._disabled = !1, this._updateDisabled(), this;
        },
        _zoomIn: function(t) {
          !this._disabled && this._map._zoom < this._map.getMaxZoom() && this._map.zoomIn(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _zoomOut: function(t) {
          !this._disabled && this._map._zoom > this._map.getMinZoom() && this._map.zoomOut(this._map.options.zoomDelta * (t.shiftKey ? 3 : 1));
        },
        _createButton: function(t, e, n, r, a) {
          var h = Q("a", n, r);
          return h.innerHTML = t, h.href = "#", h.title = e, h.setAttribute("role", "button"), h.setAttribute("aria-label", e), qe(h), W(h, "click", me), W(h, "click", a, this), W(h, "click", this._refocusOnMap, this), h;
        },
        _updateDisabled: function() {
          var t = this._map, e = "leaflet-disabled";
          ft(this._zoomInButton, e), ft(this._zoomOutButton, e), this._zoomInButton.setAttribute("aria-disabled", "false"), this._zoomOutButton.setAttribute("aria-disabled", "false"), (this._disabled || t._zoom === t.getMinZoom()) && (G(this._zoomOutButton, e), this._zoomOutButton.setAttribute("aria-disabled", "true")), (this._disabled || t._zoom === t.getMaxZoom()) && (G(this._zoomInButton, e), this._zoomInButton.setAttribute("aria-disabled", "true"));
        }
      });
      Y.mergeOptions({
        zoomControl: !0
      }), Y.addInitHook(function() {
        this.options.zoomControl && (this.zoomControl = new vi(), this.addControl(this.zoomControl));
      });
      var da = function(t) {
        return new vi(t);
      }, Mo = Ht.extend({
        // @section
        // @aka Control.Scale options
        options: {
          position: "bottomleft",
          // @option maxWidth: Number = 100
          // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
          maxWidth: 100,
          // @option metric: Boolean = True
          // Whether to show the metric scale line (m/km).
          metric: !0,
          // @option imperial: Boolean = True
          // Whether to show the imperial scale line (mi/ft).
          imperial: !0
          // @option updateWhenIdle: Boolean = false
          // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
        },
        onAdd: function(t) {
          var e = "leaflet-control-scale", n = Q("div", e), r = this.options;
          return this._addScales(r, e + "-line", n), t.on(r.updateWhenIdle ? "moveend" : "move", this._update, this), t.whenReady(this._update, this), n;
        },
        onRemove: function(t) {
          t.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(t, e, n) {
          t.metric && (this._mScale = Q("div", e, n)), t.imperial && (this._iScale = Q("div", e, n));
        },
        _update: function() {
          var t = this._map, e = t.getSize().y / 2, n = t.distance(
            t.containerPointToLatLng([0, e]),
            t.containerPointToLatLng([this.options.maxWidth, e])
          );
          this._updateScales(n);
        },
        _updateScales: function(t) {
          this.options.metric && t && this._updateMetric(t), this.options.imperial && t && this._updateImperial(t);
        },
        _updateMetric: function(t) {
          var e = this._getRoundNum(t), n = e < 1e3 ? e + " m" : e / 1e3 + " km";
          this._updateScale(this._mScale, n, e / t);
        },
        _updateImperial: function(t) {
          var e = t * 3.2808399, n, r, a;
          e > 5280 ? (n = e / 5280, r = this._getRoundNum(n), this._updateScale(this._iScale, r + " mi", r / n)) : (a = this._getRoundNum(e), this._updateScale(this._iScale, a + " ft", a / e));
        },
        _updateScale: function(t, e, n) {
          t.style.width = Math.round(this.options.maxWidth * n) + "px", t.innerHTML = e;
        },
        _getRoundNum: function(t) {
          var e = Math.pow(10, (Math.floor(t) + "").length - 1), n = t / e;
          return n = n >= 10 ? 10 : n >= 5 ? 5 : n >= 3 ? 3 : n >= 2 ? 2 : 1, e * n;
        }
      }), fa = function(t) {
        return new Mo(t);
      }, _a = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>', yi = Ht.extend({
        // @section
        // @aka Control.Attribution options
        options: {
          position: "bottomright",
          // @option prefix: String|false = 'Leaflet'
          // The HTML text shown before the attributions. Pass `false` to disable.
          prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (R.inlineSvg ? _a + " " : "") + "Leaflet</a>"
        },
        initialize: function(t) {
          k(this, t), this._attributions = {};
        },
        onAdd: function(t) {
          t.attributionControl = this, this._container = Q("div", "leaflet-control-attribution"), qe(this._container);
          for (var e in t._layers)
            t._layers[e].getAttribution && this.addAttribution(t._layers[e].getAttribution());
          return this._update(), t.on("layeradd", this._addAttribution, this), this._container;
        },
        onRemove: function(t) {
          t.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(t) {
          t.layer.getAttribution && (this.addAttribution(t.layer.getAttribution()), t.layer.once("remove", function() {
            this.removeAttribution(t.layer.getAttribution());
          }, this));
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(t) {
          return this.options.prefix = t, this._update(), this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(t) {
          return t ? (this._attributions[t] || (this._attributions[t] = 0), this._attributions[t]++, this._update(), this) : this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(t) {
          return t ? (this._attributions[t] && (this._attributions[t]--, this._update()), this) : this;
        },
        _update: function() {
          if (this._map) {
            var t = [];
            for (var e in this._attributions)
              this._attributions[e] && t.push(e);
            var n = [];
            this.options.prefix && n.push(this.options.prefix), t.length && n.push(t.join(", ")), this._container.innerHTML = n.join(' <span aria-hidden="true">|</span> ');
          }
        }
      });
      Y.mergeOptions({
        attributionControl: !0
      }), Y.addInitHook(function() {
        this.options.attributionControl && new yi().addTo(this);
      });
      var pa = function(t) {
        return new yi(t);
      };
      Ht.Layers = ko, Ht.Zoom = vi, Ht.Scale = Mo, Ht.Attribution = yi, je.layers = ha, je.zoom = da, je.scale = fa, je.attribution = pa;
      var jt = Lt.extend({
        initialize: function(t) {
          this._map = t;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
          return this._enabled ? this : (this._enabled = !0, this.addHooks(), this);
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
          return this._enabled ? (this._enabled = !1, this.removeHooks(), this) : this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
          return !!this._enabled;
        }
        // @section Extension methods
        // Classes inheriting from `Handler` must implement the two following methods:
        // @method addHooks()
        // Called when the handler is enabled, should add event hooks.
        // @method removeHooks()
        // Called when the handler is disabled, should remove the event hooks added previously.
      });
      jt.addTo = function(t, e) {
        return t.addHandler(e, this), this;
      };
      var ma = { Events: gt }, Ao = R.touch ? "touchstart mousedown" : "mousedown", ae = Bt.extend({
        options: {
          // @section
          // @aka Draggable options
          // @option clickTolerance: Number = 3
          // The max number of pixels a user can shift the mouse pointer during a click
          // for it to be considered a valid click (as opposed to a mouse drag).
          clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(t, e, n, r) {
          k(this, r), this._element = t, this._dragStartTarget = e || t, this._preventOutline = n;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
          this._enabled || (W(this._dragStartTarget, Ao, this._onDown, this), this._enabled = !0);
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
          this._enabled && (ae._dragging === this && this.finishDrag(!0), nt(this._dragStartTarget, Ao, this._onDown, this), this._enabled = !1, this._moved = !1);
        },
        _onDown: function(t) {
          if (this._enabled && (this._moved = !1, !ri(this._element, "leaflet-zoom-anim"))) {
            if (t.touches && t.touches.length !== 1) {
              ae._dragging === this && this.finishDrag();
              return;
            }
            if (!(ae._dragging || t.shiftKey || t.which !== 1 && t.button !== 1 && !t.touches) && (ae._dragging = this, this._preventOutline && hi(this._element), li(), He(), !this._moving)) {
              this.fire("down");
              var e = t.touches ? t.touches[0] : t, n = wo(this._element);
              this._startPoint = new B(e.clientX, e.clientY), this._startPos = _e(this._element), this._parentScale = di(n);
              var r = t.type === "mousedown";
              W(document, r ? "mousemove" : "touchmove", this._onMove, this), W(document, r ? "mouseup" : "touchend touchcancel", this._onUp, this);
            }
          }
        },
        _onMove: function(t) {
          if (this._enabled) {
            if (t.touches && t.touches.length > 1) {
              this._moved = !0;
              return;
            }
            var e = t.touches && t.touches.length === 1 ? t.touches[0] : t, n = new B(e.clientX, e.clientY)._subtract(this._startPoint);
            !n.x && !n.y || Math.abs(n.x) + Math.abs(n.y) < this.options.clickTolerance || (n.x /= this._parentScale.x, n.y /= this._parentScale.y, Tt(t), this._moved || (this.fire("dragstart"), this._moved = !0, G(document.body, "leaflet-dragging"), this._lastTarget = t.target || t.srcElement, window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance && (this._lastTarget = this._lastTarget.correspondingUseElement), G(this._lastTarget, "leaflet-drag-target")), this._newPos = this._startPos.add(n), this._moving = !0, this._lastEvent = t, this._updatePosition());
          }
        },
        _updatePosition: function() {
          var t = { originalEvent: this._lastEvent };
          this.fire("predrag", t), vt(this._element, this._newPos), this.fire("drag", t);
        },
        _onUp: function() {
          this._enabled && this.finishDrag();
        },
        finishDrag: function(t) {
          ft(document.body, "leaflet-dragging"), this._lastTarget && (ft(this._lastTarget, "leaflet-drag-target"), this._lastTarget = null), nt(document, "mousemove touchmove", this._onMove, this), nt(document, "mouseup touchend touchcancel", this._onUp, this), ui(), Ue();
          var e = this._moved && this._moving;
          this._moving = !1, ae._dragging = !1, e && this.fire("dragend", {
            noInertia: t,
            distance: this._newPos.distanceTo(this._startPos)
          });
        }
      });
      function Co(t, e, n) {
        var r, a = [1, 4, 2, 8], h, p, v, w, A, I, F, $;
        for (h = 0, I = t.length; h < I; h++)
          t[h]._code = ge(t[h], e);
        for (v = 0; v < 4; v++) {
          for (F = a[v], r = [], h = 0, I = t.length, p = I - 1; h < I; p = h++)
            w = t[h], A = t[p], w._code & F ? A._code & F || ($ = yn(A, w, F, e, n), $._code = ge($, e), r.push($)) : (A._code & F && ($ = yn(A, w, F, e, n), $._code = ge($, e), r.push($)), r.push(w));
          t = r;
        }
        return t;
      }
      function Eo(t, e) {
        var n, r, a, h, p, v, w, A, I;
        if (!t || t.length === 0)
          throw new Error("latlngs not passed");
        Dt(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        var F = S([0, 0]), $ = Z(t), At = $.getNorthWest().distanceTo($.getSouthWest()) * $.getNorthEast().distanceTo($.getNorthWest());
        At < 1700 && (F = wi(t));
        var Pt = t.length, Ft = [];
        for (n = 0; n < Pt; n++) {
          var It = S(t[n]);
          Ft.push(e.project(S([It.lat - F.lat, It.lng - F.lng])));
        }
        for (v = w = A = 0, n = 0, r = Pt - 1; n < Pt; r = n++)
          a = Ft[n], h = Ft[r], p = a.y * h.x - h.y * a.x, w += (a.x + h.x) * p, A += (a.y + h.y) * p, v += p * 3;
        v === 0 ? I = Ft[0] : I = [w / v, A / v];
        var Ie = e.unproject(N(I));
        return S([Ie.lat + F.lat, Ie.lng + F.lng]);
      }
      function wi(t) {
        for (var e = 0, n = 0, r = 0, a = 0; a < t.length; a++) {
          var h = S(t[a]);
          e += h.lat, n += h.lng, r++;
        }
        return S([e / r, n / r]);
      }
      var ga = {
        __proto__: null,
        clipPolygon: Co,
        polygonCenter: Eo,
        centroid: wi
      };
      function So(t, e) {
        if (!e || !t.length)
          return t.slice();
        var n = e * e;
        return t = wa(t, n), t = ya(t, n), t;
      }
      function Io(t, e, n) {
        return Math.sqrt(Ge(t, e, n, !0));
      }
      function va(t, e, n) {
        return Ge(t, e, n);
      }
      function ya(t, e) {
        var n = t.length, r = typeof Uint8Array < "u" ? Uint8Array : Array, a = new r(n);
        a[0] = a[n - 1] = 1, bi(t, a, e, 0, n - 1);
        var h, p = [];
        for (h = 0; h < n; h++)
          a[h] && p.push(t[h]);
        return p;
      }
      function bi(t, e, n, r, a) {
        var h = 0, p, v, w;
        for (v = r + 1; v <= a - 1; v++)
          w = Ge(t[v], t[r], t[a], !0), w > h && (p = v, h = w);
        h > n && (e[p] = 1, bi(t, e, n, r, p), bi(t, e, n, p, a));
      }
      function wa(t, e) {
        for (var n = [t[0]], r = 1, a = 0, h = t.length; r < h; r++)
          ba(t[r], t[a]) > e && (n.push(t[r]), a = r);
        return a < h - 1 && n.push(t[h - 1]), n;
      }
      var Oo;
      function zo(t, e, n, r, a) {
        var h = r ? Oo : ge(t, n), p = ge(e, n), v, w, A;
        for (Oo = p; ; ) {
          if (!(h | p))
            return [t, e];
          if (h & p)
            return !1;
          v = h || p, w = yn(t, e, v, n, a), A = ge(w, n), v === h ? (t = w, h = A) : (e = w, p = A);
        }
      }
      function yn(t, e, n, r, a) {
        var h = e.x - t.x, p = e.y - t.y, v = r.min, w = r.max, A, I;
        return n & 8 ? (A = t.x + h * (w.y - t.y) / p, I = w.y) : n & 4 ? (A = t.x + h * (v.y - t.y) / p, I = v.y) : n & 2 ? (A = w.x, I = t.y + p * (w.x - t.x) / h) : n & 1 && (A = v.x, I = t.y + p * (v.x - t.x) / h), new B(A, I, a);
      }
      function ge(t, e) {
        var n = 0;
        return t.x < e.min.x ? n |= 1 : t.x > e.max.x && (n |= 2), t.y < e.min.y ? n |= 4 : t.y > e.max.y && (n |= 8), n;
      }
      function ba(t, e) {
        var n = e.x - t.x, r = e.y - t.y;
        return n * n + r * r;
      }
      function Ge(t, e, n, r) {
        var a = e.x, h = e.y, p = n.x - a, v = n.y - h, w = p * p + v * v, A;
        return w > 0 && (A = ((t.x - a) * p + (t.y - h) * v) / w, A > 1 ? (a = n.x, h = n.y) : A > 0 && (a += p * A, h += v * A)), p = t.x - a, v = t.y - h, r ? p * p + v * v : new B(a, h);
      }
      function Dt(t) {
        return !O(t[0]) || typeof t[0][0] != "object" && typeof t[0][0] < "u";
      }
      function Zo(t) {
        return console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead."), Dt(t);
      }
      function Ro(t, e) {
        var n, r, a, h, p, v, w, A;
        if (!t || t.length === 0)
          throw new Error("latlngs not passed");
        Dt(t) || (console.warn("latlngs are not flat! Only the first ring will be used"), t = t[0]);
        var I = S([0, 0]), F = Z(t), $ = F.getNorthWest().distanceTo(F.getSouthWest()) * F.getNorthEast().distanceTo(F.getNorthWest());
        $ < 1700 && (I = wi(t));
        var At = t.length, Pt = [];
        for (n = 0; n < At; n++) {
          var Ft = S(t[n]);
          Pt.push(e.project(S([Ft.lat - I.lat, Ft.lng - I.lng])));
        }
        for (n = 0, r = 0; n < At - 1; n++)
          r += Pt[n].distanceTo(Pt[n + 1]) / 2;
        if (r === 0)
          A = Pt[0];
        else
          for (n = 0, h = 0; n < At - 1; n++)
            if (p = Pt[n], v = Pt[n + 1], a = p.distanceTo(v), h += a, h > r) {
              w = (h - r) / a, A = [
                v.x - w * (v.x - p.x),
                v.y - w * (v.y - p.y)
              ];
              break;
            }
        var It = e.unproject(N(A));
        return S([It.lat + I.lat, It.lng + I.lng]);
      }
      var xa = {
        __proto__: null,
        simplify: So,
        pointToSegmentDistance: Io,
        closestPointOnSegment: va,
        clipSegment: zo,
        _getEdgeIntersection: yn,
        _getBitCode: ge,
        _sqClosestPointOnSegment: Ge,
        isFlat: Dt,
        _flat: Zo,
        polylineCenter: Ro
      }, xi = {
        project: function(t) {
          return new B(t.lng, t.lat);
        },
        unproject: function(t) {
          return new z(t.y, t.x);
        },
        bounds: new K([-180, -90], [180, 90])
      }, Pi = {
        R: 6378137,
        R_MINOR: 6356752314245179e-9,
        bounds: new K([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
        project: function(t) {
          var e = Math.PI / 180, n = this.R, r = t.lat * e, a = this.R_MINOR / n, h = Math.sqrt(1 - a * a), p = h * Math.sin(r), v = Math.tan(Math.PI / 4 - r / 2) / Math.pow((1 - p) / (1 + p), h / 2);
          return r = -n * Math.log(Math.max(v, 1e-10)), new B(t.lng * e * n, r);
        },
        unproject: function(t) {
          for (var e = 180 / Math.PI, n = this.R, r = this.R_MINOR / n, a = Math.sqrt(1 - r * r), h = Math.exp(-t.y / n), p = Math.PI / 2 - 2 * Math.atan(h), v = 0, w = 0.1, A; v < 15 && Math.abs(w) > 1e-7; v++)
            A = a * Math.sin(p), A = Math.pow((1 - A) / (1 + A), a / 2), w = Math.PI / 2 - 2 * Math.atan(h * A) - p, p += w;
          return new z(p * e, t.x * e / n);
        }
      }, Pa = {
        __proto__: null,
        LonLat: xi,
        Mercator: Pi,
        SphericalMercator: tt
      }, La = u({}, D, {
        code: "EPSG:3395",
        projection: Pi,
        transformation: (function() {
          var t = 0.5 / (Math.PI * Pi.R);
          return Et(t, 0.5, -t, 0.5);
        })()
      }), Bo = u({}, D, {
        code: "EPSG:4326",
        projection: xi,
        transformation: Et(1 / 180, 1, -1 / 180, 0.5)
      }), Ta = u({}, U, {
        projection: xi,
        transformation: Et(1, 0, -1, 0),
        scale: function(t) {
          return Math.pow(2, t);
        },
        zoom: function(t) {
          return Math.log(t) / Math.LN2;
        },
        distance: function(t, e) {
          var n = e.lng - t.lng, r = e.lat - t.lat;
          return Math.sqrt(n * n + r * r);
        },
        infinite: !0
      });
      U.Earth = D, U.EPSG3395 = La, U.EPSG3857 = zt, U.EPSG900913 = Zt, U.EPSG4326 = Bo, U.Simple = Ta;
      var Ut = Bt.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
          // @option pane: String = 'overlayPane'
          // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
          pane: "overlayPane",
          // @option attribution: String = null
          // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
          attribution: null,
          bubblingMouseEvents: !0
        },
        /* @section
         * Classes extending `L.Layer` will inherit the following methods:
         *
         * @method addTo(map: Map|LayerGroup): this
         * Adds the layer to the given map or layer group.
         */
        addTo: function(t) {
          return t.addLayer(this), this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
          return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(t) {
          return t && t.removeLayer(this), this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(t) {
          return this._map.getPane(t ? this.options[t] || t : this.options.pane);
        },
        addInteractiveTarget: function(t) {
          return this._map._targets[f(t)] = this, this;
        },
        removeInteractiveTarget: function(t) {
          return delete this._map._targets[f(t)], this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
          return this.options.attribution;
        },
        _layerAdd: function(t) {
          var e = t.target;
          if (e.hasLayer(this)) {
            if (this._map = e, this._zoomAnimated = e._zoomAnimated, this.getEvents) {
              var n = this.getEvents();
              e.on(n, this), this.once("remove", function() {
                e.off(n, this);
              }, this);
            }
            this.onAdd(e), this.fire("add"), e.fire("layeradd", { layer: this });
          }
        }
      });
      Y.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(t) {
          if (!t._layerAdd)
            throw new Error("The provided object is not a Layer.");
          var e = f(t);
          return this._layers[e] ? this : (this._layers[e] = t, t._mapToAdd = this, t.beforeAdd && t.beforeAdd(this), this.whenReady(t._layerAdd, t), this);
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(t) {
          var e = f(t);
          return this._layers[e] ? (this._loaded && t.onRemove(this), delete this._layers[e], this._loaded && (this.fire("layerremove", { layer: t }), t.fire("remove")), t._map = t._mapToAdd = null, this) : this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(t) {
          return f(t) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
         * Iterates over the layers of the map, optionally specifying context of the iterator function.
         * ```
         * map.eachLayer(function(layer){
         *     layer.bindPopup('Hello');
         * });
         * ```
         */
        eachLayer: function(t, e) {
          for (var n in this._layers)
            t.call(e, this._layers[n]);
          return this;
        },
        _addLayers: function(t) {
          t = t ? O(t) ? t : [t] : [];
          for (var e = 0, n = t.length; e < n; e++)
            this.addLayer(t[e]);
        },
        _addZoomLimit: function(t) {
          (!isNaN(t.options.maxZoom) || !isNaN(t.options.minZoom)) && (this._zoomBoundLayers[f(t)] = t, this._updateZoomLevels());
        },
        _removeZoomLimit: function(t) {
          var e = f(t);
          this._zoomBoundLayers[e] && (delete this._zoomBoundLayers[e], this._updateZoomLevels());
        },
        _updateZoomLevels: function() {
          var t = 1 / 0, e = -1 / 0, n = this._getZoomSpan();
          for (var r in this._zoomBoundLayers) {
            var a = this._zoomBoundLayers[r].options;
            t = a.minZoom === void 0 ? t : Math.min(t, a.minZoom), e = a.maxZoom === void 0 ? e : Math.max(e, a.maxZoom);
          }
          this._layersMaxZoom = e === -1 / 0 ? void 0 : e, this._layersMinZoom = t === 1 / 0 ? void 0 : t, n !== this._getZoomSpan() && this.fire("zoomlevelschange"), this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom && this.setZoom(this._layersMaxZoom), this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom && this.setZoom(this._layersMinZoom);
        }
      });
      var Me = Ut.extend({
        initialize: function(t, e) {
          k(this, e), this._layers = {};
          var n, r;
          if (t)
            for (n = 0, r = t.length; n < r; n++)
              this.addLayer(t[n]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(t) {
          var e = this.getLayerId(t);
          return this._layers[e] = t, this._map && this._map.addLayer(t), this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(t) {
          var e = t in this._layers ? t : this.getLayerId(t);
          return this._map && this._layers[e] && this._map.removeLayer(this._layers[e]), delete this._layers[e], this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(t) {
          var e = typeof t == "number" ? t : this.getLayerId(t);
          return e in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
          return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(t) {
          var e = Array.prototype.slice.call(arguments, 1), n, r;
          for (n in this._layers)
            r = this._layers[n], r[t] && r[t].apply(r, e);
          return this;
        },
        onAdd: function(t) {
          this.eachLayer(t.addLayer, t);
        },
        onRemove: function(t) {
          this.eachLayer(t.removeLayer, t);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(t, e) {
          for (var n in this._layers)
            t.call(e, this._layers[n]);
          return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(t) {
          return this._layers[t];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
          var t = [];
          return this.eachLayer(t.push, t), t;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(t) {
          return this.invoke("setZIndex", t);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(t) {
          return f(t);
        }
      }), ka = function(t, e) {
        return new Me(t, e);
      }, Yt = Me.extend({
        addLayer: function(t) {
          return this.hasLayer(t) ? this : (t.addEventParent(this), Me.prototype.addLayer.call(this, t), this.fire("layeradd", { layer: t }));
        },
        removeLayer: function(t) {
          return this.hasLayer(t) ? (t in this._layers && (t = this._layers[t]), t.removeEventParent(this), Me.prototype.removeLayer.call(this, t), this.fire("layerremove", { layer: t })) : this;
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(t) {
          return this.invoke("setStyle", t);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
          return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
          return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
          var t = new lt();
          for (var e in this._layers) {
            var n = this._layers[e];
            t.extend(n.getBounds ? n.getBounds() : n.getLatLng());
          }
          return t;
        }
      }), Ma = function(t, e) {
        return new Yt(t, e);
      }, Ae = Lt.extend({
        /* @section
         * @aka Icon options
         *
         * @option iconUrl: String = null
         * **(required)** The URL to the icon image (absolute or relative to your script path).
         *
         * @option iconRetinaUrl: String = null
         * The URL to a retina sized version of the icon image (absolute or relative to your
         * script path). Used for Retina screen devices.
         *
         * @option iconSize: Point = null
         * Size of the icon image in pixels.
         *
         * @option iconAnchor: Point = null
         * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
         * will be aligned so that this point is at the marker's geographical location. Centered
         * by default if size is specified, also can be set in CSS with negative margins.
         *
         * @option popupAnchor: Point = [0, 0]
         * The coordinates of the point from which popups will "open", relative to the icon anchor.
         *
         * @option tooltipAnchor: Point = [0, 0]
         * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
         *
         * @option shadowUrl: String = null
         * The URL to the icon shadow image. If not specified, no shadow image will be created.
         *
         * @option shadowRetinaUrl: String = null
         *
         * @option shadowSize: Point = null
         * Size of the shadow image in pixels.
         *
         * @option shadowAnchor: Point = null
         * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
         * as iconAnchor if not specified).
         *
         * @option className: String = ''
         * A custom class name to assign to both icon and shadow images. Empty by default.
         */
        options: {
          popupAnchor: [0, 0],
          tooltipAnchor: [0, 0],
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1
        },
        initialize: function(t) {
          k(this, t);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(t) {
          return this._createIcon("icon", t);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(t) {
          return this._createIcon("shadow", t);
        },
        _createIcon: function(t, e) {
          var n = this._getIconUrl(t);
          if (!n) {
            if (t === "icon")
              throw new Error("iconUrl not set in Icon options (see the docs).");
            return null;
          }
          var r = this._createImg(n, e && e.tagName === "IMG" ? e : null);
          return this._setIconStyles(r, t), (this.options.crossOrigin || this.options.crossOrigin === "") && (r.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), r;
        },
        _setIconStyles: function(t, e) {
          var n = this.options, r = n[e + "Size"];
          typeof r == "number" && (r = [r, r]);
          var a = N(r), h = N(e === "shadow" && n.shadowAnchor || n.iconAnchor || a && a.divideBy(2, !0));
          t.className = "leaflet-marker-" + e + " " + (n.className || ""), h && (t.style.marginLeft = -h.x + "px", t.style.marginTop = -h.y + "px"), a && (t.style.width = a.x + "px", t.style.height = a.y + "px");
        },
        _createImg: function(t, e) {
          return e = e || document.createElement("img"), e.src = t, e;
        },
        _getIconUrl: function(t) {
          return R.retina && this.options[t + "RetinaUrl"] || this.options[t + "Url"];
        }
      });
      function Aa(t) {
        return new Ae(t);
      }
      var Ve = Ae.extend({
        options: {
          iconUrl: "marker-icon.png",
          iconRetinaUrl: "marker-icon-2x.png",
          shadowUrl: "marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          tooltipAnchor: [16, -28],
          shadowSize: [41, 41]
        },
        _getIconUrl: function(t) {
          return typeof Ve.imagePath != "string" && (Ve.imagePath = this._detectIconPath()), (this.options.imagePath || Ve.imagePath) + Ae.prototype._getIconUrl.call(this, t);
        },
        _stripUrl: function(t) {
          var e = function(n, r, a) {
            var h = r.exec(n);
            return h && h[a];
          };
          return t = e(t, /^url\((['"])?(.+)\1\)$/, 2), t && e(t, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
          var t = Q("div", "leaflet-default-icon-path", document.body), e = Fe(t, "background-image") || Fe(t, "backgroundImage");
          if (document.body.removeChild(t), e = this._stripUrl(e), e)
            return e;
          var n = document.querySelector('link[href$="leaflet.css"]');
          return n ? n.href.substring(0, n.href.length - 11 - 1) : "";
        }
      }), No = jt.extend({
        initialize: function(t) {
          this._marker = t;
        },
        addHooks: function() {
          var t = this._marker._icon;
          this._draggable || (this._draggable = new ae(t, t, !0)), this._draggable.on({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).enable(), G(t, "leaflet-marker-draggable");
        },
        removeHooks: function() {
          this._draggable.off({
            dragstart: this._onDragStart,
            predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
          }, this).disable(), this._marker._icon && ft(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(t) {
          var e = this._marker, n = e._map, r = this._marker.options.autoPanSpeed, a = this._marker.options.autoPanPadding, h = _e(e._icon), p = n.getPixelBounds(), v = n.getPixelOrigin(), w = it(
            p.min._subtract(v).add(a),
            p.max._subtract(v).subtract(a)
          );
          if (!w.contains(h)) {
            var A = N(
              (Math.max(w.max.x, h.x) - w.max.x) / (p.max.x - w.max.x) - (Math.min(w.min.x, h.x) - w.min.x) / (p.min.x - w.min.x),
              (Math.max(w.max.y, h.y) - w.max.y) / (p.max.y - w.max.y) - (Math.min(w.min.y, h.y) - w.min.y) / (p.min.y - w.min.y)
            ).multiplyBy(r);
            n.panBy(A, { animate: !1 }), this._draggable._newPos._add(A), this._draggable._startPos._add(A), vt(e._icon, this._draggable._newPos), this._onDrag(t), this._panRequest = st(this._adjustPan.bind(this, t));
          }
        },
        _onDragStart: function() {
          this._oldLatLng = this._marker.getLatLng(), this._marker.closePopup && this._marker.closePopup(), this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(t) {
          this._marker.options.autoPan && (bt(this._panRequest), this._panRequest = st(this._adjustPan.bind(this, t)));
        },
        _onDrag: function(t) {
          var e = this._marker, n = e._shadow, r = _e(e._icon), a = e._map.layerPointToLatLng(r);
          n && vt(n, r), e._latlng = a, t.latlng = a, t.oldLatLng = this._oldLatLng, e.fire("move", t).fire("drag", t);
        },
        _onDragEnd: function(t) {
          bt(this._panRequest), delete this._oldLatLng, this._marker.fire("moveend").fire("dragend", t);
        }
      }), wn = Ut.extend({
        // @section
        // @aka Marker options
        options: {
          // @option icon: Icon = *
          // Icon instance to use for rendering the marker.
          // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
          // If not specified, a common instance of `L.Icon.Default` is used.
          icon: new Ve(),
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option keyboard: Boolean = true
          // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
          keyboard: !0,
          // @option title: String = ''
          // Text for the browser tooltip that appear on marker hover (no tooltip by default).
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          title: "",
          // @option alt: String = 'Marker'
          // Text for the `alt` attribute of the icon image.
          // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
          alt: "Marker",
          // @option zIndexOffset: Number = 0
          // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
          zIndexOffset: 0,
          // @option opacity: Number = 1.0
          // The opacity of the marker.
          opacity: 1,
          // @option riseOnHover: Boolean = false
          // If `true`, the marker will get on top of others when you hover the mouse over it.
          riseOnHover: !1,
          // @option riseOffset: Number = 250
          // The z-index offset used for the `riseOnHover` feature.
          riseOffset: 250,
          // @option pane: String = 'markerPane'
          // `Map pane` where the markers icon will be added.
          pane: "markerPane",
          // @option shadowPane: String = 'shadowPane'
          // `Map pane` where the markers shadow will be added.
          shadowPane: "shadowPane",
          // @option bubblingMouseEvents: Boolean = false
          // When `true`, a mouse event on this marker will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !1,
          // @option autoPanOnFocus: Boolean = true
          // When `true`, the map will pan whenever the marker is focused (via
          // e.g. pressing `tab` on the keyboard) to ensure the marker is
          // visible within the map's bounds
          autoPanOnFocus: !0,
          // @section Draggable marker options
          // @option draggable: Boolean = false
          // Whether the marker is draggable with mouse/touch or not.
          draggable: !1,
          // @option autoPan: Boolean = false
          // Whether to pan the map when dragging this marker near its edge or not.
          autoPan: !1,
          // @option autoPanPadding: Point = Point(50, 50)
          // Distance (in pixels to the left/right and to the top/bottom) of the
          // map edge to start panning the map.
          autoPanPadding: [50, 50],
          // @option autoPanSpeed: Number = 10
          // Number of pixels the map should pan by.
          autoPanSpeed: 10
        },
        /* @section
         *
         * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
         */
        initialize: function(t, e) {
          k(this, e), this._latlng = S(t);
        },
        onAdd: function(t) {
          this._zoomAnimated = this._zoomAnimated && t.options.markerZoomAnimation, this._zoomAnimated && t.on("zoomanim", this._animateZoom, this), this._initIcon(), this.update();
        },
        onRemove: function(t) {
          this.dragging && this.dragging.enabled() && (this.options.draggable = !0, this.dragging.removeHooks()), delete this.dragging, this._zoomAnimated && t.off("zoomanim", this._animateZoom, this), this._removeIcon(), this._removeShadow();
        },
        getEvents: function() {
          return {
            zoom: this.update,
            viewreset: this.update
          };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(t) {
          var e = this._latlng;
          return this._latlng = S(t), this.update(), this.fire("move", { oldLatLng: e, latlng: this._latlng });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(t) {
          return this.options.zIndexOffset = t, this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
          return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(t) {
          return this.options.icon = t, this._map && (this._initIcon(), this.update()), this._popup && this.bindPopup(this._popup, this._popup.options), this;
        },
        getElement: function() {
          return this._icon;
        },
        update: function() {
          if (this._icon && this._map) {
            var t = this._map.latLngToLayerPoint(this._latlng).round();
            this._setPos(t);
          }
          return this;
        },
        _initIcon: function() {
          var t = this.options, e = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide"), n = t.icon.createIcon(this._icon), r = !1;
          n !== this._icon && (this._icon && this._removeIcon(), r = !0, t.title && (n.title = t.title), n.tagName === "IMG" && (n.alt = t.alt || "")), G(n, e), t.keyboard && (n.tabIndex = "0", n.setAttribute("role", "button")), this._icon = n, t.riseOnHover && this.on({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && W(n, "focus", this._panOnFocus, this);
          var a = t.icon.createShadow(this._shadow), h = !1;
          a !== this._shadow && (this._removeShadow(), h = !0), a && (G(a, e), a.alt = ""), this._shadow = a, t.opacity < 1 && this._updateOpacity(), r && this.getPane().appendChild(this._icon), this._initInteraction(), a && h && this.getPane(t.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
          this.options.riseOnHover && this.off({
            mouseover: this._bringToFront,
            mouseout: this._resetZIndex
          }), this.options.autoPanOnFocus && nt(this._icon, "focus", this._panOnFocus, this), ut(this._icon), this.removeInteractiveTarget(this._icon), this._icon = null;
        },
        _removeShadow: function() {
          this._shadow && ut(this._shadow), this._shadow = null;
        },
        _setPos: function(t) {
          this._icon && vt(this._icon, t), this._shadow && vt(this._shadow, t), this._zIndex = t.y + this.options.zIndexOffset, this._resetZIndex();
        },
        _updateZIndex: function(t) {
          this._icon && (this._icon.style.zIndex = this._zIndex + t);
        },
        _animateZoom: function(t) {
          var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center).round();
          this._setPos(e);
        },
        _initInteraction: function() {
          if (this.options.interactive && (G(this._icon, "leaflet-interactive"), this.addInteractiveTarget(this._icon), No)) {
            var t = this.options.draggable;
            this.dragging && (t = this.dragging.enabled(), this.dragging.disable()), this.dragging = new No(this), t && this.dragging.enable();
          }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(t) {
          return this.options.opacity = t, this._map && this._updateOpacity(), this;
        },
        _updateOpacity: function() {
          var t = this.options.opacity;
          this._icon && Nt(this._icon, t), this._shadow && Nt(this._shadow, t);
        },
        _bringToFront: function() {
          this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
          this._updateZIndex(0);
        },
        _panOnFocus: function() {
          var t = this._map;
          if (t) {
            var e = this.options.icon.options, n = e.iconSize ? N(e.iconSize) : N(0, 0), r = e.iconAnchor ? N(e.iconAnchor) : N(0, 0);
            t.panInside(this._latlng, {
              paddingTopLeft: r,
              paddingBottomRight: n.subtract(r)
            });
          }
        },
        _getPopupAnchor: function() {
          return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
          return this.options.icon.options.tooltipAnchor;
        }
      });
      function Ca(t, e) {
        return new wn(t, e);
      }
      var le = Ut.extend({
        // @section
        // @aka Path options
        options: {
          // @option stroke: Boolean = true
          // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
          stroke: !0,
          // @option color: String = '#3388ff'
          // Stroke color
          color: "#3388ff",
          // @option weight: Number = 3
          // Stroke width in pixels
          weight: 3,
          // @option opacity: Number = 1.0
          // Stroke opacity
          opacity: 1,
          // @option lineCap: String= 'round'
          // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
          lineCap: "round",
          // @option lineJoin: String = 'round'
          // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
          lineJoin: "round",
          // @option dashArray: String = null
          // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashArray: null,
          // @option dashOffset: String = null
          // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
          dashOffset: null,
          // @option fill: Boolean = depends
          // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
          fill: !1,
          // @option fillColor: String = *
          // Fill color. Defaults to the value of the [`color`](#path-color) option
          fillColor: null,
          // @option fillOpacity: Number = 0.2
          // Fill opacity.
          fillOpacity: 0.2,
          // @option fillRule: String = 'evenodd'
          // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
          fillRule: "evenodd",
          // className: '',
          // Option inherited from "Interactive layer" abstract class
          interactive: !0,
          // @option bubblingMouseEvents: Boolean = true
          // When `true`, a mouse event on this path will trigger the same event on the map
          // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
          bubblingMouseEvents: !0
        },
        beforeAdd: function(t) {
          this._renderer = t.getRenderer(this);
        },
        onAdd: function() {
          this._renderer._initPath(this), this._reset(), this._renderer._addPath(this);
        },
        onRemove: function() {
          this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
          return this._map && this._renderer._updatePath(this), this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(t) {
          return k(this, t), this._renderer && (this._renderer._updateStyle(this), this.options.stroke && t && Object.prototype.hasOwnProperty.call(t, "weight") && this._updateBounds()), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
          return this._renderer && this._renderer._bringToFront(this), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
          return this._renderer && this._renderer._bringToBack(this), this;
        },
        getElement: function() {
          return this._path;
        },
        _reset: function() {
          this._project(), this._update();
        },
        _clickTolerance: function() {
          return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
      }), bn = le.extend({
        // @section
        // @aka CircleMarker options
        options: {
          fill: !0,
          // @option radius: Number = 10
          // Radius of the circle marker, in pixels
          radius: 10
        },
        initialize: function(t, e) {
          k(this, e), this._latlng = S(t), this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(t) {
          var e = this._latlng;
          return this._latlng = S(t), this.redraw(), this.fire("move", { oldLatLng: e, latlng: this._latlng });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
          return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(t) {
          return this.options.radius = this._radius = t, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
          return this._radius;
        },
        setStyle: function(t) {
          var e = t && t.radius || this._radius;
          return le.prototype.setStyle.call(this, t), this.setRadius(e), this;
        },
        _project: function() {
          this._point = this._map.latLngToLayerPoint(this._latlng), this._updateBounds();
        },
        _updateBounds: function() {
          var t = this._radius, e = this._radiusY || t, n = this._clickTolerance(), r = [t + n, e + n];
          this._pxBounds = new K(this._point.subtract(r), this._point.add(r));
        },
        _update: function() {
          this._map && this._updatePath();
        },
        _updatePath: function() {
          this._renderer._updateCircle(this);
        },
        _empty: function() {
          return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(t) {
          return t.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
      });
      function Ea(t, e) {
        return new bn(t, e);
      }
      var Li = bn.extend({
        initialize: function(t, e, n) {
          if (typeof e == "number" && (e = u({}, n, { radius: e })), k(this, e), this._latlng = S(t), isNaN(this.options.radius))
            throw new Error("Circle radius cannot be NaN");
          this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(t) {
          return this._mRadius = t, this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
          return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          var t = [this._radius, this._radiusY || this._radius];
          return new lt(
            this._map.layerPointToLatLng(this._point.subtract(t)),
            this._map.layerPointToLatLng(this._point.add(t))
          );
        },
        setStyle: le.prototype.setStyle,
        _project: function() {
          var t = this._latlng.lng, e = this._latlng.lat, n = this._map, r = n.options.crs;
          if (r.distance === D.distance) {
            var a = Math.PI / 180, h = this._mRadius / D.R / a, p = n.project([e + h, t]), v = n.project([e - h, t]), w = p.add(v).divideBy(2), A = n.unproject(w).lat, I = Math.acos((Math.cos(h * a) - Math.sin(e * a) * Math.sin(A * a)) / (Math.cos(e * a) * Math.cos(A * a))) / a;
            (isNaN(I) || I === 0) && (I = h / Math.cos(Math.PI / 180 * e)), this._point = w.subtract(n.getPixelOrigin()), this._radius = isNaN(I) ? 0 : w.x - n.project([A, t - I]).x, this._radiusY = w.y - p.y;
          } else {
            var F = r.unproject(r.project(this._latlng).subtract([this._mRadius, 0]));
            this._point = n.latLngToLayerPoint(this._latlng), this._radius = this._point.x - n.latLngToLayerPoint(F).x;
          }
          this._updateBounds();
        }
      });
      function Sa(t, e, n) {
        return new Li(t, e, n);
      }
      var Jt = le.extend({
        // @section
        // @aka Polyline options
        options: {
          // @option smoothFactor: Number = 1.0
          // How much to simplify the polyline on each zoom level. More means
          // better performance and smoother look, and less means more accurate representation.
          smoothFactor: 1,
          // @option noClip: Boolean = false
          // Disable polyline clipping.
          noClip: !1
        },
        initialize: function(t, e) {
          k(this, e), this._setLatLngs(t);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
          return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(t) {
          return this._setLatLngs(t), this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
          return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(t) {
          for (var e = 1 / 0, n = null, r = Ge, a, h, p = 0, v = this._parts.length; p < v; p++)
            for (var w = this._parts[p], A = 1, I = w.length; A < I; A++) {
              a = w[A - 1], h = w[A];
              var F = r(t, a, h, !0);
              F < e && (e = F, n = r(t, a, h));
            }
          return n && (n.distance = Math.sqrt(e)), n;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return Ro(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
          return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(t, e) {
          return e = e || this._defaultShape(), t = S(t), e.push(t), this._bounds.extend(t), this.redraw();
        },
        _setLatLngs: function(t) {
          this._bounds = new lt(), this._latlngs = this._convertLatLngs(t);
        },
        _defaultShape: function() {
          return Dt(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(t) {
          for (var e = [], n = Dt(t), r = 0, a = t.length; r < a; r++)
            n ? (e[r] = S(t[r]), this._bounds.extend(e[r])) : e[r] = this._convertLatLngs(t[r]);
          return e;
        },
        _project: function() {
          var t = new K();
          this._rings = [], this._projectLatlngs(this._latlngs, this._rings, t), this._bounds.isValid() && t.isValid() && (this._rawPxBounds = t, this._updateBounds());
        },
        _updateBounds: function() {
          var t = this._clickTolerance(), e = new B(t, t);
          this._rawPxBounds && (this._pxBounds = new K([
            this._rawPxBounds.min.subtract(e),
            this._rawPxBounds.max.add(e)
          ]));
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(t, e, n) {
          var r = t[0] instanceof z, a = t.length, h, p;
          if (r) {
            for (p = [], h = 0; h < a; h++)
              p[h] = this._map.latLngToLayerPoint(t[h]), n.extend(p[h]);
            e.push(p);
          } else
            for (h = 0; h < a; h++)
              this._projectLatlngs(t[h], e, n);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
          var t = this._renderer._bounds;
          if (this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(t))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            var e = this._parts, n, r, a, h, p, v, w;
            for (n = 0, a = 0, h = this._rings.length; n < h; n++)
              for (w = this._rings[n], r = 0, p = w.length; r < p - 1; r++)
                v = zo(w[r], w[r + 1], t, r, !0), v && (e[a] = e[a] || [], e[a].push(v[0]), (v[1] !== w[r + 1] || r === p - 2) && (e[a].push(v[1]), a++));
          }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
          for (var t = this._parts, e = this.options.smoothFactor, n = 0, r = t.length; n < r; n++)
            t[n] = So(t[n], e);
        },
        _update: function() {
          this._map && (this._clipPoints(), this._simplifyPoints(), this._updatePath());
        },
        _updatePath: function() {
          this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(t, e) {
          var n, r, a, h, p, v, w = this._clickTolerance();
          if (!this._pxBounds || !this._pxBounds.contains(t))
            return !1;
          for (n = 0, h = this._parts.length; n < h; n++)
            for (v = this._parts[n], r = 0, p = v.length, a = p - 1; r < p; a = r++)
              if (!(!e && r === 0) && Io(t, v[a], v[r]) <= w)
                return !0;
          return !1;
        }
      });
      function Ia(t, e) {
        return new Jt(t, e);
      }
      Jt._flat = Zo;
      var Ce = Jt.extend({
        options: {
          fill: !0
        },
        isEmpty: function() {
          return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
          if (!this._map)
            throw new Error("Must add layer to map before using getCenter()");
          return Eo(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(t) {
          var e = Jt.prototype._convertLatLngs.call(this, t), n = e.length;
          return n >= 2 && e[0] instanceof z && e[0].equals(e[n - 1]) && e.pop(), e;
        },
        _setLatLngs: function(t) {
          Jt.prototype._setLatLngs.call(this, t), Dt(this._latlngs) && (this._latlngs = [this._latlngs]);
        },
        _defaultShape: function() {
          return Dt(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
          var t = this._renderer._bounds, e = this.options.weight, n = new B(e, e);
          if (t = new K(t.min.subtract(n), t.max.add(n)), this._parts = [], !(!this._pxBounds || !this._pxBounds.intersects(t))) {
            if (this.options.noClip) {
              this._parts = this._rings;
              return;
            }
            for (var r = 0, a = this._rings.length, h; r < a; r++)
              h = Co(this._rings[r], t, !0), h.length && this._parts.push(h);
          }
        },
        _updatePath: function() {
          this._renderer._updatePoly(this, !0);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(t) {
          var e = !1, n, r, a, h, p, v, w, A;
          if (!this._pxBounds || !this._pxBounds.contains(t))
            return !1;
          for (h = 0, w = this._parts.length; h < w; h++)
            for (n = this._parts[h], p = 0, A = n.length, v = A - 1; p < A; v = p++)
              r = n[p], a = n[v], r.y > t.y != a.y > t.y && t.x < (a.x - r.x) * (t.y - r.y) / (a.y - r.y) + r.x && (e = !e);
          return e || Jt.prototype._containsPoint.call(this, t, !0);
        }
      });
      function Oa(t, e) {
        return new Ce(t, e);
      }
      var Xt = Yt.extend({
        /* @section
         * @aka GeoJSON options
         *
         * @option pointToLayer: Function = *
         * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
         * called when data is added, passing the GeoJSON point feature and its `LatLng`.
         * The default is to spawn a default `Marker`:
         * ```js
         * function(geoJsonPoint, latlng) {
         * 	return L.marker(latlng);
         * }
         * ```
         *
         * @option style: Function = *
         * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
         * called internally when data is added.
         * The default value is to not override any defaults:
         * ```js
         * function (geoJsonFeature) {
         * 	return {}
         * }
         * ```
         *
         * @option onEachFeature: Function = *
         * A `Function` that will be called once for each created `Feature`, after it has
         * been created and styled. Useful for attaching events and popups to features.
         * The default is to do nothing with the newly created layers:
         * ```js
         * function (feature, layer) {}
         * ```
         *
         * @option filter: Function = *
         * A `Function` that will be used to decide whether to include a feature or not.
         * The default is to include all features:
         * ```js
         * function (geoJsonFeature) {
         * 	return true;
         * }
         * ```
         * Note: dynamically changing the `filter` option will have effect only on newly
         * added data. It will _not_ re-evaluate already included features.
         *
         * @option coordsToLatLng: Function = *
         * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
         * The default is the `coordsToLatLng` static method.
         *
         * @option markersInheritOptions: Boolean = false
         * Whether default Markers for "Point" type Features inherit from group options.
         */
        initialize: function(t, e) {
          k(this, e), this._layers = {}, t && this.addData(t);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(t) {
          var e = O(t) ? t : t.features, n, r, a;
          if (e) {
            for (n = 0, r = e.length; n < r; n++)
              a = e[n], (a.geometries || a.geometry || a.features || a.coordinates) && this.addData(a);
            return this;
          }
          var h = this.options;
          if (h.filter && !h.filter(t))
            return this;
          var p = xn(t, h);
          return p ? (p.feature = Tn(t), p.defaultOptions = p.options, this.resetStyle(p), h.onEachFeature && h.onEachFeature(t, p), this.addLayer(p)) : this;
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(t) {
          return t === void 0 ? this.eachLayer(this.resetStyle, this) : (t.options = u({}, t.defaultOptions), this._setLayerStyle(t, this.options.style), this);
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(t) {
          return this.eachLayer(function(e) {
            this._setLayerStyle(e, t);
          }, this);
        },
        _setLayerStyle: function(t, e) {
          t.setStyle && (typeof e == "function" && (e = e(t.feature)), t.setStyle(e));
        }
      });
      function xn(t, e) {
        var n = t.type === "Feature" ? t.geometry : t, r = n ? n.coordinates : null, a = [], h = e && e.pointToLayer, p = e && e.coordsToLatLng || Ti, v, w, A, I;
        if (!r && !n)
          return null;
        switch (n.type) {
          case "Point":
            return v = p(r), Do(h, t, v, e);
          case "MultiPoint":
            for (A = 0, I = r.length; A < I; A++)
              v = p(r[A]), a.push(Do(h, t, v, e));
            return new Yt(a);
          case "LineString":
          case "MultiLineString":
            return w = Pn(r, n.type === "LineString" ? 0 : 1, p), new Jt(w, e);
          case "Polygon":
          case "MultiPolygon":
            return w = Pn(r, n.type === "Polygon" ? 1 : 2, p), new Ce(w, e);
          case "GeometryCollection":
            for (A = 0, I = n.geometries.length; A < I; A++) {
              var F = xn({
                geometry: n.geometries[A],
                type: "Feature",
                properties: t.properties
              }, e);
              F && a.push(F);
            }
            return new Yt(a);
          case "FeatureCollection":
            for (A = 0, I = n.features.length; A < I; A++) {
              var $ = xn(n.features[A], e);
              $ && a.push($);
            }
            return new Yt(a);
          default:
            throw new Error("Invalid GeoJSON object.");
        }
      }
      function Do(t, e, n, r) {
        return t ? t(e, n) : new wn(n, r && r.markersInheritOptions && r);
      }
      function Ti(t) {
        return new z(t[1], t[0], t[2]);
      }
      function Pn(t, e, n) {
        for (var r = [], a = 0, h = t.length, p; a < h; a++)
          p = e ? Pn(t[a], e - 1, n) : (n || Ti)(t[a]), r.push(p);
        return r;
      }
      function ki(t, e) {
        return t = S(t), t.alt !== void 0 ? [x(t.lng, e), x(t.lat, e), x(t.alt, e)] : [x(t.lng, e), x(t.lat, e)];
      }
      function Ln(t, e, n, r) {
        for (var a = [], h = 0, p = t.length; h < p; h++)
          a.push(e ? Ln(t[h], Dt(t[h]) ? 0 : e - 1, n, r) : ki(t[h], r));
        return !e && n && a.length > 0 && a.push(a[0].slice()), a;
      }
      function Ee(t, e) {
        return t.feature ? u({}, t.feature, { geometry: e }) : Tn(e);
      }
      function Tn(t) {
        return t.type === "Feature" || t.type === "FeatureCollection" ? t : {
          type: "Feature",
          properties: {},
          geometry: t
        };
      }
      var Mi = {
        toGeoJSON: function(t) {
          return Ee(this, {
            type: "Point",
            coordinates: ki(this.getLatLng(), t)
          });
        }
      };
      wn.include(Mi), Li.include(Mi), bn.include(Mi), Jt.include({
        toGeoJSON: function(t) {
          var e = !Dt(this._latlngs), n = Ln(this._latlngs, e ? 1 : 0, !1, t);
          return Ee(this, {
            type: (e ? "Multi" : "") + "LineString",
            coordinates: n
          });
        }
      }), Ce.include({
        toGeoJSON: function(t) {
          var e = !Dt(this._latlngs), n = e && !Dt(this._latlngs[0]), r = Ln(this._latlngs, n ? 2 : e ? 1 : 0, !0, t);
          return e || (r = [r]), Ee(this, {
            type: (n ? "Multi" : "") + "Polygon",
            coordinates: r
          });
        }
      }), Me.include({
        toMultiPoint: function(t) {
          var e = [];
          return this.eachLayer(function(n) {
            e.push(n.toGeoJSON(t).geometry.coordinates);
          }), Ee(this, {
            type: "MultiPoint",
            coordinates: e
          });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(t) {
          var e = this.feature && this.feature.geometry && this.feature.geometry.type;
          if (e === "MultiPoint")
            return this.toMultiPoint(t);
          var n = e === "GeometryCollection", r = [];
          return this.eachLayer(function(a) {
            if (a.toGeoJSON) {
              var h = a.toGeoJSON(t);
              if (n)
                r.push(h.geometry);
              else {
                var p = Tn(h);
                p.type === "FeatureCollection" ? r.push.apply(r, p.features) : r.push(p);
              }
            }
          }), n ? Ee(this, {
            geometries: r,
            type: "GeometryCollection"
          }) : {
            type: "FeatureCollection",
            features: r
          };
        }
      });
      function Fo(t, e) {
        return new Xt(t, e);
      }
      var za = Fo, kn = Ut.extend({
        // @section
        // @aka ImageOverlay options
        options: {
          // @option opacity: Number = 1.0
          // The opacity of the image overlay.
          opacity: 1,
          // @option alt: String = ''
          // Text for the `alt` attribute of the image (useful for accessibility).
          alt: "",
          // @option interactive: Boolean = false
          // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
          interactive: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the image.
          // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option errorOverlayUrl: String = ''
          // URL to the overlay image to show in place of the overlay that failed to load.
          errorOverlayUrl: "",
          // @option zIndex: Number = 1
          // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
          zIndex: 1,
          // @option className: String = ''
          // A custom class name to assign to the image. Empty by default.
          className: ""
        },
        initialize: function(t, e, n) {
          this._url = t, this._bounds = Z(e), k(this, n);
        },
        onAdd: function() {
          this._image || (this._initImage(), this.options.opacity < 1 && this._updateOpacity()), this.options.interactive && (G(this._image, "leaflet-interactive"), this.addInteractiveTarget(this._image)), this.getPane().appendChild(this._image), this._reset();
        },
        onRemove: function() {
          ut(this._image), this.options.interactive && this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(t) {
          return this.options.opacity = t, this._image && this._updateOpacity(), this;
        },
        setStyle: function(t) {
          return t.opacity && this.setOpacity(t.opacity), this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
          return this._map && Te(this._image), this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
          return this._map && ke(this._image), this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(t) {
          return this._url = t, this._image && (this._image.src = t), this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(t) {
          return this._bounds = Z(t), this._map && this._reset(), this;
        },
        getEvents: function() {
          var t = {
            zoom: this._reset,
            viewreset: this._reset
          };
          return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(t) {
          return this.options.zIndex = t, this._updateZIndex(), this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
          return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
          return this._image;
        },
        _initImage: function() {
          var t = this._url.tagName === "IMG", e = this._image = t ? this._url : Q("img");
          if (G(e, "leaflet-image-layer"), this._zoomAnimated && G(e, "leaflet-zoom-animated"), this.options.className && G(e, this.options.className), e.onselectstart = m, e.onmousemove = m, e.onload = d(this.fire, this, "load"), e.onerror = d(this._overlayOnError, this, "error"), (this.options.crossOrigin || this.options.crossOrigin === "") && (e.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), this.options.zIndex && this._updateZIndex(), t) {
            this._url = e.src;
            return;
          }
          e.src = this._url, e.alt = this.options.alt;
        },
        _animateZoom: function(t) {
          var e = this._map.getZoomScale(t.zoom), n = this._map._latLngBoundsToNewLayerBounds(this._bounds, t.zoom, t.center).min;
          fe(this._image, n, e);
        },
        _reset: function() {
          var t = this._image, e = new K(
            this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
            this._map.latLngToLayerPoint(this._bounds.getSouthEast())
          ), n = e.getSize();
          vt(t, e.min), t.style.width = n.x + "px", t.style.height = n.y + "px";
        },
        _updateOpacity: function() {
          Nt(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
          this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._image.style.zIndex = this.options.zIndex);
        },
        _overlayOnError: function() {
          this.fire("error");
          var t = this.options.errorOverlayUrl;
          t && this._url !== t && (this._url = t, this._image.src = t);
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
          return this._bounds.getCenter();
        }
      }), Za = function(t, e, n) {
        return new kn(t, e, n);
      }, Ho = kn.extend({
        // @section
        // @aka VideoOverlay options
        options: {
          // @option autoplay: Boolean = true
          // Whether the video starts playing automatically when loaded.
          // On some browsers autoplay will only work with `muted: true`
          autoplay: !0,
          // @option loop: Boolean = true
          // Whether the video will loop back to the beginning when played.
          loop: !0,
          // @option keepAspectRatio: Boolean = true
          // Whether the video will save aspect ratio after the projection.
          // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
          keepAspectRatio: !0,
          // @option muted: Boolean = false
          // Whether the video starts on mute when loaded.
          muted: !1,
          // @option playsInline: Boolean = true
          // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
          playsInline: !0
        },
        _initImage: function() {
          var t = this._url.tagName === "VIDEO", e = this._image = t ? this._url : Q("video");
          if (G(e, "leaflet-image-layer"), this._zoomAnimated && G(e, "leaflet-zoom-animated"), this.options.className && G(e, this.options.className), e.onselectstart = m, e.onmousemove = m, e.onloadeddata = d(this.fire, this, "load"), t) {
            for (var n = e.getElementsByTagName("source"), r = [], a = 0; a < n.length; a++)
              r.push(n[a].src);
            this._url = n.length > 0 ? r : [e.src];
            return;
          }
          O(this._url) || (this._url = [this._url]), !this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(e.style, "objectFit") && (e.style.objectFit = "fill"), e.autoplay = !!this.options.autoplay, e.loop = !!this.options.loop, e.muted = !!this.options.muted, e.playsInline = !!this.options.playsInline;
          for (var h = 0; h < this._url.length; h++) {
            var p = Q("source");
            p.src = this._url[h], e.appendChild(p);
          }
        }
        // @method getElement(): HTMLVideoElement
        // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
        // used by this overlay.
      });
      function Ra(t, e, n) {
        return new Ho(t, e, n);
      }
      var Uo = kn.extend({
        _initImage: function() {
          var t = this._image = this._url;
          G(t, "leaflet-image-layer"), this._zoomAnimated && G(t, "leaflet-zoom-animated"), this.options.className && G(t, this.options.className), t.onselectstart = m, t.onmousemove = m;
        }
        // @method getElement(): SVGElement
        // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
        // used by this overlay.
      });
      function Ba(t, e, n) {
        return new Uo(t, e, n);
      }
      var Gt = Ut.extend({
        // @section
        // @aka DivOverlay options
        options: {
          // @option interactive: Boolean = false
          // If true, the popup/tooltip will listen to the mouse events.
          interactive: !1,
          // @option offset: Point = Point(0, 0)
          // The offset of the overlay position.
          offset: [0, 0],
          // @option className: String = ''
          // A custom CSS class name to assign to the overlay.
          className: "",
          // @option pane: String = undefined
          // `Map pane` where the overlay will be added.
          pane: void 0,
          // @option content: String|HTMLElement|Function = ''
          // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
          // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
          content: ""
        },
        initialize: function(t, e) {
          t && (t instanceof z || O(t)) ? (this._latlng = S(t), k(this, e)) : (k(this, t), this._source = e), this.options.content && (this._content = this.options.content);
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(t) {
          return t = arguments.length ? t : this._source._map, t.hasLayer(this) || t.addLayer(this), this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
          return this._map && this._map.removeLayer(this), this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(t) {
          return this._map ? this.close() : (arguments.length ? this._source = t : t = this._source, this._prepareOpen(), this.openOn(t._map)), this;
        },
        onAdd: function(t) {
          this._zoomAnimated = t._zoomAnimated, this._container || this._initLayout(), t._fadeAnimated && Nt(this._container, 0), clearTimeout(this._removeTimeout), this.getPane().appendChild(this._container), this.update(), t._fadeAnimated && Nt(this._container, 1), this.bringToFront(), this.options.interactive && (G(this._container, "leaflet-interactive"), this.addInteractiveTarget(this._container));
        },
        onRemove: function(t) {
          t._fadeAnimated ? (Nt(this._container, 0), this._removeTimeout = setTimeout(d(ut, void 0, this._container), 200)) : ut(this._container), this.options.interactive && (ft(this._container, "leaflet-interactive"), this.removeInteractiveTarget(this._container));
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
          return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(t) {
          return this._latlng = S(t), this._map && (this._updatePosition(), this._adjustPan()), this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
          return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(t) {
          return this._content = t, this.update(), this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
          return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
          this._map && (this._container.style.visibility = "hidden", this._updateContent(), this._updateLayout(), this._updatePosition(), this._container.style.visibility = "", this._adjustPan());
        },
        getEvents: function() {
          var t = {
            zoom: this._updatePosition,
            viewreset: this._updatePosition
          };
          return this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
          return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
          return this._map && Te(this._container), this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
          return this._map && ke(this._container), this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(t) {
          var e = this._source;
          if (!e._map)
            return !1;
          if (e instanceof Yt) {
            e = null;
            var n = this._source._layers;
            for (var r in n)
              if (n[r]._map) {
                e = n[r];
                break;
              }
            if (!e)
              return !1;
            this._source = e;
          }
          if (!t)
            if (e.getCenter)
              t = e.getCenter();
            else if (e.getLatLng)
              t = e.getLatLng();
            else if (e.getBounds)
              t = e.getBounds().getCenter();
            else
              throw new Error("Unable to get source layer LatLng.");
          return this.setLatLng(t), this._map && this.update(), !0;
        },
        _updateContent: function() {
          if (this._content) {
            var t = this._contentNode, e = typeof this._content == "function" ? this._content(this._source || this) : this._content;
            if (typeof e == "string")
              t.innerHTML = e;
            else {
              for (; t.hasChildNodes(); )
                t.removeChild(t.firstChild);
              t.appendChild(e);
            }
            this.fire("contentupdate");
          }
        },
        _updatePosition: function() {
          if (this._map) {
            var t = this._map.latLngToLayerPoint(this._latlng), e = N(this.options.offset), n = this._getAnchor();
            this._zoomAnimated ? vt(this._container, t.add(n)) : e = e.add(t).add(n);
            var r = this._containerBottom = -e.y, a = this._containerLeft = -Math.round(this._containerWidth / 2) + e.x;
            this._container.style.bottom = r + "px", this._container.style.left = a + "px";
          }
        },
        _getAnchor: function() {
          return [0, 0];
        }
      });
      Y.include({
        _initOverlay: function(t, e, n, r) {
          var a = e;
          return a instanceof t || (a = new t(r).setContent(e)), n && a.setLatLng(n), a;
        }
      }), Ut.include({
        _initOverlay: function(t, e, n, r) {
          var a = n;
          return a instanceof t ? (k(a, r), a._source = this) : (a = e && !r ? e : new t(r, this), a.setContent(n)), a;
        }
      });
      var Mn = Gt.extend({
        // @section
        // @aka Popup options
        options: {
          // @option pane: String = 'popupPane'
          // `Map pane` where the popup will be added.
          pane: "popupPane",
          // @option offset: Point = Point(0, 7)
          // The offset of the popup position.
          offset: [0, 7],
          // @option maxWidth: Number = 300
          // Max width of the popup, in pixels.
          maxWidth: 300,
          // @option minWidth: Number = 50
          // Min width of the popup, in pixels.
          minWidth: 50,
          // @option maxHeight: Number = null
          // If set, creates a scrollable container of the given height
          // inside a popup if its content exceeds it.
          // The scrollable container can be styled using the
          // `leaflet-popup-scrolled` CSS class selector.
          maxHeight: null,
          // @option autoPan: Boolean = true
          // Set it to `false` if you don't want the map to do panning animation
          // to fit the opened popup.
          autoPan: !0,
          // @option autoPanPaddingTopLeft: Point = null
          // The margin between the popup and the top left corner of the map
          // view after autopanning was performed.
          autoPanPaddingTopLeft: null,
          // @option autoPanPaddingBottomRight: Point = null
          // The margin between the popup and the bottom right corner of the map
          // view after autopanning was performed.
          autoPanPaddingBottomRight: null,
          // @option autoPanPadding: Point = Point(5, 5)
          // Equivalent of setting both top left and bottom right autopan padding to the same value.
          autoPanPadding: [5, 5],
          // @option keepInView: Boolean = false
          // Set it to `true` if you want to prevent users from panning the popup
          // off of the screen while it is open.
          keepInView: !1,
          // @option closeButton: Boolean = true
          // Controls the presence of a close button in the popup.
          closeButton: !0,
          // @option autoClose: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the popup closing when another popup is opened.
          autoClose: !0,
          // @option closeOnEscapeKey: Boolean = true
          // Set it to `false` if you want to override the default behavior of
          // the ESC key for closing of the popup.
          closeOnEscapeKey: !0,
          // @option closeOnClick: Boolean = *
          // Set it if you want to override the default behavior of the popup closing when user clicks
          // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
          // @option className: String = ''
          // A custom CSS class name to assign to the popup.
          className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(t) {
          return t = arguments.length ? t : this._source._map, !t.hasLayer(this) && t._popup && t._popup.options.autoClose && t.removeLayer(t._popup), t._popup = this, Gt.prototype.openOn.call(this, t);
        },
        onAdd: function(t) {
          Gt.prototype.onAdd.call(this, t), t.fire("popupopen", { popup: this }), this._source && (this._source.fire("popupopen", { popup: this }, !0), this._source instanceof le || this._source.on("preclick", pe));
        },
        onRemove: function(t) {
          Gt.prototype.onRemove.call(this, t), t.fire("popupclose", { popup: this }), this._source && (this._source.fire("popupclose", { popup: this }, !0), this._source instanceof le || this._source.off("preclick", pe));
        },
        getEvents: function() {
          var t = Gt.prototype.getEvents.call(this);
          return (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) && (t.preclick = this.close), this.options.keepInView && (t.moveend = this._adjustPan), t;
        },
        _initLayout: function() {
          var t = "leaflet-popup", e = this._container = Q(
            "div",
            t + " " + (this.options.className || "") + " leaflet-zoom-animated"
          ), n = this._wrapper = Q("div", t + "-content-wrapper", e);
          if (this._contentNode = Q("div", t + "-content", n), qe(e), mi(this._contentNode), W(e, "contextmenu", pe), this._tipContainer = Q("div", t + "-tip-container", e), this._tip = Q("div", t + "-tip", this._tipContainer), this.options.closeButton) {
            var r = this._closeButton = Q("a", t + "-close-button", e);
            r.setAttribute("role", "button"), r.setAttribute("aria-label", "Close popup"), r.href = "#close", r.innerHTML = '<span aria-hidden="true">&#215;</span>', W(r, "click", function(a) {
              Tt(a), this.close();
            }, this);
          }
        },
        _updateLayout: function() {
          var t = this._contentNode, e = t.style;
          e.width = "", e.whiteSpace = "nowrap";
          var n = t.offsetWidth;
          n = Math.min(n, this.options.maxWidth), n = Math.max(n, this.options.minWidth), e.width = n + 1 + "px", e.whiteSpace = "", e.height = "";
          var r = t.offsetHeight, a = this.options.maxHeight, h = "leaflet-popup-scrolled";
          a && r > a ? (e.height = a + "px", G(t, h)) : ft(t, h), this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(t) {
          var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center), n = this._getAnchor();
          vt(this._container, e.add(n));
        },
        _adjustPan: function() {
          if (this.options.autoPan) {
            if (this._map._panAnim && this._map._panAnim.stop(), this._autopanning) {
              this._autopanning = !1;
              return;
            }
            var t = this._map, e = parseInt(Fe(this._container, "marginBottom"), 10) || 0, n = this._container.offsetHeight + e, r = this._containerWidth, a = new B(this._containerLeft, -n - this._containerBottom);
            a._add(_e(this._container));
            var h = t.layerPointToContainerPoint(a), p = N(this.options.autoPanPadding), v = N(this.options.autoPanPaddingTopLeft || p), w = N(this.options.autoPanPaddingBottomRight || p), A = t.getSize(), I = 0, F = 0;
            h.x + r + w.x > A.x && (I = h.x + r - A.x + w.x), h.x - I - v.x < 0 && (I = h.x - v.x), h.y + n + w.y > A.y && (F = h.y + n - A.y + w.y), h.y - F - v.y < 0 && (F = h.y - v.y), (I || F) && (this.options.keepInView && (this._autopanning = !0), t.fire("autopanstart").panBy([I, F]));
          }
        },
        _getAnchor: function() {
          return N(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
        }
      }), Na = function(t, e) {
        return new Mn(t, e);
      };
      Y.mergeOptions({
        closePopupOnClick: !0
      }), Y.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(t, e, n) {
          return this._initOverlay(Mn, t, e, n).openOn(this), this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(t) {
          return t = arguments.length ? t : this._popup, t && t.close(), this;
        }
      }), Ut.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(t, e) {
          return this._popup = this._initOverlay(Mn, this._popup, t, e), this._popupHandlersAdded || (this.on({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !0), this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
          return this._popup && (this.off({
            click: this._openPopup,
            keypress: this._onKeyPress,
            remove: this.closePopup,
            move: this._movePopup
          }), this._popupHandlersAdded = !1, this._popup = null), this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(t) {
          return this._popup && (this instanceof Yt || (this._popup._source = this), this._popup._prepareOpen(t || this._latlng) && this._popup.openOn(this._map)), this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
          return this._popup && this._popup.close(), this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
          return this._popup && this._popup.toggle(this), this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
          return this._popup ? this._popup.isOpen() : !1;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(t) {
          return this._popup && this._popup.setContent(t), this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
          return this._popup;
        },
        _openPopup: function(t) {
          if (!(!this._popup || !this._map)) {
            me(t);
            var e = t.layer || t.target;
            if (this._popup._source === e && !(e instanceof le)) {
              this._map.hasLayer(this._popup) ? this.closePopup() : this.openPopup(t.latlng);
              return;
            }
            this._popup._source = e, this.openPopup(t.latlng);
          }
        },
        _movePopup: function(t) {
          this._popup.setLatLng(t.latlng);
        },
        _onKeyPress: function(t) {
          t.originalEvent.keyCode === 13 && this._openPopup(t);
        }
      });
      var An = Gt.extend({
        // @section
        // @aka Tooltip options
        options: {
          // @option pane: String = 'tooltipPane'
          // `Map pane` where the tooltip will be added.
          pane: "tooltipPane",
          // @option offset: Point = Point(0, 0)
          // Optional offset of the tooltip position.
          offset: [0, 0],
          // @option direction: String = 'auto'
          // Direction where to open the tooltip. Possible values are: `right`, `left`,
          // `top`, `bottom`, `center`, `auto`.
          // `auto` will dynamically switch between `right` and `left` according to the tooltip
          // position on the map.
          direction: "auto",
          // @option permanent: Boolean = false
          // Whether to open the tooltip permanently or only on mouseover.
          permanent: !1,
          // @option sticky: Boolean = false
          // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
          sticky: !1,
          // @option opacity: Number = 0.9
          // Tooltip container opacity.
          opacity: 0.9
        },
        onAdd: function(t) {
          Gt.prototype.onAdd.call(this, t), this.setOpacity(this.options.opacity), t.fire("tooltipopen", { tooltip: this }), this._source && (this.addEventParent(this._source), this._source.fire("tooltipopen", { tooltip: this }, !0));
        },
        onRemove: function(t) {
          Gt.prototype.onRemove.call(this, t), t.fire("tooltipclose", { tooltip: this }), this._source && (this.removeEventParent(this._source), this._source.fire("tooltipclose", { tooltip: this }, !0));
        },
        getEvents: function() {
          var t = Gt.prototype.getEvents.call(this);
          return this.options.permanent || (t.preclick = this.close), t;
        },
        _initLayout: function() {
          var t = "leaflet-tooltip", e = t + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
          this._contentNode = this._container = Q("div", e), this._container.setAttribute("role", "tooltip"), this._container.setAttribute("id", "leaflet-tooltip-" + f(this));
        },
        _updateLayout: function() {
        },
        _adjustPan: function() {
        },
        _setPosition: function(t) {
          var e, n, r = this._map, a = this._container, h = r.latLngToContainerPoint(r.getCenter()), p = r.layerPointToContainerPoint(t), v = this.options.direction, w = a.offsetWidth, A = a.offsetHeight, I = N(this.options.offset), F = this._getAnchor();
          v === "top" ? (e = w / 2, n = A) : v === "bottom" ? (e = w / 2, n = 0) : v === "center" ? (e = w / 2, n = A / 2) : v === "right" ? (e = 0, n = A / 2) : v === "left" ? (e = w, n = A / 2) : p.x < h.x ? (v = "right", e = 0, n = A / 2) : (v = "left", e = w + (I.x + F.x) * 2, n = A / 2), t = t.subtract(N(e, n, !0)).add(I).add(F), ft(a, "leaflet-tooltip-right"), ft(a, "leaflet-tooltip-left"), ft(a, "leaflet-tooltip-top"), ft(a, "leaflet-tooltip-bottom"), G(a, "leaflet-tooltip-" + v), vt(a, t);
        },
        _updatePosition: function() {
          var t = this._map.latLngToLayerPoint(this._latlng);
          this._setPosition(t);
        },
        setOpacity: function(t) {
          this.options.opacity = t, this._container && Nt(this._container, t);
        },
        _animateZoom: function(t) {
          var e = this._map._latLngToNewLayerPoint(this._latlng, t.zoom, t.center);
          this._setPosition(e);
        },
        _getAnchor: function() {
          return N(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
        }
      }), Da = function(t, e) {
        return new An(t, e);
      };
      Y.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(t, e, n) {
          return this._initOverlay(An, t, e, n).openOn(this), this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(t) {
          return t.close(), this;
        }
      }), Ut.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(t, e) {
          return this._tooltip && this.isTooltipOpen() && this.unbindTooltip(), this._tooltip = this._initOverlay(An, this._tooltip, t, e), this._initTooltipInteractions(), this._tooltip.options.permanent && this._map && this._map.hasLayer(this) && this.openTooltip(), this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
          return this._tooltip && (this._initTooltipInteractions(!0), this.closeTooltip(), this._tooltip = null), this;
        },
        _initTooltipInteractions: function(t) {
          if (!(!t && this._tooltipHandlersAdded)) {
            var e = t ? "off" : "on", n = {
              remove: this.closeTooltip,
              move: this._moveTooltip
            };
            this._tooltip.options.permanent ? n.add = this._openTooltip : (n.mouseover = this._openTooltip, n.mouseout = this.closeTooltip, n.click = this._openTooltip, this._map ? this._addFocusListeners() : n.add = this._addFocusListeners), this._tooltip.options.sticky && (n.mousemove = this._moveTooltip), this[e](n), this._tooltipHandlersAdded = !t;
          }
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(t) {
          return this._tooltip && (this instanceof Yt || (this._tooltip._source = this), this._tooltip._prepareOpen(t) && (this._tooltip.openOn(this._map), this.getElement ? this._setAriaDescribedByOnLayer(this) : this.eachLayer && this.eachLayer(this._setAriaDescribedByOnLayer, this))), this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
          if (this._tooltip)
            return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
          return this._tooltip && this._tooltip.toggle(this), this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
          return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(t) {
          return this._tooltip && this._tooltip.setContent(t), this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
          return this._tooltip;
        },
        _addFocusListeners: function() {
          this.getElement ? this._addFocusListenersOnLayer(this) : this.eachLayer && this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(t) {
          var e = typeof t.getElement == "function" && t.getElement();
          e && (W(e, "focus", function() {
            this._tooltip._source = t, this.openTooltip();
          }, this), W(e, "blur", this.closeTooltip, this));
        },
        _setAriaDescribedByOnLayer: function(t) {
          var e = typeof t.getElement == "function" && t.getElement();
          e && e.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(t) {
          if (!(!this._tooltip || !this._map)) {
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
              this._openOnceFlag = !0;
              var e = this;
              this._map.once("moveend", function() {
                e._openOnceFlag = !1, e._openTooltip(t);
              });
              return;
            }
            this._tooltip._source = t.layer || t.target, this.openTooltip(this._tooltip.options.sticky ? t.latlng : void 0);
          }
        },
        _moveTooltip: function(t) {
          var e = t.latlng, n, r;
          this._tooltip.options.sticky && t.originalEvent && (n = this._map.mouseEventToContainerPoint(t.originalEvent), r = this._map.containerPointToLayerPoint(n), e = this._map.layerPointToLatLng(r)), this._tooltip.setLatLng(e);
        }
      });
      var Wo = Ae.extend({
        options: {
          // @section
          // @aka DivIcon options
          iconSize: [12, 12],
          // also can be set through CSS
          // iconAnchor: (Point),
          // popupAnchor: (Point),
          // @option html: String|HTMLElement = ''
          // Custom HTML code to put inside the div element, empty by default. Alternatively,
          // an instance of `HTMLElement`.
          html: !1,
          // @option bgPos: Point = [0, 0]
          // Optional relative position of the background, in pixels
          bgPos: null,
          className: "leaflet-div-icon"
        },
        createIcon: function(t) {
          var e = t && t.tagName === "DIV" ? t : document.createElement("div"), n = this.options;
          if (n.html instanceof Element ? (_n(e), e.appendChild(n.html)) : e.innerHTML = n.html !== !1 ? n.html : "", n.bgPos) {
            var r = N(n.bgPos);
            e.style.backgroundPosition = -r.x + "px " + -r.y + "px";
          }
          return this._setIconStyles(e, "icon"), e;
        },
        createShadow: function() {
          return null;
        }
      });
      function Fa(t) {
        return new Wo(t);
      }
      Ae.Default = Ve;
      var $e = Ut.extend({
        // @section
        // @aka GridLayer options
        options: {
          // @option tileSize: Number|Point = 256
          // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
          tileSize: 256,
          // @option opacity: Number = 1.0
          // Opacity of the tiles. Can be used in the `createTile()` function.
          opacity: 1,
          // @option updateWhenIdle: Boolean = (depends)
          // Load new tiles only when panning ends.
          // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
          // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
          // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
          updateWhenIdle: R.mobile,
          // @option updateWhenZooming: Boolean = true
          // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
          updateWhenZooming: !0,
          // @option updateInterval: Number = 200
          // Tiles will not update more than once every `updateInterval` milliseconds when panning.
          updateInterval: 200,
          // @option zIndex: Number = 1
          // The explicit zIndex of the tile layer.
          zIndex: 1,
          // @option bounds: LatLngBounds = undefined
          // If set, tiles will only be loaded inside the set `LatLngBounds`.
          bounds: null,
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = undefined
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: void 0,
          // @option maxNativeZoom: Number = undefined
          // Maximum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
          // from `maxNativeZoom` level and auto-scaled.
          maxNativeZoom: void 0,
          // @option minNativeZoom: Number = undefined
          // Minimum zoom number the tile source has available. If it is specified,
          // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
          // from `minNativeZoom` level and auto-scaled.
          minNativeZoom: void 0,
          // @option noWrap: Boolean = false
          // Whether the layer is wrapped around the antimeridian. If `true`, the
          // GridLayer will only be displayed once at low zoom levels. Has no
          // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
          // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
          // tiles outside the CRS limits.
          noWrap: !1,
          // @option pane: String = 'tilePane'
          // `Map pane` where the grid layer will be added.
          pane: "tilePane",
          // @option className: String = ''
          // A custom class name to assign to the tile layer. Empty by default.
          className: "",
          // @option keepBuffer: Number = 2
          // When panning the map, keep this many rows and columns of tiles before unloading them.
          keepBuffer: 2
        },
        initialize: function(t) {
          k(this, t);
        },
        onAdd: function() {
          this._initContainer(), this._levels = {}, this._tiles = {}, this._resetView();
        },
        beforeAdd: function(t) {
          t._addZoomLimit(this);
        },
        onRemove: function(t) {
          this._removeAllTiles(), ut(this._container), t._removeZoomLimit(this), this._container = null, this._tileZoom = void 0;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
          return this._map && (Te(this._container), this._setAutoZIndex(Math.max)), this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
          return this._map && (ke(this._container), this._setAutoZIndex(Math.min)), this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
          return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(t) {
          return this.options.opacity = t, this._updateOpacity(), this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(t) {
          return this.options.zIndex = t, this._updateZIndex(), this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
          return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
          if (this._map) {
            this._removeAllTiles();
            var t = this._clampZoom(this._map.getZoom());
            t !== this._tileZoom && (this._tileZoom = t, this._updateLevels()), this._update();
          }
          return this;
        },
        getEvents: function() {
          var t = {
            viewprereset: this._invalidateAll,
            viewreset: this._resetView,
            zoom: this._resetView,
            moveend: this._onMoveEnd
          };
          return this.options.updateWhenIdle || (this._onMove || (this._onMove = g(this._onMoveEnd, this.options.updateInterval, this)), t.move = this._onMove), this._zoomAnimated && (t.zoomanim = this._animateZoom), t;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
          return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
          var t = this.options.tileSize;
          return t instanceof B ? t : new B(t, t);
        },
        _updateZIndex: function() {
          this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null && (this._container.style.zIndex = this.options.zIndex);
        },
        _setAutoZIndex: function(t) {
          for (var e = this.getPane().children, n = -t(-1 / 0, 1 / 0), r = 0, a = e.length, h; r < a; r++)
            h = e[r].style.zIndex, e[r] !== this._container && h && (n = t(n, +h));
          isFinite(n) && (this.options.zIndex = n + t(-1, 1), this._updateZIndex());
        },
        _updateOpacity: function() {
          if (this._map && !R.ielt9) {
            Nt(this._container, this.options.opacity);
            var t = +/* @__PURE__ */ new Date(), e = !1, n = !1;
            for (var r in this._tiles) {
              var a = this._tiles[r];
              if (!(!a.current || !a.loaded)) {
                var h = Math.min(1, (t - a.loaded) / 200);
                Nt(a.el, h), h < 1 ? e = !0 : (a.active ? n = !0 : this._onOpaqueTile(a), a.active = !0);
              }
            }
            n && !this._noPrune && this._pruneTiles(), e && (bt(this._fadeFrame), this._fadeFrame = st(this._updateOpacity, this));
          }
        },
        _onOpaqueTile: m,
        _initContainer: function() {
          this._container || (this._container = Q("div", "leaflet-layer " + (this.options.className || "")), this._updateZIndex(), this.options.opacity < 1 && this._updateOpacity(), this.getPane().appendChild(this._container));
        },
        _updateLevels: function() {
          var t = this._tileZoom, e = this.options.maxZoom;
          if (t !== void 0) {
            for (var n in this._levels)
              n = Number(n), this._levels[n].el.children.length || n === t ? (this._levels[n].el.style.zIndex = e - Math.abs(t - n), this._onUpdateLevel(n)) : (ut(this._levels[n].el), this._removeTilesAtZoom(n), this._onRemoveLevel(n), delete this._levels[n]);
            var r = this._levels[t], a = this._map;
            return r || (r = this._levels[t] = {}, r.el = Q("div", "leaflet-tile-container leaflet-zoom-animated", this._container), r.el.style.zIndex = e, r.origin = a.project(a.unproject(a.getPixelOrigin()), t).round(), r.zoom = t, this._setZoomTransform(r, a.getCenter(), a.getZoom()), m(r.el.offsetWidth), this._onCreateLevel(r)), this._level = r, r;
          }
        },
        _onUpdateLevel: m,
        _onRemoveLevel: m,
        _onCreateLevel: m,
        _pruneTiles: function() {
          if (this._map) {
            var t, e, n = this._map.getZoom();
            if (n > this.options.maxZoom || n < this.options.minZoom) {
              this._removeAllTiles();
              return;
            }
            for (t in this._tiles)
              e = this._tiles[t], e.retain = e.current;
            for (t in this._tiles)
              if (e = this._tiles[t], e.current && !e.active) {
                var r = e.coords;
                this._retainParent(r.x, r.y, r.z, r.z - 5) || this._retainChildren(r.x, r.y, r.z, r.z + 2);
              }
            for (t in this._tiles)
              this._tiles[t].retain || this._removeTile(t);
          }
        },
        _removeTilesAtZoom: function(t) {
          for (var e in this._tiles)
            this._tiles[e].coords.z === t && this._removeTile(e);
        },
        _removeAllTiles: function() {
          for (var t in this._tiles)
            this._removeTile(t);
        },
        _invalidateAll: function() {
          for (var t in this._levels)
            ut(this._levels[t].el), this._onRemoveLevel(Number(t)), delete this._levels[t];
          this._removeAllTiles(), this._tileZoom = void 0;
        },
        _retainParent: function(t, e, n, r) {
          var a = Math.floor(t / 2), h = Math.floor(e / 2), p = n - 1, v = new B(+a, +h);
          v.z = +p;
          var w = this._tileCoordsToKey(v), A = this._tiles[w];
          return A && A.active ? (A.retain = !0, !0) : (A && A.loaded && (A.retain = !0), p > r ? this._retainParent(a, h, p, r) : !1);
        },
        _retainChildren: function(t, e, n, r) {
          for (var a = 2 * t; a < 2 * t + 2; a++)
            for (var h = 2 * e; h < 2 * e + 2; h++) {
              var p = new B(a, h);
              p.z = n + 1;
              var v = this._tileCoordsToKey(p), w = this._tiles[v];
              if (w && w.active) {
                w.retain = !0;
                continue;
              } else w && w.loaded && (w.retain = !0);
              n + 1 < r && this._retainChildren(a, h, n + 1, r);
            }
        },
        _resetView: function(t) {
          var e = t && (t.pinch || t.flyTo);
          this._setView(this._map.getCenter(), this._map.getZoom(), e, e);
        },
        _animateZoom: function(t) {
          this._setView(t.center, t.zoom, !0, t.noUpdate);
        },
        _clampZoom: function(t) {
          var e = this.options;
          return e.minNativeZoom !== void 0 && t < e.minNativeZoom ? e.minNativeZoom : e.maxNativeZoom !== void 0 && e.maxNativeZoom < t ? e.maxNativeZoom : t;
        },
        _setView: function(t, e, n, r) {
          var a = Math.round(e);
          this.options.maxZoom !== void 0 && a > this.options.maxZoom || this.options.minZoom !== void 0 && a < this.options.minZoom ? a = void 0 : a = this._clampZoom(a);
          var h = this.options.updateWhenZooming && a !== this._tileZoom;
          (!r || h) && (this._tileZoom = a, this._abortLoading && this._abortLoading(), this._updateLevels(), this._resetGrid(), a !== void 0 && this._update(t), n || this._pruneTiles(), this._noPrune = !!n), this._setZoomTransforms(t, e);
        },
        _setZoomTransforms: function(t, e) {
          for (var n in this._levels)
            this._setZoomTransform(this._levels[n], t, e);
        },
        _setZoomTransform: function(t, e, n) {
          var r = this._map.getZoomScale(n, t.zoom), a = t.origin.multiplyBy(r).subtract(this._map._getNewPixelOrigin(e, n)).round();
          R.any3d ? fe(t.el, a, r) : vt(t.el, a);
        },
        _resetGrid: function() {
          var t = this._map, e = t.options.crs, n = this._tileSize = this.getTileSize(), r = this._tileZoom, a = this._map.getPixelWorldBounds(this._tileZoom);
          a && (this._globalTileRange = this._pxBoundsToTileRange(a)), this._wrapX = e.wrapLng && !this.options.noWrap && [
            Math.floor(t.project([0, e.wrapLng[0]], r).x / n.x),
            Math.ceil(t.project([0, e.wrapLng[1]], r).x / n.y)
          ], this._wrapY = e.wrapLat && !this.options.noWrap && [
            Math.floor(t.project([e.wrapLat[0], 0], r).y / n.x),
            Math.ceil(t.project([e.wrapLat[1], 0], r).y / n.y)
          ];
        },
        _onMoveEnd: function() {
          !this._map || this._map._animatingZoom || this._update();
        },
        _getTiledPixelBounds: function(t) {
          var e = this._map, n = e._animatingZoom ? Math.max(e._animateToZoom, e.getZoom()) : e.getZoom(), r = e.getZoomScale(n, this._tileZoom), a = e.project(t, this._tileZoom).floor(), h = e.getSize().divideBy(r * 2);
          return new K(a.subtract(h), a.add(h));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(t) {
          var e = this._map;
          if (e) {
            var n = this._clampZoom(e.getZoom());
            if (t === void 0 && (t = e.getCenter()), this._tileZoom !== void 0) {
              var r = this._getTiledPixelBounds(t), a = this._pxBoundsToTileRange(r), h = a.getCenter(), p = [], v = this.options.keepBuffer, w = new K(
                a.getBottomLeft().subtract([v, -v]),
                a.getTopRight().add([v, -v])
              );
              if (!(isFinite(a.min.x) && isFinite(a.min.y) && isFinite(a.max.x) && isFinite(a.max.y)))
                throw new Error("Attempted to load an infinite number of tiles");
              for (var A in this._tiles) {
                var I = this._tiles[A].coords;
                (I.z !== this._tileZoom || !w.contains(new B(I.x, I.y))) && (this._tiles[A].current = !1);
              }
              if (Math.abs(n - this._tileZoom) > 1) {
                this._setView(t, n);
                return;
              }
              for (var F = a.min.y; F <= a.max.y; F++)
                for (var $ = a.min.x; $ <= a.max.x; $++) {
                  var At = new B($, F);
                  if (At.z = this._tileZoom, !!this._isValidTile(At)) {
                    var Pt = this._tiles[this._tileCoordsToKey(At)];
                    Pt ? Pt.current = !0 : p.push(At);
                  }
                }
              if (p.sort(function(It, Ie) {
                return It.distanceTo(h) - Ie.distanceTo(h);
              }), p.length !== 0) {
                this._loading || (this._loading = !0, this.fire("loading"));
                var Ft = document.createDocumentFragment();
                for ($ = 0; $ < p.length; $++)
                  this._addTile(p[$], Ft);
                this._level.el.appendChild(Ft);
              }
            }
          }
        },
        _isValidTile: function(t) {
          var e = this._map.options.crs;
          if (!e.infinite) {
            var n = this._globalTileRange;
            if (!e.wrapLng && (t.x < n.min.x || t.x > n.max.x) || !e.wrapLat && (t.y < n.min.y || t.y > n.max.y))
              return !1;
          }
          if (!this.options.bounds)
            return !0;
          var r = this._tileCoordsToBounds(t);
          return Z(this.options.bounds).overlaps(r);
        },
        _keyToBounds: function(t) {
          return this._tileCoordsToBounds(this._keyToTileCoords(t));
        },
        _tileCoordsToNwSe: function(t) {
          var e = this._map, n = this.getTileSize(), r = t.scaleBy(n), a = r.add(n), h = e.unproject(r, t.z), p = e.unproject(a, t.z);
          return [h, p];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(t) {
          var e = this._tileCoordsToNwSe(t), n = new lt(e[0], e[1]);
          return this.options.noWrap || (n = this._map.wrapLatLngBounds(n)), n;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(t) {
          return t.x + ":" + t.y + ":" + t.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(t) {
          var e = t.split(":"), n = new B(+e[0], +e[1]);
          return n.z = +e[2], n;
        },
        _removeTile: function(t) {
          var e = this._tiles[t];
          e && (ut(e.el), delete this._tiles[t], this.fire("tileunload", {
            tile: e.el,
            coords: this._keyToTileCoords(t)
          }));
        },
        _initTile: function(t) {
          G(t, "leaflet-tile");
          var e = this.getTileSize();
          t.style.width = e.x + "px", t.style.height = e.y + "px", t.onselectstart = m, t.onmousemove = m, R.ielt9 && this.options.opacity < 1 && Nt(t, this.options.opacity);
        },
        _addTile: function(t, e) {
          var n = this._getTilePos(t), r = this._tileCoordsToKey(t), a = this.createTile(this._wrapCoords(t), d(this._tileReady, this, t));
          this._initTile(a), this.createTile.length < 2 && st(d(this._tileReady, this, t, null, a)), vt(a, n), this._tiles[r] = {
            el: a,
            coords: t,
            current: !0
          }, e.appendChild(a), this.fire("tileloadstart", {
            tile: a,
            coords: t
          });
        },
        _tileReady: function(t, e, n) {
          e && this.fire("tileerror", {
            error: e,
            tile: n,
            coords: t
          });
          var r = this._tileCoordsToKey(t);
          n = this._tiles[r], n && (n.loaded = +/* @__PURE__ */ new Date(), this._map._fadeAnimated ? (Nt(n.el, 0), bt(this._fadeFrame), this._fadeFrame = st(this._updateOpacity, this)) : (n.active = !0, this._pruneTiles()), e || (G(n.el, "leaflet-tile-loaded"), this.fire("tileload", {
            tile: n.el,
            coords: t
          })), this._noTilesToLoad() && (this._loading = !1, this.fire("load"), R.ielt9 || !this._map._fadeAnimated ? st(this._pruneTiles, this) : setTimeout(d(this._pruneTiles, this), 250)));
        },
        _getTilePos: function(t) {
          return t.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(t) {
          var e = new B(
            this._wrapX ? P(t.x, this._wrapX) : t.x,
            this._wrapY ? P(t.y, this._wrapY) : t.y
          );
          return e.z = t.z, e;
        },
        _pxBoundsToTileRange: function(t) {
          var e = this.getTileSize();
          return new K(
            t.min.unscaleBy(e).floor(),
            t.max.unscaleBy(e).ceil().subtract([1, 1])
          );
        },
        _noTilesToLoad: function() {
          for (var t in this._tiles)
            if (!this._tiles[t].loaded)
              return !1;
          return !0;
        }
      });
      function Ha(t) {
        return new $e(t);
      }
      var Se = $e.extend({
        // @section
        // @aka TileLayer options
        options: {
          // @option minZoom: Number = 0
          // The minimum zoom level down to which this layer will be displayed (inclusive).
          minZoom: 0,
          // @option maxZoom: Number = 18
          // The maximum zoom level up to which this layer will be displayed (inclusive).
          maxZoom: 18,
          // @option subdomains: String|String[] = 'abc'
          // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
          subdomains: "abc",
          // @option errorTileUrl: String = ''
          // URL to the tile image to show in place of the tile that failed to load.
          errorTileUrl: "",
          // @option zoomOffset: Number = 0
          // The zoom number used in tile URLs will be offset with this value.
          zoomOffset: 0,
          // @option tms: Boolean = false
          // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
          tms: !1,
          // @option zoomReverse: Boolean = false
          // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
          zoomReverse: !1,
          // @option detectRetina: Boolean = false
          // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
          detectRetina: !1,
          // @option crossOrigin: Boolean|String = false
          // Whether the crossOrigin attribute will be added to the tiles.
          // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
          // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
          crossOrigin: !1,
          // @option referrerPolicy: Boolean|String = false
          // Whether the referrerPolicy attribute will be added to the tiles.
          // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
          // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
          // (e.g. to validate an API token).
          // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
          referrerPolicy: !1
        },
        initialize: function(t, e) {
          this._url = t, e = k(this, e), e.detectRetina && R.retina && e.maxZoom > 0 ? (e.tileSize = Math.floor(e.tileSize / 2), e.zoomReverse ? (e.zoomOffset--, e.minZoom = Math.min(e.maxZoom, e.minZoom + 1)) : (e.zoomOffset++, e.maxZoom = Math.max(e.minZoom, e.maxZoom - 1)), e.minZoom = Math.max(0, e.minZoom)) : e.zoomReverse ? e.minZoom = Math.min(e.maxZoom, e.minZoom) : e.maxZoom = Math.max(e.minZoom, e.maxZoom), typeof e.subdomains == "string" && (e.subdomains = e.subdomains.split("")), this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(t, e) {
          return this._url === t && e === void 0 && (e = !0), this._url = t, e || this.redraw(), this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(t, e) {
          var n = document.createElement("img");
          return W(n, "load", d(this._tileOnLoad, this, e, n)), W(n, "error", d(this._tileOnError, this, e, n)), (this.options.crossOrigin || this.options.crossOrigin === "") && (n.crossOrigin = this.options.crossOrigin === !0 ? "" : this.options.crossOrigin), typeof this.options.referrerPolicy == "string" && (n.referrerPolicy = this.options.referrerPolicy), n.alt = "", n.src = this.getTileUrl(t), n;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(t) {
          var e = {
            r: R.retina ? "@2x" : "",
            s: this._getSubdomain(t),
            x: t.x,
            y: t.y,
            z: this._getZoomForUrl()
          };
          if (this._map && !this._map.options.crs.infinite) {
            var n = this._globalTileRange.max.y - t.y;
            this.options.tms && (e.y = n), e["-y"] = n;
          }
          return C(this._url, u(e, this.options));
        },
        _tileOnLoad: function(t, e) {
          R.ielt9 ? setTimeout(d(t, this, null, e), 0) : t(null, e);
        },
        _tileOnError: function(t, e, n) {
          var r = this.options.errorTileUrl;
          r && e.getAttribute("src") !== r && (e.src = r), t(n, e);
        },
        _onTileRemove: function(t) {
          t.tile.onload = null;
        },
        _getZoomForUrl: function() {
          var t = this._tileZoom, e = this.options.maxZoom, n = this.options.zoomReverse, r = this.options.zoomOffset;
          return n && (t = e - t), t + r;
        },
        _getSubdomain: function(t) {
          var e = Math.abs(t.x + t.y) % this.options.subdomains.length;
          return this.options.subdomains[e];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
          var t, e;
          for (t in this._tiles)
            if (this._tiles[t].coords.z !== this._tileZoom && (e = this._tiles[t].el, e.onload = m, e.onerror = m, !e.complete)) {
              e.src = j;
              var n = this._tiles[t].coords;
              ut(e), delete this._tiles[t], this.fire("tileabort", {
                tile: e,
                coords: n
              });
            }
        },
        _removeTile: function(t) {
          var e = this._tiles[t];
          if (e)
            return e.el.setAttribute("src", j), $e.prototype._removeTile.call(this, t);
        },
        _tileReady: function(t, e, n) {
          if (!(!this._map || n && n.getAttribute("src") === j))
            return $e.prototype._tileReady.call(this, t, e, n);
        }
      });
      function qo(t, e) {
        return new Se(t, e);
      }
      var jo = Se.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
          service: "WMS",
          request: "GetMap",
          // @option layers: String = ''
          // **(required)** Comma-separated list of WMS layers to show.
          layers: "",
          // @option styles: String = ''
          // Comma-separated list of WMS styles.
          styles: "",
          // @option format: String = 'image/jpeg'
          // WMS image format (use `'image/png'` for layers with transparency).
          format: "image/jpeg",
          // @option transparent: Boolean = false
          // If `true`, the WMS service will return images with transparency.
          transparent: !1,
          // @option version: String = '1.1.1'
          // Version of the WMS service to use
          version: "1.1.1"
        },
        options: {
          // @option crs: CRS = null
          // Coordinate Reference System to use for the WMS requests, defaults to
          // map CRS. Don't change this if you're not sure what it means.
          crs: null,
          // @option uppercase: Boolean = false
          // If `true`, WMS request parameter keys will be uppercase.
          uppercase: !1
        },
        initialize: function(t, e) {
          this._url = t;
          var n = u({}, this.defaultWmsParams);
          for (var r in e)
            r in this.options || (n[r] = e[r]);
          e = k(this, e);
          var a = e.detectRetina && R.retina ? 2 : 1, h = this.getTileSize();
          n.width = h.x * a, n.height = h.y * a, this.wmsParams = n;
        },
        onAdd: function(t) {
          this._crs = this.options.crs || t.options.crs, this._wmsVersion = parseFloat(this.wmsParams.version);
          var e = this._wmsVersion >= 1.3 ? "crs" : "srs";
          this.wmsParams[e] = this._crs.code, Se.prototype.onAdd.call(this, t);
        },
        getTileUrl: function(t) {
          var e = this._tileCoordsToNwSe(t), n = this._crs, r = it(n.project(e[0]), n.project(e[1])), a = r.min, h = r.max, p = (this._wmsVersion >= 1.3 && this._crs === Bo ? [a.y, a.x, h.y, h.x] : [a.x, a.y, h.x, h.y]).join(","), v = Se.prototype.getTileUrl.call(this, t);
          return v + b(this.wmsParams, v, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + p;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(t, e) {
          return u(this.wmsParams, t), e || this.redraw(), this;
        }
      });
      function Ua(t, e) {
        return new jo(t, e);
      }
      Se.WMS = jo, qo.wms = Ua;
      var Qt = Ut.extend({
        // @section
        // @aka Renderer options
        options: {
          // @option padding: Number = 0.1
          // How much to extend the clip area around the map view (relative to its size)
          // e.g. 0.1 would be 10% of map view in each direction
          padding: 0.1
        },
        initialize: function(t) {
          k(this, t), f(this), this._layers = this._layers || {};
        },
        onAdd: function() {
          this._container || (this._initContainer(), G(this._container, "leaflet-zoom-animated")), this.getPane().appendChild(this._container), this._update(), this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
          this.off("update", this._updatePaths, this), this._destroyContainer();
        },
        getEvents: function() {
          var t = {
            viewreset: this._reset,
            zoom: this._onZoom,
            moveend: this._update,
            zoomend: this._onZoomEnd
          };
          return this._zoomAnimated && (t.zoomanim = this._onAnimZoom), t;
        },
        _onAnimZoom: function(t) {
          this._updateTransform(t.center, t.zoom);
        },
        _onZoom: function() {
          this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(t, e) {
          var n = this._map.getZoomScale(e, this._zoom), r = this._map.getSize().multiplyBy(0.5 + this.options.padding), a = this._map.project(this._center, e), h = r.multiplyBy(-n).add(a).subtract(this._map._getNewPixelOrigin(t, e));
          R.any3d ? fe(this._container, h, n) : vt(this._container, h);
        },
        _reset: function() {
          this._update(), this._updateTransform(this._center, this._zoom);
          for (var t in this._layers)
            this._layers[t]._reset();
        },
        _onZoomEnd: function() {
          for (var t in this._layers)
            this._layers[t]._project();
        },
        _updatePaths: function() {
          for (var t in this._layers)
            this._layers[t]._update();
        },
        _update: function() {
          var t = this.options.padding, e = this._map.getSize(), n = this._map.containerPointToLayerPoint(e.multiplyBy(-t)).round();
          this._bounds = new K(n, n.add(e.multiplyBy(1 + t * 2)).round()), this._center = this._map.getCenter(), this._zoom = this._map.getZoom();
        }
      }), Go = Qt.extend({
        // @section
        // @aka Canvas options
        options: {
          // @option tolerance: Number = 0
          // How much to extend the click tolerance around a path/object on the map.
          tolerance: 0
        },
        getEvents: function() {
          var t = Qt.prototype.getEvents.call(this);
          return t.viewprereset = this._onViewPreReset, t;
        },
        _onViewPreReset: function() {
          this._postponeUpdatePaths = !0;
        },
        onAdd: function() {
          Qt.prototype.onAdd.call(this), this._draw();
        },
        _initContainer: function() {
          var t = this._container = document.createElement("canvas");
          W(t, "mousemove", this._onMouseMove, this), W(t, "click dblclick mousedown mouseup contextmenu", this._onClick, this), W(t, "mouseout", this._handleMouseOut, this), t._leaflet_disable_events = !0, this._ctx = t.getContext("2d");
        },
        _destroyContainer: function() {
          bt(this._redrawRequest), delete this._ctx, ut(this._container), nt(this._container), delete this._container;
        },
        _updatePaths: function() {
          if (!this._postponeUpdatePaths) {
            var t;
            this._redrawBounds = null;
            for (var e in this._layers)
              t = this._layers[e], t._update();
            this._redraw();
          }
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            Qt.prototype._update.call(this);
            var t = this._bounds, e = this._container, n = t.getSize(), r = R.retina ? 2 : 1;
            vt(e, t.min), e.width = r * n.x, e.height = r * n.y, e.style.width = n.x + "px", e.style.height = n.y + "px", R.retina && this._ctx.scale(2, 2), this._ctx.translate(-t.min.x, -t.min.y), this.fire("update");
          }
        },
        _reset: function() {
          Qt.prototype._reset.call(this), this._postponeUpdatePaths && (this._postponeUpdatePaths = !1, this._updatePaths());
        },
        _initPath: function(t) {
          this._updateDashArray(t), this._layers[f(t)] = t;
          var e = t._order = {
            layer: t,
            prev: this._drawLast,
            next: null
          };
          this._drawLast && (this._drawLast.next = e), this._drawLast = e, this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(t) {
          this._requestRedraw(t);
        },
        _removePath: function(t) {
          var e = t._order, n = e.next, r = e.prev;
          n ? n.prev = r : this._drawLast = r, r ? r.next = n : this._drawFirst = n, delete t._order, delete this._layers[f(t)], this._requestRedraw(t);
        },
        _updatePath: function(t) {
          this._extendRedrawBounds(t), t._project(), t._update(), this._requestRedraw(t);
        },
        _updateStyle: function(t) {
          this._updateDashArray(t), this._requestRedraw(t);
        },
        _updateDashArray: function(t) {
          if (typeof t.options.dashArray == "string") {
            var e = t.options.dashArray.split(/[, ]+/), n = [], r, a;
            for (a = 0; a < e.length; a++) {
              if (r = Number(e[a]), isNaN(r))
                return;
              n.push(r);
            }
            t.options._dashArray = n;
          } else
            t.options._dashArray = t.options.dashArray;
        },
        _requestRedraw: function(t) {
          this._map && (this._extendRedrawBounds(t), this._redrawRequest = this._redrawRequest || st(this._redraw, this));
        },
        _extendRedrawBounds: function(t) {
          if (t._pxBounds) {
            var e = (t.options.weight || 0) + 1;
            this._redrawBounds = this._redrawBounds || new K(), this._redrawBounds.extend(t._pxBounds.min.subtract([e, e])), this._redrawBounds.extend(t._pxBounds.max.add([e, e]));
          }
        },
        _redraw: function() {
          this._redrawRequest = null, this._redrawBounds && (this._redrawBounds.min._floor(), this._redrawBounds.max._ceil()), this._clear(), this._draw(), this._redrawBounds = null;
        },
        _clear: function() {
          var t = this._redrawBounds;
          if (t) {
            var e = t.getSize();
            this._ctx.clearRect(t.min.x, t.min.y, e.x, e.y);
          } else
            this._ctx.save(), this._ctx.setTransform(1, 0, 0, 1, 0, 0), this._ctx.clearRect(0, 0, this._container.width, this._container.height), this._ctx.restore();
        },
        _draw: function() {
          var t, e = this._redrawBounds;
          if (this._ctx.save(), e) {
            var n = e.getSize();
            this._ctx.beginPath(), this._ctx.rect(e.min.x, e.min.y, n.x, n.y), this._ctx.clip();
          }
          this._drawing = !0;
          for (var r = this._drawFirst; r; r = r.next)
            t = r.layer, (!e || t._pxBounds && t._pxBounds.intersects(e)) && t._updatePath();
          this._drawing = !1, this._ctx.restore();
        },
        _updatePoly: function(t, e) {
          if (this._drawing) {
            var n, r, a, h, p = t._parts, v = p.length, w = this._ctx;
            if (v) {
              for (w.beginPath(), n = 0; n < v; n++) {
                for (r = 0, a = p[n].length; r < a; r++)
                  h = p[n][r], w[r ? "lineTo" : "moveTo"](h.x, h.y);
                e && w.closePath();
              }
              this._fillStroke(w, t);
            }
          }
        },
        _updateCircle: function(t) {
          if (!(!this._drawing || t._empty())) {
            var e = t._point, n = this._ctx, r = Math.max(Math.round(t._radius), 1), a = (Math.max(Math.round(t._radiusY), 1) || r) / r;
            a !== 1 && (n.save(), n.scale(1, a)), n.beginPath(), n.arc(e.x, e.y / a, r, 0, Math.PI * 2, !1), a !== 1 && n.restore(), this._fillStroke(n, t);
          }
        },
        _fillStroke: function(t, e) {
          var n = e.options;
          n.fill && (t.globalAlpha = n.fillOpacity, t.fillStyle = n.fillColor || n.color, t.fill(n.fillRule || "evenodd")), n.stroke && n.weight !== 0 && (t.setLineDash && t.setLineDash(e.options && e.options._dashArray || []), t.globalAlpha = n.opacity, t.lineWidth = n.weight, t.strokeStyle = n.color, t.lineCap = n.lineCap, t.lineJoin = n.lineJoin, t.stroke());
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(t) {
          for (var e = this._map.mouseEventToLayerPoint(t), n, r, a = this._drawFirst; a; a = a.next)
            n = a.layer, n.options.interactive && n._containsPoint(e) && (!(t.type === "click" || t.type === "preclick") || !this._map._draggableMoved(n)) && (r = n);
          this._fireEvent(r ? [r] : !1, t);
        },
        _onMouseMove: function(t) {
          if (!(!this._map || this._map.dragging.moving() || this._map._animatingZoom)) {
            var e = this._map.mouseEventToLayerPoint(t);
            this._handleMouseHover(t, e);
          }
        },
        _handleMouseOut: function(t) {
          var e = this._hoveredLayer;
          e && (ft(this._container, "leaflet-interactive"), this._fireEvent([e], t, "mouseout"), this._hoveredLayer = null, this._mouseHoverThrottled = !1);
        },
        _handleMouseHover: function(t, e) {
          if (!this._mouseHoverThrottled) {
            for (var n, r, a = this._drawFirst; a; a = a.next)
              n = a.layer, n.options.interactive && n._containsPoint(e) && (r = n);
            r !== this._hoveredLayer && (this._handleMouseOut(t), r && (G(this._container, "leaflet-interactive"), this._fireEvent([r], t, "mouseover"), this._hoveredLayer = r)), this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : !1, t), this._mouseHoverThrottled = !0, setTimeout(d(function() {
              this._mouseHoverThrottled = !1;
            }, this), 32);
          }
        },
        _fireEvent: function(t, e, n) {
          this._map._fireDOMEvent(e, n || e.type, t);
        },
        _bringToFront: function(t) {
          var e = t._order;
          if (e) {
            var n = e.next, r = e.prev;
            if (n)
              n.prev = r;
            else
              return;
            r ? r.next = n : n && (this._drawFirst = n), e.prev = this._drawLast, this._drawLast.next = e, e.next = null, this._drawLast = e, this._requestRedraw(t);
          }
        },
        _bringToBack: function(t) {
          var e = t._order;
          if (e) {
            var n = e.next, r = e.prev;
            if (r)
              r.next = n;
            else
              return;
            n ? n.prev = r : r && (this._drawLast = r), e.prev = null, e.next = this._drawFirst, this._drawFirst.prev = e, this._drawFirst = e, this._requestRedraw(t);
          }
        }
      });
      function Vo(t) {
        return R.canvas ? new Go(t) : null;
      }
      var Ke = (function() {
        try {
          return document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml"), function(t) {
            return document.createElement("<lvml:" + t + ' class="lvml">');
          };
        } catch {
        }
        return function(t) {
          return document.createElement("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
      })(), Wa = {
        _initContainer: function() {
          this._container = Q("div", "leaflet-vml-container");
        },
        _update: function() {
          this._map._animatingZoom || (Qt.prototype._update.call(this), this.fire("update"));
        },
        _initPath: function(t) {
          var e = t._container = Ke("shape");
          G(e, "leaflet-vml-shape " + (this.options.className || "")), e.coordsize = "1 1", t._path = Ke("path"), e.appendChild(t._path), this._updateStyle(t), this._layers[f(t)] = t;
        },
        _addPath: function(t) {
          var e = t._container;
          this._container.appendChild(e), t.options.interactive && t.addInteractiveTarget(e);
        },
        _removePath: function(t) {
          var e = t._container;
          ut(e), t.removeInteractiveTarget(e), delete this._layers[f(t)];
        },
        _updateStyle: function(t) {
          var e = t._stroke, n = t._fill, r = t.options, a = t._container;
          a.stroked = !!r.stroke, a.filled = !!r.fill, r.stroke ? (e || (e = t._stroke = Ke("stroke")), a.appendChild(e), e.weight = r.weight + "px", e.color = r.color, e.opacity = r.opacity, r.dashArray ? e.dashStyle = O(r.dashArray) ? r.dashArray.join(" ") : r.dashArray.replace(/( *, *)/g, " ") : e.dashStyle = "", e.endcap = r.lineCap.replace("butt", "flat"), e.joinstyle = r.lineJoin) : e && (a.removeChild(e), t._stroke = null), r.fill ? (n || (n = t._fill = Ke("fill")), a.appendChild(n), n.color = r.fillColor || r.color, n.opacity = r.fillOpacity) : n && (a.removeChild(n), t._fill = null);
        },
        _updateCircle: function(t) {
          var e = t._point.round(), n = Math.round(t._radius), r = Math.round(t._radiusY || n);
          this._setPath(t, t._empty() ? "M0 0" : "AL " + e.x + "," + e.y + " " + n + "," + r + " 0," + 65535 * 360);
        },
        _setPath: function(t, e) {
          t._path.v = e;
        },
        _bringToFront: function(t) {
          Te(t._container);
        },
        _bringToBack: function(t) {
          ke(t._container);
        }
      }, Cn = R.vml ? Ke : Rt, Ye = Qt.extend({
        _initContainer: function() {
          this._container = Cn("svg"), this._container.setAttribute("pointer-events", "none"), this._rootGroup = Cn("g"), this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
          ut(this._container), nt(this._container), delete this._container, delete this._rootGroup, delete this._svgSize;
        },
        _update: function() {
          if (!(this._map._animatingZoom && this._bounds)) {
            Qt.prototype._update.call(this);
            var t = this._bounds, e = t.getSize(), n = this._container;
            (!this._svgSize || !this._svgSize.equals(e)) && (this._svgSize = e, n.setAttribute("width", e.x), n.setAttribute("height", e.y)), vt(n, t.min), n.setAttribute("viewBox", [t.min.x, t.min.y, e.x, e.y].join(" ")), this.fire("update");
          }
        },
        // methods below are called by vector layers implementations
        _initPath: function(t) {
          var e = t._path = Cn("path");
          t.options.className && G(e, t.options.className), t.options.interactive && G(e, "leaflet-interactive"), this._updateStyle(t), this._layers[f(t)] = t;
        },
        _addPath: function(t) {
          this._rootGroup || this._initContainer(), this._rootGroup.appendChild(t._path), t.addInteractiveTarget(t._path);
        },
        _removePath: function(t) {
          ut(t._path), t.removeInteractiveTarget(t._path), delete this._layers[f(t)];
        },
        _updatePath: function(t) {
          t._project(), t._update();
        },
        _updateStyle: function(t) {
          var e = t._path, n = t.options;
          e && (n.stroke ? (e.setAttribute("stroke", n.color), e.setAttribute("stroke-opacity", n.opacity), e.setAttribute("stroke-width", n.weight), e.setAttribute("stroke-linecap", n.lineCap), e.setAttribute("stroke-linejoin", n.lineJoin), n.dashArray ? e.setAttribute("stroke-dasharray", n.dashArray) : e.removeAttribute("stroke-dasharray"), n.dashOffset ? e.setAttribute("stroke-dashoffset", n.dashOffset) : e.removeAttribute("stroke-dashoffset")) : e.setAttribute("stroke", "none"), n.fill ? (e.setAttribute("fill", n.fillColor || n.color), e.setAttribute("fill-opacity", n.fillOpacity), e.setAttribute("fill-rule", n.fillRule || "evenodd")) : e.setAttribute("fill", "none"));
        },
        _updatePoly: function(t, e) {
          this._setPath(t, $t(t._parts, e));
        },
        _updateCircle: function(t) {
          var e = t._point, n = Math.max(Math.round(t._radius), 1), r = Math.max(Math.round(t._radiusY), 1) || n, a = "a" + n + "," + r + " 0 1,0 ", h = t._empty() ? "M0 0" : "M" + (e.x - n) + "," + e.y + a + n * 2 + ",0 " + a + -n * 2 + ",0 ";
          this._setPath(t, h);
        },
        _setPath: function(t, e) {
          t._path.setAttribute("d", e);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(t) {
          Te(t._path);
        },
        _bringToBack: function(t) {
          ke(t._path);
        }
      });
      R.vml && Ye.include(Wa);
      function $o(t) {
        return R.svg || R.vml ? new Ye(t) : null;
      }
      Y.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(t) {
          var e = t.options.renderer || this._getPaneRenderer(t.options.pane) || this.options.renderer || this._renderer;
          return e || (e = this._renderer = this._createRenderer()), this.hasLayer(e) || this.addLayer(e), e;
        },
        _getPaneRenderer: function(t) {
          if (t === "overlayPane" || t === void 0)
            return !1;
          var e = this._paneRenderers[t];
          return e === void 0 && (e = this._createRenderer({ pane: t }), this._paneRenderers[t] = e), e;
        },
        _createRenderer: function(t) {
          return this.options.preferCanvas && Vo(t) || $o(t);
        }
      });
      var Ko = Ce.extend({
        initialize: function(t, e) {
          Ce.prototype.initialize.call(this, this._boundsToLatLngs(t), e);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(t) {
          return this.setLatLngs(this._boundsToLatLngs(t));
        },
        _boundsToLatLngs: function(t) {
          return t = Z(t), [
            t.getSouthWest(),
            t.getNorthWest(),
            t.getNorthEast(),
            t.getSouthEast()
          ];
        }
      });
      function qa(t, e) {
        return new Ko(t, e);
      }
      Ye.create = Cn, Ye.pointsToPath = $t, Xt.geometryToLayer = xn, Xt.coordsToLatLng = Ti, Xt.coordsToLatLngs = Pn, Xt.latLngToCoords = ki, Xt.latLngsToCoords = Ln, Xt.getFeature = Ee, Xt.asFeature = Tn, Y.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: !0
      });
      var Yo = jt.extend({
        initialize: function(t) {
          this._map = t, this._container = t._container, this._pane = t._panes.overlayPane, this._resetStateTimeout = 0, t.on("unload", this._destroy, this);
        },
        addHooks: function() {
          W(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
          nt(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
          return this._moved;
        },
        _destroy: function() {
          ut(this._pane), delete this._pane;
        },
        _resetState: function() {
          this._resetStateTimeout = 0, this._moved = !1;
        },
        _clearDeferredResetState: function() {
          this._resetStateTimeout !== 0 && (clearTimeout(this._resetStateTimeout), this._resetStateTimeout = 0);
        },
        _onMouseDown: function(t) {
          if (!t.shiftKey || t.which !== 1 && t.button !== 1)
            return !1;
          this._clearDeferredResetState(), this._resetState(), He(), li(), this._startPoint = this._map.mouseEventToContainerPoint(t), W(document, {
            contextmenu: me,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseMove: function(t) {
          this._moved || (this._moved = !0, this._box = Q("div", "leaflet-zoom-box", this._container), G(this._container, "leaflet-crosshair"), this._map.fire("boxzoomstart")), this._point = this._map.mouseEventToContainerPoint(t);
          var e = new K(this._point, this._startPoint), n = e.getSize();
          vt(this._box, e.min), this._box.style.width = n.x + "px", this._box.style.height = n.y + "px";
        },
        _finish: function() {
          this._moved && (ut(this._box), ft(this._container, "leaflet-crosshair")), Ue(), ui(), nt(document, {
            contextmenu: me,
            mousemove: this._onMouseMove,
            mouseup: this._onMouseUp,
            keydown: this._onKeyDown
          }, this);
        },
        _onMouseUp: function(t) {
          if (!(t.which !== 1 && t.button !== 1) && (this._finish(), !!this._moved)) {
            this._clearDeferredResetState(), this._resetStateTimeout = setTimeout(d(this._resetState, this), 0);
            var e = new lt(
              this._map.containerPointToLatLng(this._startPoint),
              this._map.containerPointToLatLng(this._point)
            );
            this._map.fitBounds(e).fire("boxzoomend", { boxZoomBounds: e });
          }
        },
        _onKeyDown: function(t) {
          t.keyCode === 27 && (this._finish(), this._clearDeferredResetState(), this._resetState());
        }
      });
      Y.addInitHook("addHandler", "boxZoom", Yo), Y.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: !0
      });
      var Jo = jt.extend({
        addHooks: function() {
          this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
          this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(t) {
          var e = this._map, n = e.getZoom(), r = e.options.zoomDelta, a = t.originalEvent.shiftKey ? n - r : n + r;
          e.options.doubleClickZoom === "center" ? e.setZoom(a) : e.setZoomAround(t.containerPoint, a);
        }
      });
      Y.addInitHook("addHandler", "doubleClickZoom", Jo), Y.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: !0,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: !0,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // px/s^2
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: 1 / 0,
        // px/s
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: !1,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0
      });
      var Xo = jt.extend({
        addHooks: function() {
          if (!this._draggable) {
            var t = this._map;
            this._draggable = new ae(t._mapPane, t._container), this._draggable.on({
              dragstart: this._onDragStart,
              drag: this._onDrag,
              dragend: this._onDragEnd
            }, this), this._draggable.on("predrag", this._onPreDragLimit, this), t.options.worldCopyJump && (this._draggable.on("predrag", this._onPreDragWrap, this), t.on("zoomend", this._onZoomEnd, this), t.whenReady(this._onZoomEnd, this));
          }
          G(this._map._container, "leaflet-grab leaflet-touch-drag"), this._draggable.enable(), this._positions = [], this._times = [];
        },
        removeHooks: function() {
          ft(this._map._container, "leaflet-grab"), ft(this._map._container, "leaflet-touch-drag"), this._draggable.disable();
        },
        moved: function() {
          return this._draggable && this._draggable._moved;
        },
        moving: function() {
          return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
          var t = this._map;
          if (t._stop(), this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
            var e = Z(this._map.options.maxBounds);
            this._offsetLimit = it(
              this._map.latLngToContainerPoint(e.getNorthWest()).multiplyBy(-1),
              this._map.latLngToContainerPoint(e.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
            ), this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
          } else
            this._offsetLimit = null;
          t.fire("movestart").fire("dragstart"), t.options.inertia && (this._positions = [], this._times = []);
        },
        _onDrag: function(t) {
          if (this._map.options.inertia) {
            var e = this._lastTime = +/* @__PURE__ */ new Date(), n = this._lastPos = this._draggable._absPos || this._draggable._newPos;
            this._positions.push(n), this._times.push(e), this._prunePositions(e);
          }
          this._map.fire("move", t).fire("drag", t);
        },
        _prunePositions: function(t) {
          for (; this._positions.length > 1 && t - this._times[0] > 50; )
            this._positions.shift(), this._times.shift();
        },
        _onZoomEnd: function() {
          var t = this._map.getSize().divideBy(2), e = this._map.latLngToLayerPoint([0, 0]);
          this._initialWorldOffset = e.subtract(t).x, this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(t, e) {
          return t - (t - e) * this._viscosity;
        },
        _onPreDragLimit: function() {
          if (!(!this._viscosity || !this._offsetLimit)) {
            var t = this._draggable._newPos.subtract(this._draggable._startPos), e = this._offsetLimit;
            t.x < e.min.x && (t.x = this._viscousLimit(t.x, e.min.x)), t.y < e.min.y && (t.y = this._viscousLimit(t.y, e.min.y)), t.x > e.max.x && (t.x = this._viscousLimit(t.x, e.max.x)), t.y > e.max.y && (t.y = this._viscousLimit(t.y, e.max.y)), this._draggable._newPos = this._draggable._startPos.add(t);
          }
        },
        _onPreDragWrap: function() {
          var t = this._worldWidth, e = Math.round(t / 2), n = this._initialWorldOffset, r = this._draggable._newPos.x, a = (r - e + n) % t + e - n, h = (r + e + n) % t - e - n, p = Math.abs(a + n) < Math.abs(h + n) ? a : h;
          this._draggable._absPos = this._draggable._newPos.clone(), this._draggable._newPos.x = p;
        },
        _onDragEnd: function(t) {
          var e = this._map, n = e.options, r = !n.inertia || t.noInertia || this._times.length < 2;
          if (e.fire("dragend", t), r)
            e.fire("moveend");
          else {
            this._prunePositions(+/* @__PURE__ */ new Date());
            var a = this._lastPos.subtract(this._positions[0]), h = (this._lastTime - this._times[0]) / 1e3, p = n.easeLinearity, v = a.multiplyBy(p / h), w = v.distanceTo([0, 0]), A = Math.min(n.inertiaMaxSpeed, w), I = v.multiplyBy(A / w), F = A / (n.inertiaDeceleration * p), $ = I.multiplyBy(-F / 2).round();
            !$.x && !$.y ? e.fire("moveend") : ($ = e._limitOffset($, e.options.maxBounds), st(function() {
              e.panBy($, {
                duration: F,
                easeLinearity: p,
                noMoveStart: !0,
                animate: !0
              });
            }));
          }
        }
      });
      Y.addInitHook("addHandler", "dragging", Xo), Y.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: !0,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
      });
      var Qo = jt.extend({
        keyCodes: {
          left: [37],
          right: [39],
          down: [40],
          up: [38],
          zoomIn: [187, 107, 61, 171],
          zoomOut: [189, 109, 54, 173]
        },
        initialize: function(t) {
          this._map = t, this._setPanDelta(t.options.keyboardPanDelta), this._setZoomDelta(t.options.zoomDelta);
        },
        addHooks: function() {
          var t = this._map._container;
          t.tabIndex <= 0 && (t.tabIndex = "0"), W(t, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.on({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        removeHooks: function() {
          this._removeHooks(), nt(this._map._container, {
            focus: this._onFocus,
            blur: this._onBlur,
            mousedown: this._onMouseDown
          }, this), this._map.off({
            focus: this._addHooks,
            blur: this._removeHooks
          }, this);
        },
        _onMouseDown: function() {
          if (!this._focused) {
            var t = document.body, e = document.documentElement, n = t.scrollTop || e.scrollTop, r = t.scrollLeft || e.scrollLeft;
            this._map._container.focus(), window.scrollTo(r, n);
          }
        },
        _onFocus: function() {
          this._focused = !0, this._map.fire("focus");
        },
        _onBlur: function() {
          this._focused = !1, this._map.fire("blur");
        },
        _setPanDelta: function(t) {
          var e = this._panKeys = {}, n = this.keyCodes, r, a;
          for (r = 0, a = n.left.length; r < a; r++)
            e[n.left[r]] = [-1 * t, 0];
          for (r = 0, a = n.right.length; r < a; r++)
            e[n.right[r]] = [t, 0];
          for (r = 0, a = n.down.length; r < a; r++)
            e[n.down[r]] = [0, t];
          for (r = 0, a = n.up.length; r < a; r++)
            e[n.up[r]] = [0, -1 * t];
        },
        _setZoomDelta: function(t) {
          var e = this._zoomKeys = {}, n = this.keyCodes, r, a;
          for (r = 0, a = n.zoomIn.length; r < a; r++)
            e[n.zoomIn[r]] = t;
          for (r = 0, a = n.zoomOut.length; r < a; r++)
            e[n.zoomOut[r]] = -t;
        },
        _addHooks: function() {
          W(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
          nt(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(t) {
          if (!(t.altKey || t.ctrlKey || t.metaKey)) {
            var e = t.keyCode, n = this._map, r;
            if (e in this._panKeys) {
              if (!n._panAnim || !n._panAnim._inProgress)
                if (r = this._panKeys[e], t.shiftKey && (r = N(r).multiplyBy(3)), n.options.maxBounds && (r = n._limitOffset(N(r), n.options.maxBounds)), n.options.worldCopyJump) {
                  var a = n.wrapLatLng(n.unproject(n.project(n.getCenter()).add(r)));
                  n.panTo(a);
                } else
                  n.panBy(r);
            } else if (e in this._zoomKeys)
              n.setZoom(n.getZoom() + (t.shiftKey ? 3 : 1) * this._zoomKeys[e]);
            else if (e === 27 && n._popup && n._popup.options.closeOnEscapeKey)
              n.closePopup();
            else
              return;
            me(t);
          }
        }
      });
      Y.addInitHook("addHandler", "keyboard", Qo), Y.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: !0,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
      });
      var tr = jt.extend({
        addHooks: function() {
          W(this._map._container, "wheel", this._onWheelScroll, this), this._delta = 0;
        },
        removeHooks: function() {
          nt(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(t) {
          var e = Lo(t), n = this._map.options.wheelDebounceTime;
          this._delta += e, this._lastMousePos = this._map.mouseEventToContainerPoint(t), this._startTime || (this._startTime = +/* @__PURE__ */ new Date());
          var r = Math.max(n - (+/* @__PURE__ */ new Date() - this._startTime), 0);
          clearTimeout(this._timer), this._timer = setTimeout(d(this._performZoom, this), r), me(t);
        },
        _performZoom: function() {
          var t = this._map, e = t.getZoom(), n = this._map.options.zoomSnap || 0;
          t._stop();
          var r = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), a = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(r)))) / Math.LN2, h = n ? Math.ceil(a / n) * n : a, p = t._limitZoom(e + (this._delta > 0 ? h : -h)) - e;
          this._delta = 0, this._startTime = null, p && (t.options.scrollWheelZoom === "center" ? t.setZoom(e + p) : t.setZoomAround(this._lastMousePos, e + p));
        }
      });
      Y.addInitHook("addHandler", "scrollWheelZoom", tr);
      var ja = 600;
      Y.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: R.touchNative && R.safari && R.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
      });
      var er = jt.extend({
        addHooks: function() {
          W(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
          nt(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(t) {
          if (clearTimeout(this._holdTimeout), t.touches.length === 1) {
            var e = t.touches[0];
            this._startPos = this._newPos = new B(e.clientX, e.clientY), this._holdTimeout = setTimeout(d(function() {
              this._cancel(), this._isTapValid() && (W(document, "touchend", Tt), W(document, "touchend touchcancel", this._cancelClickPrevent), this._simulateEvent("contextmenu", e));
            }, this), ja), W(document, "touchend touchcancel contextmenu", this._cancel, this), W(document, "touchmove", this._onMove, this);
          }
        },
        _cancelClickPrevent: function t() {
          nt(document, "touchend", Tt), nt(document, "touchend touchcancel", t);
        },
        _cancel: function() {
          clearTimeout(this._holdTimeout), nt(document, "touchend touchcancel contextmenu", this._cancel, this), nt(document, "touchmove", this._onMove, this);
        },
        _onMove: function(t) {
          var e = t.touches[0];
          this._newPos = new B(e.clientX, e.clientY);
        },
        _isTapValid: function() {
          return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(t, e) {
          var n = new MouseEvent(t, {
            bubbles: !0,
            cancelable: !0,
            view: window,
            // detail: 1,
            screenX: e.screenX,
            screenY: e.screenY,
            clientX: e.clientX,
            clientY: e.clientY
            // button: 2,
            // buttons: 2
          });
          n._simulated = !0, e.target.dispatchEvent(n);
        }
      });
      Y.addInitHook("addHandler", "tapHold", er), Y.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: R.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: !0
      });
      var nr = jt.extend({
        addHooks: function() {
          G(this._map._container, "leaflet-touch-zoom"), W(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
          ft(this._map._container, "leaflet-touch-zoom"), nt(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(t) {
          var e = this._map;
          if (!(!t.touches || t.touches.length !== 2 || e._animatingZoom || this._zooming)) {
            var n = e.mouseEventToContainerPoint(t.touches[0]), r = e.mouseEventToContainerPoint(t.touches[1]);
            this._centerPoint = e.getSize()._divideBy(2), this._startLatLng = e.containerPointToLatLng(this._centerPoint), e.options.touchZoom !== "center" && (this._pinchStartLatLng = e.containerPointToLatLng(n.add(r)._divideBy(2))), this._startDist = n.distanceTo(r), this._startZoom = e.getZoom(), this._moved = !1, this._zooming = !0, e._stop(), W(document, "touchmove", this._onTouchMove, this), W(document, "touchend touchcancel", this._onTouchEnd, this), Tt(t);
          }
        },
        _onTouchMove: function(t) {
          if (!(!t.touches || t.touches.length !== 2 || !this._zooming)) {
            var e = this._map, n = e.mouseEventToContainerPoint(t.touches[0]), r = e.mouseEventToContainerPoint(t.touches[1]), a = n.distanceTo(r) / this._startDist;
            if (this._zoom = e.getScaleZoom(a, this._startZoom), !e.options.bounceAtZoomLimits && (this._zoom < e.getMinZoom() && a < 1 || this._zoom > e.getMaxZoom() && a > 1) && (this._zoom = e._limitZoom(this._zoom)), e.options.touchZoom === "center") {
              if (this._center = this._startLatLng, a === 1)
                return;
            } else {
              var h = n._add(r)._divideBy(2)._subtract(this._centerPoint);
              if (a === 1 && h.x === 0 && h.y === 0)
                return;
              this._center = e.unproject(e.project(this._pinchStartLatLng, this._zoom).subtract(h), this._zoom);
            }
            this._moved || (e._moveStart(!0, !1), this._moved = !0), bt(this._animRequest);
            var p = d(e._move, e, this._center, this._zoom, { pinch: !0, round: !1 }, void 0);
            this._animRequest = st(p, this, !0), Tt(t);
          }
        },
        _onTouchEnd: function() {
          if (!this._moved || !this._zooming) {
            this._zooming = !1;
            return;
          }
          this._zooming = !1, bt(this._animRequest), nt(document, "touchmove", this._onTouchMove, this), nt(document, "touchend touchcancel", this._onTouchEnd, this), this._map.options.zoomAnimation ? this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), !0, this._map.options.zoomSnap) : this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
      });
      Y.addInitHook("addHandler", "touchZoom", nr), Y.BoxZoom = Yo, Y.DoubleClickZoom = Jo, Y.Drag = Xo, Y.Keyboard = Qo, Y.ScrollWheelZoom = tr, Y.TapHold = er, Y.TouchZoom = nr, s.Bounds = K, s.Browser = R, s.CRS = U, s.Canvas = Go, s.Circle = Li, s.CircleMarker = bn, s.Class = Lt, s.Control = Ht, s.DivIcon = Wo, s.DivOverlay = Gt, s.DomEvent = ua, s.DomUtil = aa, s.Draggable = ae, s.Evented = Bt, s.FeatureGroup = Yt, s.GeoJSON = Xt, s.GridLayer = $e, s.Handler = jt, s.Icon = Ae, s.ImageOverlay = kn, s.LatLng = z, s.LatLngBounds = lt, s.Layer = Ut, s.LayerGroup = Me, s.LineUtil = xa, s.Map = Y, s.Marker = wn, s.Mixin = ma, s.Path = le, s.Point = B, s.PolyUtil = ga, s.Polygon = Ce, s.Polyline = Jt, s.Popup = Mn, s.PosAnimation = To, s.Projection = Pa, s.Rectangle = Ko, s.Renderer = Qt, s.SVG = Ye, s.SVGOverlay = Uo, s.TileLayer = Se, s.Tooltip = An, s.Transformation = Mt, s.Util = ie, s.VideoOverlay = Ho, s.bind = d, s.bounds = it, s.canvas = Vo, s.circle = Sa, s.circleMarker = Ea, s.control = je, s.divIcon = Fa, s.extend = u, s.featureGroup = Ma, s.geoJSON = Fo, s.geoJson = za, s.gridLayer = Ha, s.icon = Aa, s.imageOverlay = Za, s.latLng = S, s.latLngBounds = Z, s.layerGroup = ka, s.map = ca, s.marker = Ca, s.point = N, s.polygon = Oa, s.polyline = Ia, s.popup = Na, s.rectangle = qa, s.setOptions = k, s.stamp = f, s.svg = $o, s.svgOverlay = Ba, s.tileLayer = qo, s.tooltip = Da, s.transformation = Et, s.version = l, s.videoOverlay = Ra;
      var Ga = window.L;
      s.noConflict = function() {
        return window.L = Ga, this;
      }, window.L = s;
    }));
  })(en, en.exports)), en.exports;
}
var we = Tc();
const kc = '<span class="locator__pin-inner"><svg width="25" height="34" viewBox="0 0 25 33.7121" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4999 0C19.4033 0 25 5.56269 25 12.4239C25 18.3886 19.2458 26.604 14.7355 32.5991C14.1916 33.3214 13.4106 33.7121 12.5 33.7121C11.5894 33.7121 10.8082 33.3225 10.2645 32.5991C5.75424 26.6038 0 18.3898 0 12.4239C0 5.56255 5.59665 0 12.4999 0Z" fill="#3F1951"/></svg><span class="locator__pin-logo"></span></span>', Jr = (o) => we.divIcon({
  html: kc,
  className: `locator__pin${o ? " locator__pin--on" : ""}`,
  iconSize: [25, 34],
  iconAnchor: [12.5, 34],
  popupAnchor: [0, -34]
}), Mc = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, Ac = (o) => o.replace(/[&<>"']/g, (i) => Mc[i]), Xr = (o) => o.filter((i) => i.latitude != null && i.longitude != null);
function Cc({ installers: o, selectedId: i, onSelectInstaller: s, center: l, fitBounds: u }) {
  const c = J(null), d = J(null), _ = J(null), f = J(/* @__PURE__ */ new Map()), [g, P] = _t(!1), m = J(o), x = J(l != null), T = J(!1);
  m.current = o, x.current = l != null, T.current = (u?.length ?? 0) > 0;
  const E = (b) => {
    const M = Xr(m.current);
    x.current || T.current || M.length === 0 || b.getSize().x === 0 || b.fitBounds(
      we.latLngBounds(M.map((C) => [C.latitude, C.longitude])),
      { padding: [40, 40] }
    );
  };
  xt(() => {
    const b = c.current;
    if (!b || d.current) return;
    const M = () => {
      if (d.current) return;
      const O = we.map(b, {
        minZoom: 2,
        maxBounds: we.latLngBounds([-85, -180], [85, 180]),
        maxBoundsViscosity: 1,
        worldCopyJump: !1
      }).setView([0, 0], 2);
      we.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
        maxZoom: 19,
        noWrap: !0
      }).addTo(O), d.current = O;
      const V = new ResizeObserver(() => {
        O.invalidateSize(), E(O);
      });
      V.observe(b), _.current = V, P(!0);
    };
    let C = null;
    return typeof IntersectionObserver < "u" ? (C = new IntersectionObserver(
      (O) => {
        O.some((V) => V.isIntersecting) && (M(), C?.disconnect(), C = null);
      },
      { rootMargin: "200px" }
    ), C.observe(b)) : M(), () => {
      C?.disconnect(), _.current?.disconnect(), _.current = null, d.current?.remove(), d.current = null;
    };
  }, []), xt(() => {
    const b = d.current;
    if (!b) return;
    const M = Xr(o), C = new Set(M.map((O) => O.id));
    f.current.forEach((O, V) => {
      C.has(V) || (O.remove(), f.current.delete(V));
    });
    for (const O of M) {
      const V = O.latitude, j = O.longitude, rt = f.current.get(O.id);
      if (rt) {
        rt.setLatLng([V, j]);
        continue;
      }
      const et = we.marker([V, j], { icon: Jr(O.id === i) }).addTo(b);
      et.bindPopup(`<span class="locator__popup-name">${Ac(O.name)}</span>`), et.on("click", () => s(O.id)), f.current.set(O.id, et);
    }
    E(b);
  }, [o, s, g]), xt(() => {
    f.current.forEach((b, M) => b.setIcon(Jr(M === i))), i && f.current.get(i)?.openPopup();
  }, [i, g]);
  const k = (u ?? []).map((b) => `${b.latitude},${b.longitude}`).join("|");
  return xt(() => {
    const b = d.current;
    !b || !u || u.length === 0 || b.fitBounds(
      we.latLngBounds(u.map((M) => [M.latitude, M.longitude])),
      { padding: [40, 40], maxZoom: 13 }
    );
  }, [k, g]), xt(() => {
    u && u.length > 0 || d.current && l && d.current.panTo([l.latitude, l.longitude]);
  }, [i, l?.latitude, l?.longitude, g]), /* @__PURE__ */ y("div", { class: "locator__map", ref: c });
}
function Ec(o) {
  return o.mapApiKey?.trim() ? /* @__PURE__ */ y(bc, { ...o }) : /* @__PURE__ */ y(Cc, { ...o });
}
const Qr = 4;
function ts(o, i) {
  return o.includes(i) ? o.filter((s) => s !== i) : [...o, i];
}
function Sc({
  loadIndex: o,
  mapApiKey: i,
  mapId: s,
  visitorCountry: l,
  resolveReference: u,
  resolveInstaller: c,
  geocode: d,
  radiusKm: _ = 15
}) {
  const {
    index: f,
    status: g,
    reason: P,
    reload: m
  } = Bl(o), [x, T] = _t(""), [E, k] = _t([]), [b, M] = _t([]), [C, O] = _t(null), [V, j] = _t(!1), [rt, et] = _t(!1), [pt, dt] = _t(null), [mt, st] = _t(null), [bt, ie] = _t(!1), { point: Lt, status: oe, request: gt } = zl(u), { suggestions: Bt } = Ul(d?.search, C ? "" : x), B = te(
    () => C ? { latitude: C.latitude, longitude: C.longitude } : Lt,
    [C, Lt]
  ), { results: kt, textMatched: N, selectedId: K, selected: it, select: lt, toggle: Z } = Nl(f, {
    referencePoint: B,
    // A committed address is not a text filter.
    query: C ? "" : x,
    services: E,
    vehicleTypes: b,
    radiusKm: _,
    // A searched place filters by its own extent when the geocoder reports one;
    // the radius is only for a point with no extent, or the buyer's location.
    bounds: C?.bounds ?? null,
    country: C?.countryName ?? null
  }), z = te(() => Tl(f), [f]), S = Dl(c, K);
  xt(() => {
    j(!1), dt(null), st(null), ie(!1);
  }, [B, x, E, b]);
  const U = te(
    () => B ? kt : bl(kt, fr(l?.name, l?.isoCode)),
    [kt, B, l?.name, l?.isoCode]
  ), D = te(() => {
    if (pt) {
      const X = new Set(pt), ot = U.filter((St) => X.has(St.id));
      return ot.length > 0 ? ot : U;
    }
    if (mt) {
      const X = U.filter((ot) => ys(mt, ot));
      return X.length > 0 ? X : U;
    }
    return U;
  }, [U, pt, mt]), H = pt != null || mt != null, tt = !H && !V && D.length > Qr, Mt = tt ? D.slice(0, Qr) : D, Et = pt ? D : U;
  xt(() => {
    !K || V || Mt.some((X) => X.id === K) || j(!0);
  }, [K]), xt(() => {
    K && !it && lt(null);
  }, [K, it, lt]);
  const zt = Ct(
    (X) => k((ot) => ot.filter((St) => St !== X)),
    []
  ), Zt = Ct(
    (X) => M((ot) => ot.filter((St) => St !== X)),
    []
  ), Rt = Ct(() => {
    k([]), M([]);
  }, []), $t = Ct((X) => k((ot) => ts(ot, X)), []), Kt = Ct((X) => M((ot) => ts(ot, X)), []), re = Ct((X) => {
    O(null), T(X);
  }, []), Pe = J(0), an = Ct(
    (X) => {
      if (!d) return;
      const ot = ++Pe.current;
      T(X.label), d.resolve(X).then((St) => {
        if (ot === Pe.current) {
          if (!St) {
            console.warn("[installer-locator] could not resolve the selected place");
            return;
          }
          O(St), T("");
        }
      });
    },
    [d]
  ), Re = Ct((X) => st(X), []), ln = Ct(() => {
    dt(null), ie(!0);
  }, []), un = Ct(
    (X) => {
      dt(X), lt(null);
    },
    [lt]
  ), Qn = Ct(() => {
    O(null), T("");
  }, []), ti = Ct(() => {
    O(null), gt();
  }, [gt]), se = (X) => X.filter((ot) => ot.latitude != null && ot.longitude != null).map((ot) => ({ latitude: ot.latitude, longitude: ot.longitude })), Be = te(() => {
    const X = fr(l?.name, l?.isoCode);
    if (X.length === 0) return [];
    const ot = new Set(X);
    return U.filter((St) => ot.has(eo(St.country)));
  }, [U, l?.name, l?.isoCode]), cn = K ? null : pt ? se(D) : C ? [{ latitude: C.latitude, longitude: C.longitude }, ...se(Et)] : mt || bt ? null : Be.length > 0 ? se(Be) : rt ? se(Mt) : null, ei = it && it.latitude != null && it.longitude != null ? { latitude: it.latitude, longitude: it.longitude } : B, hn = C ? ` · near ${C.label}` : Lt ? " · near you" : "", dn = C ? C.label : x;
  return /* @__PURE__ */ y(
    "div",
    {
      class: `locator ${tt ? "" : "locator--capped"} ${rt ? "locator--map-open" : ""}`,
      children: [
        /* @__PURE__ */ y("header", { class: "locator__header", children: [
          /* @__PURE__ */ y("div", { class: "locator__controls", children: [
            /* @__PURE__ */ y(
              Kl,
              {
                value: dn,
                onChange: re,
                onClear: Qn,
                selectOnFocus: C != null,
                placeholder: "Search by location",
                suggestions: Bt,
                onSelectSuggestion: an
              }
            ),
            /* @__PURE__ */ y(Yl, { status: oe, onRequest: ti })
          ] }),
          /* @__PURE__ */ y(
            Jl,
            {
              serviceOptions: z.services,
              vehicleTypeOptions: z.vehicleTypes,
              selectedServices: E,
              selectedVehicleTypes: b,
              onToggleService: $t,
              onToggleVehicleType: Kt
            }
          ),
          /* @__PURE__ */ y(
            Xl,
            {
              services: E,
              vehicleTypes: b,
              onRemoveService: zt,
              onRemoveVehicleType: Zt,
              onClearAll: Rt
            }
          ),
          /* @__PURE__ */ y("p", { class: "locator__count", children: g === "ready" ? (
            // A query that matched nothing falls back to the nearby set so a
            // half-typed address does not dead-end the list. Say so, rather
            // than reporting the whole directory as if it were the result —
            // that is what made a failed search look like a broken filter.
            N ? H ? (
              // Keep the total in view: the subset alone read as though the
              // directory had shrunk to whatever was on screen.
              `${kt.length} ${kt.length === 1 ? "dealer" : "dealers"} found · ${D.length} in this area`
            ) : `${kt.length} ${kt.length === 1 ? "dealer" : "dealers"} found${hn}` : (
              // Not "all": the fallback has already had facets, place and
              // radius applied, so it is not the whole directory.
              `No dealers match “${x.trim()}” · showing ${kt.length} instead`
            )
          ) : g === "loading" ? "Loading dealers…" : "Dealers unavailable" })
        ] }),
        /* @__PURE__ */ y("div", { class: "locator__body", children: [
          /* @__PURE__ */ y("aside", { class: "locator__panel", children: [
            g === "loading" ? /* @__PURE__ */ y("p", { class: "locator__card-loading", children: "Loading dealers…" }) : g === "error" ? (
              // Never render a partially consistent index (index-shard-contract §3);
              // the hook already refetched once before we get here.
              /* @__PURE__ */ y("div", { class: "locator__empty", children: [
                /* @__PURE__ */ y("p", { children: "Dealer list couldn’t be loaded." }),
                /* @__PURE__ */ y("button", { type: "button", class: "locator__btn locator__btn--ghost", onClick: m, children: "Try again" }),
                /* @__PURE__ */ y("p", { class: "locator__empty-reason", children: [
                  "Reason: ",
                  P
                ] })
              ] })
            ) : kt.length === 0 ? /* @__PURE__ */ y("p", { class: "locator__empty", children: f.length === 0 ? "No dealers available." : C ? C.countryName || C.bounds ? `No dealers in ${C.label}.` : `No dealers within ${_} km of ${C.label}.` : Lt ? (
              // Geolocation also applies the radius, so say so rather
              // than blaming filters the visitor may not have set.
              `No dealers within ${_} km of your location.`
            ) : "No dealers match your filters." }) : /* @__PURE__ */ y(
              _u,
              {
                installers: Mt,
                selectedId: K,
                onSelectInstaller: Z,
                detail: S.installer,
                detailStatus: S.status,
                detailForId: S.forId
              }
            ),
            tt && /* @__PURE__ */ y(
              "button",
              {
                type: "button",
                class: "locator__more",
                onClick: () => j(!0),
                children: "Show more dealers"
              }
            )
          ] }),
          /* @__PURE__ */ y(
            "button",
            {
              type: "button",
              class: "locator__mapswitch",
              onClick: () => et((X) => !X),
              children: [
                rt ? /* @__PURE__ */ y($l, {}) : /* @__PURE__ */ y(Vl, {}),
                rt ? "View as list" : "View on map"
              ]
            }
          ),
          /* @__PURE__ */ y(
            tu,
            {
              entry: it,
              detail: S.installer,
              detailStatus: S.status,
              detailForId: S.forId
            }
          ),
          /* @__PURE__ */ y(
            Ec,
            {
              installers: Et,
              selectedId: K,
              onSelectInstaller: lt,
              onSelectCluster: un,
              clustered: pt == null,
              onViewportChange: Re,
              onUserMove: ln,
              center: ei,
              fitBounds: cn,
              mapApiKey: i,
              mapId: s
            }
          )
        ] })
      ]
    }
  );
}
const Ic = () => new Promise((o) => {
  if (!("geolocation" in navigator)) {
    o(null);
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (i) => o({ latitude: i.coords.latitude, longitude: i.coords.longitude }),
    () => o(null),
    { timeout: 5e3 }
  );
});
function Oc(o) {
  const i = o?.trim();
  if (!i) return;
  let s = null, l = /* @__PURE__ */ new Map();
  return { search: async (c) => {
    try {
      const d = await ro(i);
      if (!d?.Geocoder) return [];
      s ??= new d.Geocoder();
      const { results: _ } = await s.geocode({ address: c }), f = _.slice(0, 6).map(zc).filter(Zc);
      return l = new Map(f.map((g) => [g.id, g])), f;
    } catch (d) {
      const _ = d?.code;
      return _ && _ !== "ZERO_RESULTS" && console.warn("[installer-locator] Google geocode failed:", _), [];
    }
  }, resolve: async (c) => l.get(c.id) ?? null };
}
function zc(o) {
  const i = o.geometry?.location, s = o.geometry?.viewport, l = o.types?.includes("country") ? o.address_components?.find((u) => u.types.includes("country"))?.long_name : void 0;
  return {
    id: o.place_id ?? o.formatted_address ?? "",
    label: o.formatted_address ?? "",
    latitude: i ? i.lat() : Number.NaN,
    longitude: i ? i.lng() : Number.NaN,
    // The viewport is what makes a country or a city filter by its own extent
    // instead of an arbitrary radius (see applyInstallerFilters).
    bounds: s ? {
      south: s.getSouthWest().lat(),
      west: s.getSouthWest().lng(),
      north: s.getNorthEast().lat(),
      east: s.getNorthEast().lng()
    } : void 0,
    // Only when the result IS a country, not merely located in one.
    countryName: l
  };
}
const Zc = (o) => o.id !== "" && o.label !== "" && Number.isFinite(o.latitude) && Number.isFinite(o.longitude);
function Rc(o, i) {
  const s = o?.trim();
  if (!s) return;
  let l;
  async function u() {
    if (l !== void 0) return l ?? i;
    const c = await ro(s);
    return !c?.AutocompleteSuggestion || !c.AutocompleteSessionToken ? (console.info("[installer-locator] Places (New) unavailable; address search uses geocoding"), l = null, i) : (l = Bc(c.AutocompleteSuggestion, c.AutocompleteSessionToken), l);
  }
  return {
    search: async (c) => (await u())?.search(c) ?? [],
    resolve: async (c) => (await u())?.resolve(c) ?? null
  };
}
function Bc(o, i) {
  let s = null, l = /* @__PURE__ */ new Map();
  return {
    async search(u) {
      try {
        s ??= new i();
        const { suggestions: c } = await o.fetchAutocompleteSuggestions({
          input: u,
          sessionToken: s
        });
        l = /* @__PURE__ */ new Map();
        const d = [];
        for (const _ of c) {
          const f = _.placePrediction;
          f?.placeId && (l.set(f.placeId, f), d.push({ id: f.placeId, label: f.text?.toString() ?? "" }));
        }
        return d.filter((_) => _.label !== "").slice(0, 6);
      } catch (c) {
        return console.warn("[installer-locator] Places autocomplete failed:", c), [];
      }
    },
    async resolve(u) {
      const c = l.get(u.id);
      if (!c) return null;
      try {
        const d = c.toPlace();
        await d.fetchFields({
          fields: ["location", "viewport", "formattedAddress", "addressComponents", "types"]
        }), s = null, l = /* @__PURE__ */ new Map();
        const _ = d.location;
        return _ ? {
          id: u.id,
          label: d.formattedAddress ?? u.label,
          latitude: _.lat(),
          longitude: _.lng(),
          bounds: Nc(d.viewport),
          // Only when the place IS a country, not merely located in one — the
          // filter matches country by name, which beats a bounding box that for
          // the United States spans -180..180 because of Pacific territories.
          countryName: d.types?.includes("country") ? d.addressComponents?.find((f) => f.types.includes("country"))?.longText ?? void 0 : void 0
        } : null;
      } catch (d) {
        return console.warn("[installer-locator] Place details failed:", d), s = null, null;
      }
    }
  };
}
const Nc = (o) => o ? {
  south: o.getSouthWest().lat(),
  west: o.getSouthWest().lng(),
  north: o.getNorthEast().lat(),
  east: o.getNorthEast().lng()
} : void 0;
function Dc() {
  let o = /* @__PURE__ */ new Map();
  return { search: async (s) => {
    try {
      const l = await fetch(
        `https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&limit=6&q=${encodeURIComponent(s)}`,
        { headers: { Accept: "application/json" } }
      );
      if (!l.ok)
        return console.warn("[installer-locator] OSM geocode returned", l.status), [];
      const c = (await l.json()).map((d) => {
        const _ = d.boundingbox?.map(Number);
        return {
          id: String(d.place_id ?? d.display_name ?? ""),
          label: String(d.display_name ?? ""),
          latitude: Number(d.lat),
          longitude: Number(d.lon),
          // Nominatim orders it [south, north, west, east].
          bounds: _ && _.length === 4 && _.every(Number.isFinite) ? { south: _[0], north: _[1], west: _[2], east: _[3] } : void 0,
          // Only when the result IS a country, not merely located in one.
          countryName: d.addresstype === "country" ? d.address?.country : void 0
        };
      }).filter(
        (d) => d.id !== "" && d.label !== "" && Number.isFinite(d.latitude) && Number.isFinite(d.longitude)
      );
      return o = new Map(c.map((d) => [d.id, d])), c;
    } catch {
      return [];
    }
  }, resolve: async (s) => o.get(s.id) ?? null };
}
const Kn = "[data-link-installer-locator]", Fc = "2026-04", Yn = /* @__PURE__ */ new Set();
function Hc(o, i, s) {
  const l = s?.trim().replace(/^https?:\/\//, "").replace(/\/+$/, ""), u = l ? `https://${l}/api/${i}/graphql.json` : `/api/${i}/graphql.json`;
  return async (c, d) => {
    const _ = await fetch(u, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": o
      },
      body: JSON.stringify({ query: c, variables: d })
    });
    if (!_.ok) throw new Error(`Storefront API ${_.status}`);
    const f = await _.json();
    if (f.errors?.length) throw new Error(f.errors[0].message);
    if (!f.data) throw new Error("Storefront API returned no data");
    return f.data;
  };
}
function Uc(o) {
  const i = o.dataset.mapApiKey, s = Oc(i), l = Rc(i, s);
  if (l) return l;
  const u = o.dataset.openMapFallback;
  return u !== void 0 && u !== "false" ? Dc() : void 0;
}
function Vi(o) {
  ds(null, o), Yn.delete(o);
}
function es(o) {
  if (Yn.has(o)) return;
  const i = o.dataset.storefrontToken;
  if (!i) {
    console.error("[installer-locator] missing data-storefront-token — cannot load installers");
    return;
  }
  const s = Hc(
    i,
    o.dataset.apiVersion ?? Fc,
    o.dataset.shopDomain
  ), l = o.dataset.indexType || vs, u = o.dataset.installerType || gs, c = vl(l);
  try {
    ds(
      /* @__PURE__ */ y(
        Sc,
        {
          loadIndex: () => s(c),
          resolveInstaller: async (d) => ul(
            ml(
              await s(
                fl,
                _l(d, u)
              )
            )
          ),
          mapApiKey: o.dataset.mapApiKey ?? "",
          mapId: o.dataset.mapId,
          visitorCountry: {
            name: o.dataset.visitorCountry,
            isoCode: o.dataset.visitorCountryCode
          },
          resolveReference: Ic,
          geocode: Uc(o)
        }
      ),
      o
    ), Yn.add(o);
  } catch (d) {
    console.error("[installer-locator] mount failed", d);
  }
}
function Wc() {
  Yn.forEach((o) => {
    o.isConnected || Vi(o);
  });
}
function $i(o) {
  Wc(), o.querySelectorAll(Kn).forEach(es), o instanceof HTMLElement && o.matches(Kn) && es(o);
}
function qc(o) {
  o.querySelectorAll(Kn).forEach(Vi), o instanceof HTMLElement && o.matches(Kn) && Vi(o);
}
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => $i(document)) : $i(document);
document.addEventListener("shopify:section:load", (o) => {
  o.target instanceof HTMLElement && $i(o.target);
});
document.addEventListener("shopify:section:unload", (o) => {
  o.target instanceof HTMLElement && qc(o.target);
});
